var tilXwordPuzzles;
class TilXword {
  constructor(puzzleSpec, containerId = '', customizer = null, visTop = 0, maxDim = 0, notTemp = true, isMobile, isPrime, isFrmapp, overlayCall, gameAPICall, puzzleAPI, todaysGame, hardPause, type, apiConfigData, temp, fireGa, viewSolution) {
    this.isMobile = isMobile;
    this.isPrime = isPrime;
    this.isFrmapp = isFrmapp;
    this.overlayCall = overlayCall;
    this.hardPause = hardPause;
    this.type = type;
    this.configPenalty = apiConfigData?.penaltyTimeForCharRevealInSec || 5;
    this.configSaveStateCounter = apiConfigData?.saveStateTimerValueInSec || 30;
    this.fireGa = fireGa;
    this.gameAPICall = gameAPICall;
    this.id = puzzleAPI && puzzleAPI.gameId ? puzzleAPI.gameId : '';
    this.puzzleText = puzzleSpec;
    this.todaysGame = todaysGame;
    this.containerId = containerId;
    this.customizer = customizer;
    this.notTemp = notTemp;
    this.tempSetup = temp;
    this.gridWidth = 0;
    this.gridHeight = 0;
    this.layers3d = 1;
    this.h3dLayer = 0;
    this.angle3d = 55;
    this.skew3d = `skewX(${this.angle3d - 90}deg)`;
    this.offset3d = 0;
    this.ratio3d = 0.75;
    if(this.type !=='crossword'){
      this.cellW = this.isMobile ? 60 : 100;
      this.cellH = this.isMobile ? 60 : 100;
    }else{
      this.cellW = this.isMobile ? 35 : 50;
      this.cellH = this.isMobile ? 35 : 50;
    }
    this.squareDim = 0;
    this.topClueClearance = 0;
    this.questionTexts = [];
    this.forcedSeps = {'force-hyphen-right': [], 'force-hyphen-below': [], 'force-bar-right': [], 'force-bar-below': []};
    this.colourfuls = [];
    this.grid = [];
    this.clues = {};
    this.hasDgmlessCells = false;
    this.hasUnsolvedCells = false;
    this.hasReveals = false;
    this.hasAcrossClues = false;
    this.hasDownClues = false;
    this.hasZ3dClues = false;
    this.hasNodirClues = false;
    this.reversals = {};
    this.usedReversals = {};
    this.nextNonNumId = 1;
    this.offNumClueIndices = {};
    this.cellsToOrphan = {};
    this.szCellsToOrphan = 0;
    this.visTop = visTop;
    this.maxDim = maxDim;
    this.cluesBoxWidth = 0;
    this.MAX_GRID_SIZE = 300;
    this.GRIDLINE = 1;
    this.BAR_WIDTH = 3;
    this.BAR_WIDTH_BY2 = 2;
    this.SEP_WIDTH = 2;
    this.SEP_WIDTH_BY2 = 1.5;
    this.NUMBER_START_X = 2;
    this.MAX_REBUS_SIZE = 20;
    this.answersList = [];
    this.revelationList = [];
    this.inClueAnnoReveals = {};
    this.currRow = -1;
    this.currCol = -1;
    this.currDir = 'A';
    this.currClueIndex = null;
    this.usingGnav = false;
    this.lastOrphan = null;
    this.activeCells = [];
    this.activeClues = [];
    this.cellLightToggleTimer = null;
    this.cellNotLight = false;
    this.multiLetter = false;
    this.multiLetterCellRow = -1;
    this.multiLetterCellCol = -1;
    this.lastKeyHadShift = false;
    this.numCellsToFill = 0;
    this.numCellsFilled = 0;
    this.numCellsPrefilled = 0;
    this.knownCorrect = false;
    this.knownIncorrect = false;
    this.allClueIndices = [];
    this.PLACEHOLDER_BLANK_LEN = 15;
    this.BLOCK_CHAR = '⬛';
    this.SPECIAL_STATE_CHARS = {
      '0': String.fromCharCode(1),
      '1': String.fromCharCode(2),
      '.': String.fromCharCode(3),
      '?': String.fromCharCode(4),
    };
    this.SPECIAL_DISPLAY_CHARS = {};
    for (let x in this.SPECIAL_STATE_CHARS) {
      this.SPECIAL_DISPLAY_CHARS[this.SPECIAL_STATE_CHARS[x]] = x;
    }
    this.scriptRE = null;
    this.scriptLowerCaseRE = null;
    this.fontFamily = '';
    this.fontSize = '';
    this.smartColoring = true;
    this.lightColorScheme = {
      active: '#EBEBD3',
      'active-clue': '#FCAB64',
      anno: 'darkgreen',
      hint: 'dodgerblue',
      'hint-bulb': 'dodgerblue',
      arrow: 'white',
      background: '#1E1D4B',
      button: '#4caf50',
      'button-hover': 'darkgreen',
      'button-text': 'white',
      caret: 'gray',
      cell: 'white',
      circle: 'gray',
      'circle-input': 'gray',
      currclue: 'white',
      'def-underline': '#3eb0ff',
      'imp-text': 'darkgreen',
      input: '#FCAB64',
      'light-label': '#1E1D4B',
      'light-label-input': '#1E1D4B',
      'light-text': '#1E1D4B',
      'light-text-input': '#1E1D4B',
      orphan: 'linen',
      'overwritten-end': '#bb00bb',
      'overwritten-start': '#ff00ff',
      prefill: 'blue',
      separator: 'blue',
      'small-button': 'inherit',
      'small-button-hover': 'lightpink',
      'small-button-text': 'darkgreen',
      solution: 'dodgerblue',
      solved: 'dodgerblue',
      errorEntry: '#E21B22',
      correctEntry: '#519561'
    };
    this.darkColorScheme = {
      ...this.lightColorScheme,
      currclue: '#1E1D4B',
      'active-clue': '#663366',
      orphan: '#663300',
      anno: 'lightgreen',
      'imp-text': 'lightgreen',
      'small-button-hover': '#330066',
      'small-button-text': 'lightgreen',
    };
    this.colorScheme = this.lightColorScheme;
    this.nextLine = 0;
    this.sectionLines = {};
    this.STATE_SEP = 'til';
    this.extractionSlots = 0;
    this.hideInferredNumbers = false;
    this.cluesPanelLines = -1;
    this.allowChars = null;
    this.hideCopyPlaceholders = false;
    this.addSolutionToAnno = true;
    this.offsetLeft = 0;
    this.offsetTop = 0;
    this.language = '';
    this.languageScript = '';
    this.langMaxCharCodes = 1;
    this.hasRebusCells = false;
    this.ignoreUnclued = false;
    this.ignoreEnumMismatch = false;
    this.showCellLevelButtons = false;
    this.printCompleted3Cols = false;
    this.printIncomplete2Cols = false;
    this.hltOverwrittenMillis = 5000;
    this.revelCellsList = [];
    this.timeTaken = 0;
    this.timePenalty = 0;
    this.pause = false;
    this.stopTimeCounter = '';
    this.revelAllPenalty = 0;
    this.lastFocussedCell = {row:0, column:0, dir: this.currDir};
    this.autoSuggestEnabled = false;
    this.viewSolution = viewSolution;
    this.createPuzzle();
  }

  destroy() {
    if (this.frame) {
      this.frame.innerHTML = '';
      this.frame = null;
    }
    if (tilXwordPuzzles && this.id && tilXwordPuzzles[this.id]) {
      delete tilXwordPuzzles[this.id];
    }
    if (this.windowListeners) {
      for (let e in this.windowListeners) {
        window.removeEventListener(e, this.windowListeners[e]);
      }
      this.windowListeners = {};
    }
  }

  init() {
    this.parseOverall();
    this.computeGridSize(this.maxDim);
    if (!tilXwordPuzzles) {
      tilXwordPuzzles = {};
      tilXwordPuzzles['tilspecialid'] = 1;
    }
    this.index = tilXwordPuzzles['tilspecialid']++;
    this.prefix = 'til' + this.index;

    const basicHTML = `
  <div class="til-frame til-flex-col" tabindex="-1" id="${this.prefix}-frame">
    <div id="${this.prefix}-timeBlock" class="timeBlock ${this.showCongrate ? 'disabled' : ''} " style="display: ${this.showCongrate ? 'none' : ''}">
      <div class="left">
        <strong id="${this.prefix}-clock-num-filled">0</strong>
      </div>
      <div class="right">
      ${this.isMobile ? `
      <div class="actionWrap">
          <div class="circle" id="${this.prefix}-hard-pause"><i class="icon pause"></i></div>
          <div class="circle" id="${this.prefix}-how-to-play" ><i class="icon question"></i></div>
          <div class="circle disabled" id="${this.prefix}-revealcell">
            <i class="icon reveal"></i> 
            <span id="${this.prefix}-plusPoint" class="plusPoint" style="opacity: .5">+${this.configPenalty} Sec</span>
          </div>
          <div class="circle" id="${this.prefix}-menu-circle"><i class="icon dots"></i>
            <ul class="menuList" id="${this.prefix}-menu-list">
              <li id="${this.prefix}-revel-char">
                <div class="iconWrap">
                  <i class="icon revealCharacter"></i>
                </div>
                <span>Reveal Character *</span>
              </li>
              <li id="${this.prefix}-reveal-all">
                <div class="iconWrap">
                  <i class="icon revealPuzzle"></i>
                </div>
                <span>Reveal Puzzle *</span>
              </li>
              <li id="${this.prefix}-reset">
                <div class="iconWrap">
                  <i class="icon reset"></i>
                </div>
                <span>Reset Puzzle</span>
              </li>
              <li id="${this.prefix}-how-to-play-dot">
                <div class="iconWrap">
                  <i class="icon question"></i>
                </div>
                <span>How to Play?</span>
              </li>
            </ul>
          </div>
        </div>
      ` : ''}
      ${!this.isMobile ? `
      <div class="actionWrap">
          <div class="circle" id="${this.prefix}-hard-pause"><i class="icon pause" ></i></div>
          <div class="circle disabled" id="${this.prefix}-revealcell">
              <i class="icon reveal"></i> 
              <span id="${this.prefix}-plusPoint" class="plusPoint" style="opacity: .5">+${this.configPenalty} Sec</span>
            </div>
          <div class="circle" id="${this.prefix}-reveal-all"><i class="icon revealPuzzle"></i></div>
          <div class="circle" id="${this.prefix}-reset"><i class="icon reset" ></i></div>
          <div class="circle" id="${this.prefix}-how-to-play"><i class="icon question" ></i></div>
        </div>
        ` : ''}
      </div>
    </div>
    <div id="${this.prefix}-grid-and-clues" class="til-grid-and-clues-flex">
      <div id="${this.prefix}-grid-panel" class="til-grid-panel">
        <div id="${this.prefix}-grid-parent-centerer" class="til-grid-parent-centerer">
        ${(this.isMobile && !this.viewSolution) || this.viewSolution ? `
          <div id="${this.prefix}-curr-clue" class="til-curr-clue" style="display:none">
            <div id="${this.prefix}-curr-clue-inner" class="til-curr-clue-inner"></div>
          </div>
          ` : ''}
          <div id="${this.prefix}-grid-parent" class="til-grid-parent">
            <svg id="${this.prefix}-grid" class="til-grid disabled" zoomAndPan="disable"></svg>
            <div id="${this.prefix}-grid-input-wrapper" class="til-grid-input-wrapper" style="display:none;left:0;top:0">
            ${this.isMobile ? `
              <input id="${this.prefix}-grid-input" type="text" autocomplete="off" spellcheck="false" class="til-grid-input til-cell-text" readonly />
              ` : 
              `<input id="${this.prefix}-grid-input" type="text" autocomplete="off" spellcheck="false" class="til-grid-input til-cell-text" />`
            } 
            </div>
            <div id="${this.prefix}-colour-group" style="display:none;left:0;top:0"></div>
          </div>
        </div>
        ${!this.viewSolution ? `
        <div id="${this.prefix}-controls-etc" class="til-controls-etc">
          <div id="${this.prefix}-controls" class="til-controls til-wide-box">
            <div id="${this.prefix}-buttons-extra-row" class="til-controls-row">
            ${!this.showCongrate ? ` 
              <div class="gameSubmitArea">
              <div class="autoCheck">
                  <label for="${this.prefix}-autocheckbtn">
                    Auto Check
                    <input
                      id="${this.prefix}-autocheckbtn"
                      type="checkbox"
                    />
                    <i class="tickIcon"></i>
                  </label>
                  <div class="toolTipInfo">
                    <i class="info"></i>
                    <div class="toolTipContent">
                      Get instant feedback as you type. Correct letters are locked, incorrect ones are highlighted.
                    </div>
                  </div>
                </div>
                <div class="submitWrap">
                  <button id="${this.prefix}-submit" class="til-button til-submitBtn">Submit</button>
                </div>
                  
                <div class="noteArea">
                  <strong>Note:</strong>
                  <ul>
                    <li>Revealing every character adds an incremental time penalty</li>
                    <li>Revealing puzzle adds a cumulative incremental penalty for all the blank and incorrectly filled cells</li>
                  </ul>
                </div>
              </div>  
               ` : ''} 
            </div>
          </div>
        </div>` : ''}
      </div>

      ${!this.isMobile && !this.viewSolution ? `
        <div>
        <div id="${this.prefix}-clues" class="til-clues til-clues-flex">
          <div class="til-clues-panel" style="display:none">
            <div id="${this.prefix}-across-label" class="til-clues-box til-clues-label">
              <hr/>
              ${this.layers3d > 1 ? 'Across & Back' : 'Across'}
            </div>
            <div id="${this.prefix}-across-clues-panel" class="til-clues-box">
              <table id="${this.prefix}-across" class="til-clues-table"></table>
            </div>
          </div>
          <div class="til-clues-panel" style="display:none">
            <div id="${this.prefix}-down-label" class="til-clues-box til-clues-label">
              <hr/>
              ${this.layers3d > 1 ? 'Away & Towards' : 'Down'}
            </div>
            <div id="${this.prefix}-down-clues-panel" class="til-clues-box">
              <table id="${this.prefix}-down" class="til-clues-table"></table>
            </div>
          </div>
          <div class="til-clues-panel" style="display:none">
            <div id="${this.prefix}-z3d-label" class="til-clues-box til-clues-label">
              <hr/>
              Down & Up
            </div>
            <div id="${this.prefix}-z3d-clues-panel" class="til-clues-box">
              <table id="${this.prefix}-z3d" class="til-clues-table"></table>
            </div>
          </div>
          <div class="til-clues-panel" style="display:none">
            <div id="${this.prefix}-nodir-label" class="til-clues-box til-clues-label">
              <hr/>
            </div>
            <div id="${this.prefix}-nodir-clues-panel" class="til-clues-box">
              <table id="${this.prefix}-nodir" class="til-clues-table"></table>
            </div>
          </div>
        </div> <!-- til-clues -->
        </div>
      ` : ''}
      

    </div> <!-- til-grid-and-clues-flex -->
  </div> <!-- til-frame -->
`;


    if (document.getElementById(this.prefix + '-frame')) {
      this.log('Element with id ' + this.prefix + 'frame already exists');
    }

    const tilXwordHolder = document.getElementById(this.containerId);
    if (tilXwordHolder) {
      if (this.containerId == 'tilXword') {
        tilXwordHolder.id = 'tilXword' + this.index;
      }
      tilXwordHolder.innerHTML = basicHTML;
    }
    this.frame = document.getElementById(this.prefix + '-frame');
    if (this.fontFamily) {
      this.frame.style.fontFamily = this.fontFamily;
    }
    if (this.fontSize) {
      this.frame.style.fontSize = this.fontSize;
    }
    this.pickColorScheme();
    this.controlsEtc = document.getElementById(this.prefix + '-controls-etc');
    this.gridPanel = document.getElementById(this.prefix + '-grid-panel');
    this.svg = document.getElementById(this.prefix + '-grid');
    this.gridInputWrapper = document.getElementById(this.prefix + '-grid-input-wrapper');
    this.gridInputWrapper.style.width = '' + this.cellW + 'px';
    this.gridInputWrapper.style.height = '' + (this.cellH - 2) + 'px';
    this.gridInputWrapper.insertAdjacentHTML('beforeend',
      `<div id="${this.prefix}-grid-input-rarr" class="til-grid-input-rarr">&rtrif;</div>
       <div id="${this.prefix}-grid-input-larr" class="til-grid-input-larr">&ltrif;</div>
       <div id="${this.prefix}-grid-input-darr" class="til-grid-input-darr">&dtrif;</div>
       <div id="${this.prefix}-grid-input-uarr" class="til-grid-input-uarr">&utrif;</div>`
    );
    this.gridInputRarr = document.getElementById( this.prefix + '-grid-input-rarr' );
    this.gridInputDarr = document.getElementById( this.prefix + '-grid-input-darr' );
    this.gridInputLarr = document.getElementById(this.prefix + '-grid-input-larr');
    this.gridInputUarr = document.getElementById(this.prefix + '-grid-input-uarr');
    for (let e of [
      this.gridInputRarr,
      this.gridInputDarr,
      this.gridInputLarr,
      this.gridInputUarr,
    ]) {
      e.style.color = this.colorScheme['arrow'];
      e.style.fontSize = this.arrowSize + 'px';
    }
    if (this.hasRebusCells) {
      this.gridInputRarr.className = 'til-grid-input-darr';
      this.gridInputLarr.className = 'til-grid-input-uarr';
    }

    this.gridInput = document.getElementById(this.prefix + '-grid-input');
    this.gridInput.style.caretColor = this.colorScheme['caret'];

    this.acrossPanel = document.getElementById(
      this.prefix + '-across-clues-panel'
    );
    this.downPanel = document.getElementById(this.prefix + '-down-clues-panel');
    this.z3dPanel = document.getElementById(this.prefix + '-z3d-clues-panel');
    this.nodirPanel = document.getElementById(this.prefix + '-nodir-clues-panel');
    this.acrossClues = document.getElementById(this.prefix + '-across');
    this.downClues = document.getElementById(this.prefix + '-down');
    this.z3dClues = document.getElementById(this.prefix + '-z3d');
    this.nodirClues = document.getElementById(this.prefix + '-nodir');
    this.gridcluesContainer = document.getElementById(this.prefix + '-grid-and-clues');
    this.clearArea = document.getElementById(this.prefix + '-clear-area');
    this.gridParent = document.getElementById(this.prefix + '-grid-parent');
    this.currClue = document.getElementById(this.prefix + '-curr-clue');
    this.currClueInner = document.getElementById(this.prefix + '-curr-clue-inner');
    this.colourGroup = document.getElementById(this.prefix + '-colour-group');
    this.buttonRow1 = document.getElementById(this.prefix + '-button-row-1');
    this.buttonRow2 = document.getElementById(this.prefix + '-button-row-2');
    this.revealcellButton = document.getElementById(this.prefix + '-revealcell');
    this.revealcellButton ? this.revealcellButton.addEventListener('click', this.revealCellConfirmation.bind(this)) : '';
    this.revealcharButton = document.getElementById(this.prefix + '-revel-char');
    this.revealcharButton ? this.revealcharButton.addEventListener('click', this.revealCellConfirmation.bind(this)) : '';
    this.howtoPlayButton = document.getElementById(this.prefix + '-how-to-play');
    this.howtoPlayButton? this.howtoPlayButton.addEventListener('click', this.howtoPlay.bind(this)) : '';
    this.hardPauseEle = document.getElementById(this.prefix + '-hard-pause');
    this.hardPauseEle? this.hardPauseEle.addEventListener('click', this.hardPauseCall.bind(this)) : '';
    
    this.howtoPlayDotButton = document.getElementById(this.prefix + '-how-to-play-dot');
    this.howtoPlayDotButton ? this.howtoPlayDotButton.addEventListener('click', this.howtoPlay.bind(this)) : '';
    this.revealAllButton = document.getElementById(this.prefix + '-reveal-all');
    this.revealAllButton ? this.revealAllButton.addEventListener('click',this.revealAllHandler.bind(this)) : '';
    this.submitButtonWrapper = document.getElementById(this.prefix + '-buttons-extra-row');
    this.submitButton = document.getElementById(this.prefix + '-submit');
    this.submitButton ? this.submitButton.addEventListener('click', this.submitSolution.bind(this)) : '';
    this.menuList = document.getElementById(this.prefix + '-menu-list');
    this.menuCircle = document.getElementById(this.prefix + '-menu-circle');
    this.menuCircle ? this.menuCircle.addEventListener('click', this.menuListHandler.bind(this)) : '';
    this.resetButton = document.getElementById(this.prefix + '-reset');
    this.resetButton ? this.resetButton.addEventListener('click', this.resetCall.bind(this)) : '';

    this.autoSuggestButton = document.getElementById(this.prefix + '-autocheckbtn');
    if (this.autoSuggestButton) {
      this.autoSuggestButton.addEventListener('change', this.handleAutoSuggestClick.bind(this));
    }


    this.CURR_PLACEHOLDER_BLANK_ID = this.prefix + '-curr-blank';
    if(!this.tempSetup){
      this.boundManageTimer = this.manageTimer.bind(this);
      document.addEventListener("visibilitychange", this.boundManageTimer);
    }

    document.querySelectorAll('#til_crossword_keyboard button').forEach(button => {
      button.removeEventListener('click', this.keyBoardCall);
      button.addEventListener('click', this.keyBoardCall);
    });

    this.showCongrate ? this.overlayCall = () => {} : '';
    
    if (this.language) {
      this.frame.lang = this.language;
      this.gridInput.lang = this.language;
    }
    const maxlen = this.hasRebusCells
      ? this.MAX_REBUS_SIZE
      : 2 * this.langMaxCharCodes;
    this.gridInput.maxLength = '' + maxlen;

  }

  log(msg) {
    console.log('Crossword Puzzle #' + this.index + ' [' + this.id + ']: ' + msg);
  }

  parseOverall() {
    this.specLines = []; 
    let rawLines = this.puzzleText.trim().split('\n');
    for (let rawLine of rawLines) {
      let cIndex = rawLine.indexOf('#');
    
      while (cIndex >= 0 &&
        cIndex + 1 < rawLine.length &&
        rawLine.charAt(cIndex + 1) != ' ') {
        cIndex = rawLine.indexOf('#', cIndex + 1);
      }
      if (cIndex >= 0) {rawLine = rawLine.substr(0, cIndex).trim();
      } else {rawLine = rawLine.trim();}
      if (!rawLine) {continue;}
      this.specLines.push(rawLine);
    }
    this.numLines = this.specLines.length;
    let parsedSec = this.parseSection();
    while (parsedSec && parsedSec.section != 'end') {
      let firstLine = this.nextLine;
      let nextParsedSec = this.parseSection();
      let lastLine = this.nextLine - 2;
      this.sectionLines[parsedSec.section] = [firstLine, lastLine];
      if (parsedSec.section == 'begin') {
      } else if (parsedSec.section == 'id') {
        this.id = parsedSec.value.trim();
      } else if (parsedSec.section == 'width') {
        this.gridWidth = parseInt(parsedSec.value);
      } else if (parsedSec.section == 'height') {
        this.gridHeight = parseInt(parsedSec.value);
      } else if (parsedSec.section == '3d') {
        this.parse3d(parsedSec.value);
      } else if (parsedSec.section == 'cell-size') {
        const cellParts = parsedSec.value.split(' ');
        if (cellParts.length != 2) {
          this.log('tilXword-cell-size: must have "<width> <height>"');
        }
        this.cellW = parseInt(cellParts[0]);
        this.cellH = parseInt(cellParts[1]);
        if (this.cellW <= 9 || this.cellH <= 9) {
          this.log('tilXword-cell-size: <width>, <height> must be >= 10');
        }
      } else if (parsedSec.section == 'force-hyphen-right' ||
        parsedSec.section == 'force-hyphen-below' ||
        parsedSec.section == 'force-bar-right' ||
        parsedSec.section == 'force-bar-below') {
        this.parseForcedSep(parsedSec.value, parsedSec.section);
      } else if (parsedSec.section == 'question') {
        this.questionTexts.push(parsedSec.value);
      } else if (parsedSec.section == 'nodir') {
        this.nodirHeading = parsedSec.value;
      } else if (parsedSec.section == 'reversals') {
        this.parseReversals(parsedSec.value);
      } else if (parsedSec.section == 'option') {
        this.parseOption(parsedSec.value);
      } else if (parsedSec.section == 'language') {
        this.parseLanguage(parsedSec.value);
      }
      parsedSec = nextParsedSec;
    }
    this.multiLetter = this.hasRebusCells || this.langMaxCharCodes > 1;
    this.dirOrder = {};
    this.dirOrder['A'] = (this.sectionLines[this.layers3d > 1 ? '3d-across' : 'across'] || [0])[0];
    this.dirOrder['D'] = (this.sectionLines[this.layers3d > 1 ? '3d-away' : 'down'] || [0])[0];
    this.dirOrder['Z'] = (this.sectionLines['3d-down'] || [0])[0];
    this.dirOrder['X'] = (this.sectionLines['nodir'] || [0])[0];
  }
  colonSplit(s) {
    let index = s.indexOf(':');
    if (index < 0) {
      index = s.length;
    }
    return {
      section: s
        .substr(0, index)
        .trim()
        .toLowerCase(),
      value: s.substr(index + 1).trim(),
    };
  }

  manageTimer() {
    try {
      if (typeof localStorage !== 'undefined' && !this.tempSetup) {
        const storedValue = localStorage.getItem('toigames');
        const parsedValue = storedValue ? JSON.parse(storedValue) : '';
        const howtoplayCrossword = parsedValue ? parsedValue.howtoplay : '';
        if (howtoplayCrossword) {
          if (document.visibilityState === 'hidden') {
              this.hardPauseCall()
              this.pause = true;
          } else if (document.visibilityState === 'visible') {
              this.pause = false;
          }
        }
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  }

  parseSection() {
    const MARKER = 'tilXword-';
    while (this.nextLine < this.numLines &&
      this.specLines[this.nextLine].trim().indexOf(MARKER) != 0) {
      this.nextLine++;
    }
    if (this.nextLine >= this.numLines) {
      return null;
    }
    const line = this.specLines[this.nextLine].trim().substr(MARKER.length);
    this.nextLine++;
    return this.colonSplit(line);
  }
  clueLabelDisp(clue) {
    let suff = '';
    if (clue.dir == 'A') {
      if (clue.reversed) {
        suff =
          this.layers3d > 1
            ? 'ba'
            : 'ba';
      } else {
        suff =
          this.layers3d > 1
            ? 'ac'
            : 'a';
      }
    } else if (clue.dir == 'D') {
      if (clue.reversed) {
        suff =
          this.layers3d > 1
            ? 'to'
            : 'u';
      } else {
        suff =
          this.layers3d > 1
            ? 'aw'
            : 'd';
      }
    } else if (clue.dir == 'Z') {
      suff = clue.reversed ? 'up' : 'dn';
    } else {
      return clue.label;
    }
    return '' + clue.label + suff;
  }
  isColour(s) {
    const e = new Option().style;
    e.color = s;
    return e.color !== '';
  }
  reversalKey(cells) {
    return JSON.stringify([cells[0], cells[cells.length - 1]]);
  }
  parseReversals(s) {
    const parts = s.split(' ');
    for (let p of parts) {
      const cells = p.split('-');
      if (!cells || cells.length != 2) {
        this.log('Empty/incomplete reversal specified in: ' + p);
      }
      const start = this.parseCellLocation(cells[0]);
      const end = this.parseCellLocation(cells[1]);
      if (!start || !end) {
        this.log('Unparseable reversal specified in: ' + p);
      }
      this.reversals[this.reversalKey([start, end])] = p;
    }
  }
  parseForcedSep(s, section) {
    let parsedCells = s.split(' ');
    for (let c of parsedCells) {
      if (!c) {
        continue;
      }
      let cellLocation = this.parseCellLocation(c);
      if (!cellLocation) {
        continue;
      }
      this.forcedSeps[section].push(cellLocation);
    }
  }
  answerListener(answer, forceUpper) {
    this.deactivateCurrCell();
    this.deactivateCurrClue();
    this.usingGnav = false;
    let cursor = answer.selectionStart;
    if (forceUpper) {
      answer.value = answer.value.toUpperCase().trimLeft();
    } else {
      answer.value = answer.value.trimLeft();
    }
    answer.selectionEnd = cursor;
    this.updateAndSaveState();
  }

  parseOption(s) {
    let sparts = s.split(' ');
    for (let spart of sparts) {
      spart = spart.trim();
      if (spart == 'show-cell-level-buttons') {
        this.showCellLevelButtons = true;
        continue;
      }
      if (spart == 'hide-inferred-numbers') {
        this.hideInferredNumbers = true;
        continue;
      }
      if (spart == 'hide-copy-placeholder-buttons') {
        this.hideCopyPlaceholders = true;
        continue;
      }
      if (spart == 'no-auto-solution-in-anno') {
        this.addSolutionToAnno = false;
        continue;
      }
      if (spart == 'no-smart-coloring' || spart == 'no-smart-colouring') {
        this.smartColoring = false;
        continue;
      }
      if (spart == 'columnar-layout') {
        /* Deprecated. */
        continue;
      }
      if (spart == 'clues-at-right-in-two-columns') {
        /* Deprecated, we always try to position clues to the right now. */
        continue;
      }
      if (spart == 'print-incomplete-2cols') {
        this.printIncomplete2Cols = true;
        continue;
      }
      if (spart == 'print-completed-3cols') {
        this.printCompleted3Cols = true;
        continue;
      }
      if (spart == 'rebus-cells') {
        this.hasRebusCells = true;
        continue;
      }
      if (spart == 'ignore-unclued') {
        this.ignoreUnclued = true;
        continue;
      }
      if (spart == 'ignore-enum-mismatch') {
        this.ignoreEnumMismatch = true;
        continue;
      }
      if (spart == 'allow-digits') {
        spart = 'allow-chars:0123456789';
      }
      if (spart == 'add-extraction-slots') {
        spart = 'add-extraction-slots:1';
      }
      const colon = spart.indexOf(':');
      if (colon < 0) {
        this.log('Expected Crossword Option: key:value, got: ' + spart);
      }
      const kv = [spart.substr(0, colon).trim(), spart.substr(colon + 1).trim()];

      if (kv[0] == 'add-extraction-slots') {
        this.extractionSlots = parseInt(kv[1]);
        if (isNaN(this.extractionSlots) || this.extractionSlots <= 0) {
          this.log('Unexpected val in Crossword Option: add-extraction-slots: ' + kv[1]);
        }
        continue;
      }
      if (kv[0] == 'clues-panel-lines') {
        this.cluesPanelLines = parseInt(kv[1]);
        if (isNaN(this.cluesPanelLines) || this.cluesPanelLines <= 0) {
          this.log('Unexpected val in Crossword Option: clue-panel-lines: ' + kv[1]);
        }
        continue;
      }
      if (kv[0] == 'highlight-overwritten-seconds') {
        const secs = parseFloat(kv[1]);
        if (isNaN(secs) || secs < 0) {
          this.log('Unexpected val in Crossword Option: highlight-overwritten-seconds: ' + kv[1]);
        }
        this.hltOverwrittenMillis = secs * 1000;
        continue;
      }
      if (kv[0] == 'offset-left') {
        this.offsetLeft = parseInt(kv[1]);
        if (isNaN(this.offsetLeft)) {this.log('Unexpected val in Crossword Option: offset-left: ' + kv[1]);}
        continue;
      }
      if (kv[0] == 'offset-top') {
        this.offsetTop = parseInt(kv[1]);
        if (isNaN(this.offsetTop)) {
          this.log('Unexpected val in Crossword Option: offset-top: ' + kv[1]);
        }
        continue;
      }
      if (kv[0] == 'grid-background') {
        /** Deprecated and ignored. */
        continue;
      }
      if (kv[0] == 'font-family') {
        this.fontFamily = kv[1];
        continue;
      }
      if (kv[0] == 'font-size') {
        this.fontSize = kv[1];
        continue;
      }
      if (kv[0] == 'top-clue-clearance') {
        this.topClueClearance = parseInt(kv[1]);
        if (isNaN(this.topClueClearance) || this.topClueClearance < 0) {
          this.log('Unexpected val in Crossword Option: top-clue-clearance: ' + kv[1]);
        }
        continue;
      }
      if (kv[0].substr(0, 6) == 'color-' || kv[0].substr(0, 7) == 'colour-') {
        let cSchemes = [this.lightColorScheme, this.darkColorScheme];
        let key = kv[0].substr(kv[0].indexOf('-') + 1);
        if (key.startsWith('dark.')) {
          cSchemes = [this.darkColorScheme];
          key = key.substr(5);
        } else if (key.startsWith('light.')) {
          cSchemes = [this.lightColorScheme];
          key = key.substr(6);
        }
        if (!this.isColour(kv[1])) {
          this.log('Invalid colour for ' + key + ': ' + kv[1]);
        }
        for (const cs of cSchemes) {
          if (!cs[key]) {
            this.log('Unsupported coloring option: ' + kv[0]);
          }
          cs[key] = kv[1];
        }
        continue;
      }
      if (kv[0].substr(0, 16) == 'override-number-') {
        const key = kv[0].substr(16);
        if (!this.hasOwnProperty(key)) {
          this.log('Invalid TilXword property: ' + key);
        }
        if (typeof this[key] !== 'number') {
          this.log('Non-numeric TilXword property: ' + key);
        }
        const val = parseFloat(kv[1]);
        this[key] = val;
        continue;
      }
      if (kv[0] == 'allow-chars') {
        if (!this.allowChars) this.allowChars = {};
        for (c of kv[1]) {
          if (/\s/.test(c)) continue;
          this.allowChars[c] = true;
          if (this.SPECIAL_STATE_CHARS.hasOwnProperty(c)) {
            this.allowChars[this.SPECIAL_STATE_CHARS[c]] = true;
          }
        }
        continue;
      }
      this.log('Unexpected Crossword Option: ' + spart);
    }
  }
  parseLanguage(s) {
    const parts = s.trim().split(' ');
    if (parts.length < 2) {
      this.log('Usage: tilXword-language: ' + s + 'cannot be parsed ' + 'as "language-code Script [max-char-codes]"');
    }
    this.language = parts[0];
    this.languageScript = parts[1];
    try {
      this.scriptRE = new RegExp(
        '^\\p{Script=' + this.languageScript + '}+$',
        'u'
      );
      this.scriptLowerCaseRE = new RegExp('^\\p{Lowercase}+$', 'u');
    } catch (err) {
      this.log( 'Your browser ' + '<a href="#"' + ">does not support Unicode property escapes</a> OR you've provided " + 'an invalid Script name: ' + this.languageScript);
    }
    if (this.languageScript.toLowerCase() == 'devanagari') { this.langMaxCharCodes = 5;}
    if (parts.length > 2) {
      this.langMaxCharCodes = parseInt(parts[2]);
      if (isNaN(this.langMaxCharCodes) || this.langMaxCharCodes < 1) {
        this.log('invalid max-char-codes in tilXword-language: ' + parts[2]);
      }
    }
  }
  extractSectionLines(start, end) {
    let text = '';
    if (start > 0) {
      const markerLine = this.specLines[start - 1].trim();
      if (markerLine.startsWith('tilXword-')) {
        const colon = markerLine.indexOf(':');
        if (colon >= 0) {
          text = markerLine.substr(colon + 1).trim();
        }
      }
    }
    let l = start;
    while (l <= end) {
      if (text) text += '\n';
      text += this.specLines[l];
      l++;
    }
    return text.trim();
  }

  parseAndDisplayPrelude() {
    const lines = this.sectionLines['prelude'] || [-1, -1];
    if (lines[0] < 0) {
      return;
    }
  }

  checkConsistency() {
    if (this.gridWidth < 1 ||
      this.gridWidth > this.MAX_GRID_SIZE ||
      this.gridHeight < 1 ||
      this.gridHeight > this.MAX_GRID_SIZE) {
      this.log('Bad/missing width/height');
    }
    if (this.layers3d <= 0 || this.gridHeight % this.layers3d != 0) {
      this.log( 'The number of 3-D layers (' + this.layers3d + ') must be a positive divisor of height (' + this.gridHeight +')');
    }
    if (this.layers3d > 1 && this.hasDgmlessCells) {
      this.log( 'Diagramless cells are (currently) not allowed in 3-D crosswords');
    }
    if (this.layers3d > 1) {
      if (this.sectionLines['across'] || this.sectionLines['down']) {
        this.log('Use 3d-across/3d-away/3d-down sections in 3-D ' +'crosswords, not across/down');
      }
    } else {
      if (this.sectionLines['3d-across'] ||
        this.sectionLines['3d-down'] ||
        this.sectionLines['3d-away']) {
        this.log('Cannot use 3d-across/3d-away/3d-down sections in ' + 'non 3-D crosswords, not across/down');
      }
    }
    let noClueList = '';
    for (let ci of Object.keys(this.clues)) {
      const clue = this.clues[ci];
      const cname = this.clueLabelDisp(clue);
      if (clue.parentClueIndex) {
        continue;
      }
      if (!clue.clue) {
        if (noClueList) noClueList += ', ';
        noClueList += cname;
      }
      const cells = this.getAllCells(ci);
      const lightLen = cells.length;
      if (!this.ignoreEnumMismatch &&
        !this.hasDgmlessCells &&
        clue.enumLen > 0 &&
        lightLen > 0 &&
        clue.enumLen != lightLen &&
        (!cells.endsOnStart || clue.enumLen != lightLen + 1)) {
      }
    }

    if (this.hasRebusCells && this.langMaxCharCodes > 1) {
      this.log('Sorry, no rebus cells when the language has max-char-codes > 1.');
    }
    if (this.hasRebusCells && this.hasDgmlessCells) {
      this.log('Sorry, no rebus cells when there are diagramless cells.');
    }
  }
  caseCheck(c) {
    if (c.length > 1 && (this.hasRebusCells || this.langMaxCharCodes > 1)) {
      for (const letter of c) {
        if (!this.caseCheck(letter)) {
          return false;
        }
      }
      return true;
    }
    if (this.scriptRE) {
      if (this.scriptRE.test(c)) {
        return !this.scriptLowerCaseRE.test(c);
      }
    } else {
      if (c >= 'A' && c <= 'Z') {
        return true;
      }
    }
    return false;
  }

  isValidDisplayChar(c) {
    if (this.caseCheck(c)) {
      return true;
    }
    if (c == this.BLOCK_CHAR) {
      return true;
    }
    if (this.allowChars && this.allowChars[c]) {
      return true;
    }
    return false;
  }
  isValidStateChar(c) {
    if (this.caseCheck(c)) {
      return true;
    }
    if (this.allowChars &&
      this.allowChars[c] &&
      !this.SPECIAL_STATE_CHARS.hasOwnProperty(c)) {
      return true;
    }
    if (c == '0') {
      return true;
    }
    if (this.hasDgmlessCells && c == '1') {
      return true;
    }
    return false;
  }
  isValidGridChar(c) {
    return this.isValidStateChar(c) || c == '?';
  }
  stateToDisplayChar(c) {
    if (c == '0' || c == '?') {
      return '';
    }
    if (c == '1') {
      return this.BLOCK_CHAR;
    }
    if (this.SPECIAL_DISPLAY_CHARS.hasOwnProperty(c)) {
      return this.SPECIAL_DISPLAY_CHARS[c];
    }
    if (this.hasRebusCells && c.length > 1) {
      let out = '';
      for (const letter of c) {
        out += this.stateToDisplayChar(letter);
      }
      return out;
    }
    return c;
  }
  displayToStateChar(c) {
    if (c == this.BLOCK_CHAR) {
      return '1';
    }
    if (this.SPECIAL_STATE_CHARS.hasOwnProperty(c)) {
      return this.SPECIAL_STATE_CHARS[c];
    }
    if (!this.isValidDisplayChar(c)) {
      return '0';
    }
    if (this.hasRebusCells && c.length > 1) {
      let out = '';
      for (const letter of c) {
        out += this.displayToStateChar(letter);
      }
      return out;
    }
    return c;
  }
  newGridCell(row, col, letter, escaped = false) {
    let cell = {};
    cell.row = row;
    cell.col = col;
    cell.currLetter = '?';
    let is_special = false;
    if (!escaped && (letter == '?' || letter == '.' || letter == '0')) {
      cell.solution = letter;
      is_special = true;
    } else {
      cell.solution = this.displayToStateChar(letter.toUpperCase());
    }
    cell.isLight = false;
    if (cell.solution != '.') {
      if (!is_special && !this.isValidStateChar(cell.solution)) {
        this.log('Bad grid entry at ' + row + ',' + col + ':' + letter);
      }
      cell.isLight = true;
    }
    cell.prefill = false;
    cell.isDgmless = false;

    cell.hasBarAfter = false;
    cell.hasBarUnder = false;
    cell.hasCircle = false;
    return cell;
  }

  parseGrid() {
    let allEntriesAre0s = true;
    const DECORATORS = ' +|_@!*~';
    const reDecorators = new RegExp('[' + DECORATORS + ']');
    const reNextChar = new RegExp('[.0&' + DECORATORS + ']');

    const lines = this.sectionLines['grid'] || [-1, -1];
    const gridFirstLine = lines[0];
    const gridLastLine = lines[1];
    if (gridFirstLine < 0 ||
      gridFirstLine > gridLastLine ||
      this.gridHeight != gridLastLine - gridFirstLine + 1) {
      this.log('Not the right number of lines (' + this.gridHeight +') in or missing tilXword-grid section');
    }
    this.grid = new Array(this.gridHeight);
    for (let i = 0; i < this.gridHeight; i++) {
      this.grid[i] = new Array(this.gridWidth);
      let gridLine = this.specLines[i + gridFirstLine].trim().toUpperCase();
      if (!this.multiLetter) {
        gridLine = gridLine.replace(/\s/g, '');
      } else {
        gridLine = gridLine.replace(/\s+/g, ' ');
      }
      let gridLineIndex = 0;
      for (let j = 0; j < this.gridWidth; j++) {
        if (gridLineIndex >= gridLine.length) {
          let errmsg = 'Too few letters in the grid at row,col: ' + i + ',' + j;
          if (this.multiLetter) {
            errmsg = errmsg + '. Note that grid letters must be separated by spaces or decorators for languages that have compound characters or if there are rebus cells';
          }
          this.log(errmsg);
        }
        let letter = gridLine.charAt(gridLineIndex++);
        let escaped = false;
        if (letter == '&') {
          letter = gridLine.charAt(gridLineIndex++);
          escaped = true;
        }
        if (this.multiLetter && letter != '.' && letter != '0') {
          let next = gridLineIndex;
          while (next < gridLine.length &&
            !reNextChar.test(gridLine.charAt(next))) {
            next++;
          }
          letter = letter + gridLine.substring(gridLineIndex, next).trim();
          gridLineIndex = next;
        }
        this.grid[i][j] = this.newGridCell(i, j, letter, escaped);
        let gridCell = this.grid[i][j];
        let thisChar = '';
        while (gridLineIndex < gridLine.length &&
          (thisChar = gridLine.charAt(gridLineIndex)) &&
          reDecorators.test(thisChar)) {
          if (thisChar == '|') {
            gridCell.hasBarAfter = true;
          } else if (thisChar == '_') {
            gridCell.hasBarUnder = true;
          } else if (thisChar == '+') {
            gridCell.hasBarAfter = true;
            gridCell.hasBarUnder = true;
          } else if (thisChar == '@') {
            gridCell.hasCircle = true;
          } else if (thisChar == '*') {
            gridCell.isDgmless = true;
          } else if (thisChar == '!') {
            gridCell.prefill = true;
          } else if (thisChar == '~') {
            gridCell.skipNum = true;
          } else if (thisChar == ' ') {
          } else {
            this.log('Should not happen! thisChar = ' + thisChar);
          }
          gridLineIndex++;
        }
        if (gridCell.isLight && gridCell.solution != '0' && !gridCell.prefill) {
          allEntriesAre0s = false;
        }
      }
    }
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        let gridCell = this.grid[i][j];
        if (gridCell.isLight) {
          let saved = gridCell.solution;
          if (gridCell.solution == '0') {
            if (allEntriesAre0s && !gridCell.prefill) {
              this.hasUnsolvedCells = true;
            } else {
              gridCell.solution = this.SPECIAL_STATE_CHARS['0'];
            }
          }
          if (!this.isValidGridChar(gridCell.solution)) {
            this.log('Invalid grid entry[' + i + '][' + j + ']: ' + saved);
          }
        }
        if (gridCell.isDgmless && gridCell.solution == '.') {
          gridCell.solution = '1';
        }
        if (gridCell.prefill && !gridCell.isLight) {
          this.log('Pre-filled cell (' + i + ',' + j + ') not in a light: ');
        }
        if (gridCell.isDgmless) {
          this.hasDgmlessCells = true;
        }
      }
    }
    if (this.hasDgmlessCells) {
      this.hideCopyPlaceholders = true;
    }
    if (this.layers3d > 1) {
      for (let l = 1; l < this.layers3d; l++) {
        const i = l * this.h3dLayer - 1;
        for (let j = 0; j < this.gridWidth; j++) {
          this.grid[i][j].hasBarUnder = true;
        }
      }
    }
  }
  parse3d(s) {
    const parts = s.split(' ');
    if (parts.length == 0) {
      this.log('tilXword-3d: must be followed by #layers');
    }
    this.layers3d = parseInt(parts[0]);
    if (parts.length > 1) {
      this.angle3d = parseFloat(parts[1]);
    }
    if (parts.length > 2) {
      this.ratio3d = parseFloat(parts[2]);
    }
    if (isNaN(this.layers3d) ||
      this.layers3d <= 1 ||
      isNaN(this.angle3d) ||
      isNaN(this.ratio3d) ||
      this.layers3d < 1 ||
      this.angle3d < 20 ||
      this.angle3d > 90 ||
      this.ratio3d < 0.4 ||
      this.ratio3d > 1.6) {
      this.log('tilXword-3d: invalid parameters specified');
    }
    this.skew3d = `skewX(${this.angle3d - 90}deg)`;
  }
  startsAcrossClue(i, j) {
    if (!this.grid[i][j].isLight) {
      return null;
    }
    if (j > 0 &&
      this.grid[i][j - 1].isLight &&
      !this.grid[i][j - 1].hasBarAfter) {
      return null;
    }
    if (this.grid[i][j].hasBarAfter) {
      return null;
    }
    if (j == this.gridWidth - 1) {
      return null;
    }
    if (!this.grid[i][j + 1].isLight) {
      return null;
    }
    const cells = [[i, j]];
    for (let jnext = j + 1; jnext < this.gridWidth; jnext++) {
      const gridCell = this.grid[i][jnext];
      if (!gridCell.isLight) break;
      cells.push([i, jnext]);
      if (gridCell.hasBarAfter) break;
    }
    return cells;
  }
  startsDownClue(i, j) {
    if (!this.grid[i][j].isLight) {
      return null;
    }
    if (i > 0 &&
      this.grid[i - 1][j].isLight &&
      !this.grid[i - 1][j].hasBarUnder) {
      return null;
    }
    if (this.grid[i][j].hasBarUnder) {
      return null;
    }
    if (i == this.gridHeight - 1) {
      return null;
    }
    if (!this.grid[i + 1][j].isLight) {
      return null;
    }
    const cells = [[i, j]];
    for (let inext = i + 1; inext < this.gridHeight; inext++) {
      const gridCell = this.grid[inext][j];
      if (!gridCell.isLight) break;
      cells.push([inext, j]);
      if (gridCell.hasBarUnder) break;
    }
    return cells;
  }
  startsZ3dClue(i, j) {
    if (this.layers3d <= 1) return false;
    if (!this.grid[i][j].isLight) {
      return null;
    }
    const l = Math.floor(i / this.h3dLayer);
    if (l == this.layers3d - 1) {
      return null;
    }
    const li = i % this.h3dLayer;
    const iNext = (l + 1) * this.h3dLayer + li;
    if (!this.grid[iNext][j].isLight) {
      return null;
    }
    const iPrev = (l - 1) * this.h3dLayer + li;
    if (iPrev >= 0 && this.grid[iPrev][j].isLight) {
      return null;
    }
    const cells = [[i, j]];
    for (let nextl = l + 1; nextl < this.layers3d; nextl++) {
      const row = nextl * this.h3dLayer + li;
      if (!this.grid[row][j].isLight) {
        break;
      }
      cells.push([row, j]);
    }
    return cells;
  }
  newClue(index) {
    const clue = {};
    clue.index = index;
    clue.dir = index.substr(0, 1);
    clue.label = index.substr(1);
    clue.cells = [];
    clue.clue = '';
    clue.enumLen = 0;
    clue.hyphenAfter = [];
    clue.wordEndAfter = [];
    clue.anno = '';
    clue.linkedOffset = 0;
    clue.reversed = false;
    clue.placeholder = '';
    clue.solution = '';
    return clue;
  }
  maybeReverseLight(cells) {
    const key = this.reversalKey(cells);
    if (!this.reversals[key]) return false;
    cells.reverse();
    this.usedReversals[key] = this.reversals[key];
    delete this.reversals[key];
    return true;
  }
  setCellLightMemberships(clue) {
    if (!clue || !clue.cells || clue.cells.length == 0) {
      return;
    }
    let prev = [];
    for (let c of clue.cells) {
      let gridCell = this.grid[c[0]][c[1]];
      let navDir = clue.dir;
      if (navDir == 'X') {
        if (!gridCell.nodirClues) {
          gridCell.nodirClues = [];
        }
        gridCell.nodirClues.push(clue.index);
        navDir = clue.index;
      } else if (navDir == 'A') {
        gridCell.acrossClueLabel = clue.label;
      } else if (navDir == 'D') {
        gridCell.downClueLabel = clue.label;
      } else if (navDir == 'Z') {
        gridCell.z3dClueLabel = clue.label;
      }
      if (prev.length > 0) {
        this.grid[prev[0]][prev[1]]['succ' + navDir] = {
          cell: c,
          dir: navDir,
        };
        gridCell['pred' + navDir] = {
          cell: prev,
          dir: navDir,
        };
      }
      prev = c;
    }
  }

  markClueStartsUsingGrid() {
    if (this.hasDgmlessCells && this.hasUnsolvedCells) {
      return;
    }

    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        let cells = this.startsAcrossClue(i, j);
        if (cells) {
          const reversed = this.maybeReverseLight(cells);
          const c = cells[0];
          const gridCell = this.grid[c[0]][c[1]];
          gridCell.startsAcrossClue = cells;
          if (reversed) gridCell.revAcrossClue = true;
        }
        cells = this.startsDownClue(i, j);
        if (cells && this.layers3d > 1) {
          cells.reverse();
        }
        if (cells) {
          const reversed = this.maybeReverseLight(cells);
          const c = cells[0];
          const gridCell = this.grid[c[0]][c[1]];
          gridCell.startsDownClue = cells;
          if (reversed) gridCell.revDownClue = true;
        }
        cells = this.startsZ3dClue(i, j);
        if (cells) {
          const reversed = this.maybeReverseLight(cells);
          const c = cells[0];
          const gridCell = this.grid[c[0]][c[1]];
          gridCell.startsZ3dClue = cells;
          if (reversed) gridCell.revZ3dClue = true;
        }
      }
    }

    let nextClueNum = 1;
    let nextSkipNum = 1;
    for (let ii = 0; ii < this.gridHeight; ii++) {
      let i = ii;
      if (this.layers3d > 1) {

        const l = Math.floor(ii / this.h3dLayer);
        const li = this.h3dLayer - 1 - ii % this.h3dLayer;
        i = l * this.h3dLayer + li;
      }
      for (let j = 0; j < this.gridWidth; j++) {
        let gridCell = this.grid[i][j];
        let label = gridCell.skipNum ? '~' + nextSkipNum : '' + nextClueNum;
        if (gridCell.startsAcrossClue) {
          gridCell.startsClueLabel = '' + label;
          const index = 'A' + label;
          const clue = this.newClue(index);
          clue.cells = gridCell.startsAcrossClue;
          if (gridCell.revAcrossClue) {
            clue.reversed = true;
          }
          this.clues[index] = clue;
        }
        if (gridCell.startsDownClue) {
          gridCell.startsClueLabel = '' + label;
          const index = 'D' + label;
          const clue = this.newClue(index);
          clue.cells = gridCell.startsDownClue;
          if (gridCell.revDownClue) {
            clue.reversed = true;
          }
          this.clues[index] = clue;
        }
        if (gridCell.startsZ3dClue) {
          gridCell.startsClueLabel = '' + label;
          const index = 'Z' + label;
          const clue = this.newClue(index);
          clue.cells = gridCell.startsZ3dClue;
          if (gridCell.revZ3dClue) {
            clue.reversed = true;
          }
          this.clues[index] = clue;
        }
        if (gridCell.startsClueLabel) {
          if (gridCell.skipNum) {
            nextSkipNum++;
          } else {
            nextClueNum++;
          }
        } else {
          if (gridCell.skipNum) {
            this.log('Cell ' + i + ',' + j + ' has the "skip number" ' + 'decorator ~ but no clue starts there');
          }
        }
      }
    }
    for (let ci in this.clues) {
      this.setCellLightMemberships(this.clues[ci]);
    }
  }

  adjustAfterEnum(clueLine, afterEnum) {
    let lineAfter = clueLine.substr(afterEnum);
    while (lineAfter.trim().substr(0, 2) == '</') {
      let closer = clueLine.indexOf('>', afterEnum);
      if (closer < 0) {
        return afterEnum;
      }
      afterEnum = closer + 1;
      lineAfter = clueLine.substr(afterEnum);
    }
    return afterEnum;
  }

  parseCellLocation(s) {
    let row = -1;
    let col = -1;
    s = s.trim();
    let spaceAt = s.indexOf(' ');
    if (spaceAt >= 0) {
      s = s.substr(0, spaceAt);
    }
    let matches = s.match(/r(\d+)c(\d+)/);
    if (matches && matches.length == 3) {
      row = this.gridHeight - parseInt(matches[1]);
      col = parseInt(matches[2]) - 1;
    } else {
      matches = s.match(/c(\d+)r(\d+)/);
      if (matches && matches.length == 3) {
        col = parseInt(matches[1]) - 1;
        row = this.gridHeight - parseInt(matches[2]);
      }
    }
    if (row < 0 || col < 0) {
      col = s.charCodeAt(0) - 'a'.charCodeAt(0);
      row = this.gridHeight - parseInt(s.substr(1));
    }
    if (isNaN(row) ||
      isNaN(col) ||
      row < 0 ||
      row >= this.gridHeight ||
      col < 0 ||
      col >= this.gridWidth) {
      return null;
    }
    return [row, col];
  }

  findEnum(clueLine) {
    let candidate = null;
    let start = 0;
    let cluePart = clueLine;
    while (start < clueLine.length) {
      let enumLocation = cluePart.search(/\([1-9]+[0-9\-,\.'’\s]*\)/);
      let numeric = true;
      if (enumLocation < 0 && !candidate) {
        numeric = false;
        enumLocation = cluePart.search(
          /\(([^)]*\s(w[o]?[r]?[d]?[s]?|l[e]?[t]?[t]?[e]?[r]?[s]?)[^)a-z]*|\s*\?\s*)\)/i
        );
      }
      if (enumLocation < 0) {
        break;
      }
      const enumEndLocation = enumLocation + cluePart.substr(enumLocation).indexOf(')');
      console.assert(enumEndLocation >= 0, cluePart);
      candidate = [start + enumLocation, start + enumEndLocation, numeric];
      start += enumEndLocation + 1;
      cluePart = clueLine.substr(start);
      if (cluePart.search(/[ ]*\[.*\]/) == 0) {
        return candidate;
      }
    }
    return candidate;
  }

  parseEnum(clueLine) {
    let parse = {
      enumLen: 0,
      wordEndAfter: [],
      hyphenAfter: [],
      afterClue: clueLine.length,
      afterEnum: clueLine.length,
      dontShow: false,
      placeholder: '',
      enumStr: '',
    };
    const foundEnum = this.findEnum(clueLine);
    if (!foundEnum) {
      return parse;
    }
    const enumLocation = foundEnum[0];
    const enumEndLocation = foundEnum[1];
    const isNumeric = foundEnum[2];
    parse.enumStr = clueLine.substring(enumLocation, enumEndLocation + 1);
    if (clueLine.charAt(enumEndLocation + 1) == '*') {
      parse.afterEnum = enumEndLocation + 2;
      parse.afterClue = enumLocation;
      parse.dontShow = true;
    } else {
      parse.afterEnum = this.adjustAfterEnum(clueLine, enumEndLocation + 1);
      parse.afterClue = parse.afterEnum;
    }
    if (!isNumeric) {
      /* Salvage an enumLen from cases like (6, 2 words) and (5 letters) */
      let k = 0;
      const kLetters = parse.enumStr.match(
        /\(\s*(\d+)\s*l[e]?[t]?[t]?[e]?[r]?[s]?\s*\)/i
      );
      if (kLetters) {
        k = parseInt(kLetters[1], 10);
      }
      const kWords = parse.enumStr.match(
        /\(\s*(\d+)\s*,\s*\d+\s*w[o]?[r]?[d]?[s]?\s*\)/i
      );
      if (kWords) {
        k = parseInt(kWords[1], 10);
      }
      if (!isNaN(k) && k > 0) {
        parse.enumLen = k;
      }
      return parse;
    }
    let enumLeft = clueLine.substring(enumLocation + 1, enumEndLocation);
    let nextPart;
    while (enumLeft &&
      (nextPart = parseInt(enumLeft)) &&
      !isNaN(nextPart) &&
      nextPart > 0) {
      for (let i = 0; i < nextPart; i++) {
        parse.placeholder = parse.placeholder + '?';
      }
      parse.enumLen = parse.enumLen + nextPart;
      enumLeft = enumLeft.replace(/^\s*\d+/, '');
      enumLeft = enumLeft.replace(/^\s+(\d)/, ',$1');
      let nextSymbol = enumLeft.substr(0, 1);
      if (nextSymbol == '-') {
        parse.hyphenAfter.push(parse.enumLen - 1);
        enumLeft = enumLeft.substr(1);
      } else if (nextSymbol == ',') {
        nextSymbol = ' ';
        parse.wordEndAfter.push(parse.enumLen - 1);
        enumLeft = enumLeft.substr(1);
      } else if (nextSymbol == '.') {
        parse.wordEndAfter.push(parse.enumLen - 1);
        enumLeft = enumLeft.substr(1);
      } else if (nextSymbol == "'") {
        enumLeft = enumLeft.substr(1);
      } else if (enumLeft.indexOf('’') == 0) {
        nextSymbol = "'";
        enumLeft = enumLeft.substr('’'.length);
      } else {
        break;
      }
      parse.placeholder = parse.placeholder + nextSymbol;
    }
    return parse;
  }

  parseDir(s, matchSpecial = false) {
    const parse = { dir: '', reversed: false };
    let dirStr = '';
    let skip = 0;
    const lcs = s.toLowerCase();
    if (this.layers3d <= 1) {
      const match = lcs.match(/^[adbu]/);
      const extMatch = lcs.match(/^[a-z]*/);
      if (match && match.length == 1) {
        console.assert(extMatch && extMatch.length == 1, match, extMatch);
        dirStr = match[0];
        if (dirStr == 'a' && 'across'.startsWith(extMatch[0])) {
          parse.dir = 'A';
          skip = extMatch[0].length;
        } else if (dirStr == 'd' &&
          ('down'.startsWith(extMatch[0]) || extMatch[0] == 'dn')) {
          parse.dir = 'D';
          skip = extMatch[0].length;
        } else if (dirStr == 'b' && 'back'.startsWith(extMatch[0])) {
          parse.dir = 'A';
          parse.reversed = true;
          skip = extMatch[0].length;
        } else if (dirStr == 'u' && 'up'.startsWith(extMatch[0])) {
          parse.dir = 'D';
          parse.reversed = true;
          skip = extMatch[0].length;
        }
      } else if (matchSpecial) {
        let specSkip = 0;
        let specDir = '';
        if (lcs.startsWith(' across')) {
          specSkip = 7;
          specDir = 'A';
        } else if (lcs.startsWith(' a')) {
          specSkip = 2;
          specDir = 'A';
        } else if (lcs.startsWith(' ac')) {
          specSkip = 3;
          specDir = 'A';
        } else if (lcs.startsWith(' down')) {
          specSkip = 5;
          specDir = 'D';
        } else if (lcs.startsWith(' d')) {
          specSkip = 2;
          specDir = 'D';
        } else if (lcs.startsWith(' dn')) {
          specSkip = 3;
          specDir = 'D';
        }
        if (specSkip > 0) {
          const suffRE = /^((,[ ]?[0-9])|( [A-Z0-9]))/;
          if (suffRE.test(s.substr(specSkip))) {
            parse.dir = specDir;
            skip = specSkip;
            dirStr = lcs.substr(1, 1);
          }
        }
      }
    } else {
      const match = lcs.match(/^[a-z][a-z]/);
      if (match && match.length == 1) {
        dirStr = match[0].trimLeft();
        skip = match[0].length;
        if (dirStr == 'ac') {
          parse.dir = 'A';
          if (lcs.startsWith('across')) {
            skip = 6;
          }
        } else if (dirStr == 'aw') {
          parse.dir = 'D';
          if (lcs.startsWith('away')) {
            skip = 4;
          }
        } else if (dirStr == 'dn' || dirStr == 'do') {
          parse.dir = 'Z';
          if (lcs.startsWith('down')) {
            skip = 4;
          }
        } else if (dirStr == 'ba') {
          parse.dir = 'A';
          parse.reversed = true;
          if (lcs.startsWith('back')) {
            skip = 4;
          }
        } else if (dirStr == 'to') {
          parse.dir = 'D';
          parse.reversed = true;
          if (lcs.startsWith('towards')) {
            skip = 7;
          } else if (lcs.startsWith('toward')) {
            skip = 6;
          }
        } else if (dirStr == 'up') {
          parse.dir = 'Z';
          parse.reversed = true;
        }
      }
    }
    if (parse.dir) {
      parse.dirStr = dirStr;
      parse.skip = skip;
    }
    return parse;
  }

  parseClueLabel(clueLine,
    consumeTrailing = true,
    isChild = false) {
    let parse = { dir: '', label: '', notLabel: true };
    parse.hasChilden = false;
    parse.linkSep = '';
    parse.skip = 0;
    parse.leadSpace = '';
    const space = clueLine.match(/^\s*/);
    if (space && space.length == 1) {
      parse.skip += space[0].length;
      clueLine = clueLine.substr(space[0].length);
      parse.leadSpace = space[0];
    }

    const prefDir = this.parseDir(clueLine);
    if (prefDir.dir) {
      parse.dir = prefDir.dir;
      parse.dirIsPrefix = true;
      parse.dirStr = prefDir.dirStr;
      parse.reversed = prefDir.reversed;
      parse.skip += prefDir.skip;
      clueLine = clueLine.substr(prefDir.skip);
    }
    const numberParts = clueLine.match(/^\s*[1-9]\d*/);
    let lskip = 0;
    if (numberParts && numberParts.length == 1) {
      let clueNum = parseInt(numberParts[0]);
      parse.label = '' + clueNum;
      parse.isOffNum = false;
      lskip = numberParts[0].length;
    } else {
      if (clueLine.charAt(0) != '[') {
        return parse;
      }
      let bracEnd = clueLine.indexOf(']');
      if (bracEnd < 0) {
        this.log('Missing matching ] in clue label in ' + clueLine);
      }
      parse.label = clueLine.substring(1, bracEnd).trim();
      if (parse.label.charAt(parse.label.length - 1) == '.') {
        parse.label = parse.label.substr(0, parse.label.length - 1).trim();
      }
      parse.isOffNum = true;
      lskip = bracEnd + 1;
    }
    parse.skip += lskip;
    clueLine = clueLine.substr(lskip);

    if (!parse.dir) {
      const suffDir = this.parseDir(clueLine, isChild);
      if (suffDir.dir) {
        parse.dir = suffDir.dir;
        parse.dirStr = suffDir.dirStr;
        parse.reversed = suffDir.reversed;
        parse.skip += suffDir.skip;
        clueLine = clueLine.substr(suffDir.skip);
      }
    }
    parse.notLabel = false;
    if (consumeTrailing) {
      let commaParts = clueLine.match(/^\s*(?:,|(?:and|&|\/)\s*[1-9])/);
      if (commaParts && commaParts.length == 1) {
        parse.hasChildren = true;
        parse.linkSep = commaParts[0].trim();
        let skipLen = commaParts[0].length;
        if (parse.linkSep.startsWith('and') ||
          parse.linkSep.startsWith('/') ||
          parse.linkSep.startsWith('&')) {
          parse.linkSep = parse.linkSep.startsWith('/') ? '/' : '&';
          skipLen--; // One digit was in RE.
        }
        parse.skip += skipLen;
        clueLine = clueLine.substr(skipLen);
      }
      let periodParts = clueLine.match(/^\s*\./);
      if (periodParts && periodParts.length == 1 && !clueLine.match(/^\s*\.\./)) {
        parse.hasChildren = false;
        parse.skip += periodParts[0].length;
        clueLine = clueLine.substr(periodParts[0].length);
      }
    }
    return parse;
  }

  clueFromLabel(s) {
    const parse = this.parseClueLabel(s);
    if (!parse.dir || !parse.label) {
      return null;
    }
    const ci = this.getDirClueIndex(parse.dir, parse.label);
    return this.clues[ci] || null;
  }
  sameCells(cells1, cells2) {
    if ((!cells1 && cells2) || (cells1 && !cells2)) {
      return false;
    }
    if (!cells1 && !cells2) {
      return true;
    }
    if (cells1.length != cells2.length) {
      return false;
    }
    for (let i = 0; i < cells1.length; i++) {
      const c1 = cells1[i];
      const c2 = cells2[i];
      if (c1.length != 2 || c2.length != 2 || c1[0] != c2[0] || c1[1] != c2[1]) {
        return false;
      }
    }
    return true;
  }

  maybeRelocateClue(clueIndex, dir, clue) {
    if (!clue.startCell) {
      return clueIndex;
    }
    if (!(clue.isOffNum && dir != 'X') &&
      !(clue.cells.length > 0 && dir == 'X')) {
      return clueIndex;
    }
    const r = clue.startCell[0];
    const c = clue.startCell[1];
    let gridCell = this.grid[r][c];
    if (!gridCell.startsClueLabel) {
      return clueIndex;
    }
    let replIndex = null;
    let clueAtRepl = null;
    if (dir == 'X') {
      if (gridCell.startsAcrossClue) {
        replIndex = 'A' + gridCell.startsClueLabel;
        clueAtRepl = this.clues[replIndex];
        if (clueAtRepl &&
          !clueAtRepl.clue &&
          this.sameCells(clue.cells, clueAtRepl.cells)) {
          return replIndex;
        }
      }
      if (gridCell.startsDownClue) {
        replIndex = 'D' + gridCell.startsClueLabel;
        clueAtRepl = this.clues[replIndex];
        if (clueAtRepl &&
          !clueAtRepl.clue &&
          this.sameCells(clue.cells, clueAtRepl.cells)) {
          return replIndex;
        }
      }
      if (gridCell.startsZ3dClue) {
        replIndex = 'Z' + gridCell.startsClueLabel;
        clueAtRepl = this.clues[replIndex];
        if (clueAtRepl &&
          !clueAtRepl.clue &&
          this.sameCells(clue.cells, clueAtRepl.cells)) {
          return replIndex;
        }
      }
      return clueIndex;
    }
    if (dir == 'A' && gridCell.startsAcrossClue) {
      replIndex = 'A' + gridCell.startsClueLabel;
    } else if (dir == 'D' && gridCell.startsDownClue) {
      replIndex = 'D' + gridCell.startsClueLabel;
    } else if (dir == 'Z' && gridCell.startsZ3dClue) {
      replIndex = 'Z' + gridCell.startsClueLabel;
    }
    clueAtRepl = this.clues[replIndex];
    if (replIndex &&
      clueAtRepl &&
      !clueAtRepl.clue &&
      clueAtRepl.cells.length > 0) {
      return replIndex;
    }
    return clueIndex;
  }
  parseInClueAnnos(clue) {
    clue.inClueAnnos = [];
    let idx = clue.clue.indexOf('~{');
    let endIdx = 0;
    let clueText = clue.clue;
    while (idx >= 0) {
      endIdx = clueText.indexOf('}~', idx + 1);
      if (endIdx < 0) {
        endIdx = idx;
        break;
      }
      let cls = 'til-definition';
      if (clueText.charAt(idx + 2) == '{') {
        let close = clueText.indexOf('}', idx + 3);
        if (close > idx + 3) {
          let parsedCls = clueText.substring(idx + 3, close).trim();
          if (parsedCls) {
            cls = parsedCls;
          }
        }
      }
      clue.inClueAnnos.push(cls);
      this.hasReveals = true;
      endIdx += 2;
      idx = clueText.indexOf('~{', endIdx);
    }
  }

  parseClue(dir, clueLine) {
    clueLine = clueLine.trim();
    let numCellsGiven = 0;
    let startCell = null;
    let cells = [];
    while (clueLine.indexOf('#') == 0) {
      let cell = this.parseCellLocation(clueLine.substr(1));
      if (!cell) {
        break;
      }
      if (numCellsGiven == 0) {
        startCell = cell;
      }
      clueLine = clueLine.replace(/^#[a-z0-9]*\s*/, '');
      numCellsGiven += 1;
      if (numCellsGiven == 2) {
        cells.push(startCell);
        cells.push(cell);
      } else if (numCellsGiven > 2) {
        cells.push(cell);
      }
    }
    if (cells.length > 0 && dir != 'X') {
      this.log('Cells listed in non-nodir clue: ' + clueLine);
    }

    let clueLabelParse = this.parseClueLabel(clueLine);
    const clue = this.newClue(dir + clueLabelParse.label);

    if (clueLabelParse.notLabel) {
      clue.isFiller = true;
      return clue;
    }
    if (startCell) {
      clue.startCell = startCell;
    }
    if (cells.length > 0) {
      clue.cells = cells;
    }
    if (clueLabelParse.dir && clueLabelParse.dir != dir) {
      this.log('Explicit dir ' + clueLabelParse.dir + ' does not match ' + dir + ' in clue: ' + clueLine );
    }
    clue.label = clueLabelParse.label;
    clue.isOffNum = clueLabelParse.isOffNum;
    let clueIndex = dir + clue.label;
    if (clue.isOffNum) {
      const offNumIndex = dir + '#' + this.nextNonNumId++;
      if (!this.offNumClueIndices[clue.label]) {
        this.offNumClueIndices[clue.label] = [];
      }
      this.offNumClueIndices[clue.label].push(offNumIndex);
      clueIndex = offNumIndex;
    }

    clueIndex = this.maybeRelocateClue(clueIndex, dir, clue);
    clue.index = clueIndex;

    clueLine = clueLine.substr(clueLabelParse.skip);
    clue.linkSep = clueLabelParse.linkSep || '';
    clue.children = [];
    while (clueLabelParse.hasChildren) {
      clueLabelParse = this.parseClueLabel(clueLine, true, true /* isChild */);
      clue.children.push(clueLabelParse);
      clueLine = clueLine.substr(clueLabelParse.skip);
    }

    const enumParse = this.parseEnum(clueLine);
    clue.enumLen = enumParse.enumLen;
    clue.hyphenAfter = enumParse.hyphenAfter;
    clue.wordEndAfter = enumParse.wordEndAfter;
    clue.placeholder = enumParse.placeholder;
    clue.enumStr = enumParse.enumStr;
    clue.clue = clueLine.substr(0, enumParse.afterClue).trim();
    clue.anno = clueLine.substr(enumParse.afterEnum).trim();

    this.setClueCellsDgmless(clue);

    this.parseInClueAnnos(clue);

    return clue;
  }
  setClueCellsDgmless(clue) {
    if (!clue ||
      !clue.startCell ||
      clue.cells.length > 0 ||
      clue.dir == 'X' ||
      !this.hasDgmlessCells ||
      !this.hasUnsolvedCells) {
      return;
    }
    let row = clue.startCell[0];
    let col = clue.startCell[1];
    let gridCell = this.grid[row][col];
    gridCell.startsCluelabel = clue.label;
    if (clue.dir == 'A') {
      gridCell.startsAcrossClue = true;
      let max = clue.enumLen > 0
        ? Math.min(col + clue.enumLen, this.gridWidth)
        : this.gridWidth;
      for (let x = col; x < max; x++) {
        gridCell = this.grid[row][x];
        if (gridCell.isLight && !gridCell.isDgmless) {
          gridCell.acrossClueLabel = clue.label;
          clue.cells.push([row, x]);
          if (gridCell.hasBarAfter) {
            break;
          }
        } else {
          break;
        }
      }
    } else if (clue.dir == 'D') {
      gridCell.startsDownClue = true;
      let max = clue.enumLen > 0
        ? Math.min(row + clue.enumLen, this.gridHeight)
        : this.gridHeight;
      for (let x = row; x < max; x++) {
        gridCell = this.grid[x][col];
        if (gridCell.isLight && !gridCell.isDgmless) {
          gridCell.downClueLabel = clue.label;
          clue.cells.push([x, col]);
          if (gridCell.hasBarUnder) {
            break;
          }
        } else {
          break;
        }
      }
    }
  }

  parseCellsOfOrphan(s) {
    let segments = [];
    let cells = [];
    let cellsOrClues = s.trim().split(' ');
    let lastCell = null;
    for (let cellOrClue of cellsOrClues) {
      if (!cellOrClue) {
        continue;
      }
      let cellLocation = this.parseCellLocation(cellOrClue);
      if (!cellLocation) {
        let theClue = this.clueFromLabel(cellOrClue);
        if (!theClue || theClue.cells.length == 0) {
          return null;
        }
        if (theClue.cells.length > 1) {
          let clueCells = theClue.cells;
          segments.push(clueCells);
          if (lastCell &&
            lastCell[0] == clueCells[0][0] &&
            lastCell[1] == clueCells[0][1]) {
            cells.pop();
          }
          cells = cells.concat(clueCells);
        }
      } else {
        cells.push(cellLocation);
      }
      if (cells.length > 1) {
        lastCell = cells[cells.length - 1];
      }
    }
    return cells.length == 0 ? null : { cells: cells, segments: segments };
  }
  getAllCells(ci) {
    let theClue = this.clues[ci];
    if (!theClue) {
      return [];
    }
    if (theClue.parentClueIndex) {
      return [];
    }
    let clueIndices = this.getLinkedClues(ci);
    let cells = [];
    for (let clueIndex of clueIndices) {
      let chClue = this.clues[clueIndex];
      if (chClue.cellsOfOrphan) {
        for (let rowcol of chClue.cellsOfOrphan) {
          cells.push(rowcol);
        }
      } else {
        for (let i = chClue.linkedOffset; i < chClue.cells.length; i++) {
          cells.push(chClue.cells[i]);
        }
      }
    }
    const last = cells.length - 1;
    if (last > 0 &&
      cells[0][0] == cells[last][0] &&
      cells[0][1] == cells[last][1]) {
      cells.pop();
      cells.endsOnStart = true;
    }
    return cells;
  }

  getCellsEntry(cells, pattern = '') {
    if (!pattern) {
      pattern = '';
      for (let i = 0; i < cells.length; i++) pattern += '?';
    }
    let ppos = 0;
    let entry = '';
    for (let i = 0; i < cells.length; i++) {
      while (ppos < pattern.length && pattern[ppos] != '?') {
        entry += pattern[ppos++];
      }
      if (ppos >= pattern.length) {
        break;
      }
      const cell = cells[i];
      const gridCell = this.grid[cell[0]][cell[1]];
      entry +=
        gridCell.currLetter == '0'
          ? '?'
          : this.stateToDisplayChar(gridCell.currLetter);
      ppos++;
    }
    return entry;
  }
  getClueEntry(ci) {
    const clue = this.clues[ci];
    if (!clue || clue.parentClueIndex) {
      return '';
    }
    const cells = this.getAllCells(ci);
    const pattern = clue.placeholder || '';
    return this.getCellsEntry(cells, pattern);
  }
  setClueSolution(ci) {
    let theClue = this.clues[ci];
    if (!theClue || theClue.solution) {
      return;
    }
    let cells = this.getAllCells(ci);
    if (cells.length == 0) {
      return;
    }
    let solution = '';
    for (let cell of cells) {
      let sol = this.grid[cell[0]][cell[1]].solution;
      let c = sol == '?' ? '?' : this.stateToDisplayChar(sol);
      if (!c) {
        return;
      }
      solution = solution + c;
    }
    if (!solution) {
      return;
    }
    if (theClue.placeholder) {
      let s = '';
      let index = 0;
      for (let i = 0; i < theClue.placeholder.length; i++) {
        if (theClue.placeholder.charAt(i) == '?') {
          if (index >= solution.length) {
            return;
          }
          s = s + solution.charAt(index++);
        } else {
          s = s + theClue.placeholder.charAt(i);
        }
      }
      if (index < solution.length) {
        s = s + solution.substr(index);
      }
      solution = s;
    }
    theClue.solution = solution;
  }
  parseAnno(anno, clueIndex) {
    let theClue = this.clues[clueIndex];
    anno = anno.trim();
    while (anno && anno.substr(0, 1) == '[') {
      let indexOfBrac = anno.indexOf(']');
      if (indexOfBrac <= 0) {
        break;
      }
      let inBrac = anno.substring(1, indexOfBrac).trim();
      let cellsOfOrphan = this.parseCellsOfOrphan(inBrac);
      if (!theClue.cellsOfOrphan &&
        cellsOfOrphan &&
        cellsOfOrphan.cells.length > 0) {
        theClue.cellsOfOrphan = cellsOfOrphan.cells;
        for (let segment of cellsOfOrphan.segments) {
          this.cellsToOrphan[JSON.stringify(segment)] = clueIndex;
          this.szCellsToOrphan++;
        }
      } else if (inBrac && !theClue.solution) {
        theClue.explicitSol = true;
        theClue.solution = inBrac;
      } else if (!inBrac) {
        anno = anno.substr(indexOfBrac + 1).trim();
        break;
      } else {
        break;
      }
      anno = anno.substr(indexOfBrac + 1).trim();
      this.hasReveals = true;
    }
    let numBlanks = 0;
    while (anno && anno.substr(0, 1) == '_') {
      numBlanks++;
      anno = anno.substr(1).trim();
    }
    if (numBlanks > 0) {
      theClue.showBlanks = numBlanks;
      let x = -1;
      if (anno.startsWith('[') && (x = anno.indexOf(']')) >= 1) {
        theClue.placeholderForBlank = anno.substring(1, x);
        anno = anno.substr(x + 1).trim();
      }
    }
    theClue.anno = anno;
  }

  parseClueLists() {
    let prev = null;
    let firstClueIndex = null;
    let lastClueIndex = null;
    const dirs = ['A', 'D', 'Z', 'X'];
    dirs.sort(this.dirCmp.bind(this));
    for (let clueDirection of dirs) {
      let section = '';
      if (clueDirection == 'A') {
        section = this.layers3d > 1 ? '3d-across' : 'across';
      } else if (clueDirection == 'D') {
        section = this.layers3d > 1 ? '3d-away' : 'down';
      } else if (clueDirection == 'Z') {
        section = '3d-down';
      } else {
        section = 'nodir';
      }
      const lines = this.sectionLines[section] || [-1, -1];
      const first = lines[0];
      const last = lines[1];
      if (first < 0 || last < first) {
        continue;
      }
      let filler = '';
      let lastDirClue = null;
      let startNewTable = false;
      let newTableHeading = '';
      for (let l = first; l <= last; l++) {
        let clueLine = this.specLines[l].trim();
        if (clueLine == '') {
          continue;
        }
        if (clueLine.substr(0, 3) == '---') {
          startNewTable = true;
          newTableHeading = clueLine.substr(3).trim();
          continue;
        }
        const clue = this.parseClue(clueDirection, clueLine);
        if (clue.isFiller) {
          filler = filler + clueLine + '\n';
          continue;
        }
        if (!clue.index) {
          this.log('Could not parse clue: ' + clueLine);
        }
        if (this.clues[clue.index] && this.clues[clue.index].clue) {
          this.log('Clue entry already exists for clue: ' + clueLine);
        }
        if (clue.clue.trim() == '*') {
          this.deleteClue(clue.index);
          continue;
        }
        if (!firstClueIndex) {
          firstClueIndex = clue.index;
        }
        lastClueIndex = clue.index;
        lastDirClue = clue;

        let knownInGrid = false;
        if (this.clues[clue.index]) {
          knownInGrid = true;
          let gridClue = this.clues[clue.index];
          if (clue.cells.length > 0) {
            if (gridClue.cells.length > 0) {
              if (!this.sameCells(gridClue.cells, clue.cells)) {
                this.log('Grid, clue diff in cells for ' + clue.index);
              }
            }
          } else {
            clue.cells = gridClue.cells;
          }
          if (clue.dir == 'X' &&
            (gridClue.dir == 'A' || gridClue.dir == 'D' || gridClue.dir == 'Z')) {
            clue.dir = gridClue.dir;
          }
          if (gridClue.reversed) {
            clue.reversed = true;
          }
        }
        this.clues[clue.index] = clue;
        if (clueDirection != clue.dir) {
          clue.clueTableDir = clueDirection;
        }

        if (!knownInGrid && clue.cells.length > 0) {
          this.setCellLightMemberships(clue);
        }

        clue.fullDisplayLabel = this.clueLabelDisp(clue);
        clue.displayLabel = !clue.reversed ? clue.label : clue.fullDisplayLabel;
        clue.childrenClueIndices = [];

        this.parseAnno(clue.anno, clue.index);

        if (clue.startCell) {
          const row = clue.startCell[0];
          const col = clue.startCell[1];
          this.grid[row][col].forcedClueLabel = clue.label;
        }
        clue.prev = prev;
        clue.next = null;
        if (prev) {
          this.clues[prev].next = clue.index;
        }
        prev = clue.index;
        if (filler) {
          clue.filler = filler;
          filler = '';
        }
        if (startNewTable) {
          clue.startNewTable = true;
          clue.newTableHeading = newTableHeading;
          startNewTable = false;
          newTableHeading = '';
        }

        if (clue.clue) {
          this.allClueIndices.push(clue.index);
        }
      }
      if (filler) {
        this.log('Filler line should not be at the end: ' + filler);
      }
    }
    if (firstClueIndex && lastClueIndex) {
      this.clues[firstClueIndex].prev = lastClueIndex;
      this.clues[lastClueIndex].next = firstClueIndex;
    }
    for (let clueIndex of this.allClueIndices) {
      if (!this.clues[clueIndex].parentClueIndex && this.isOrphan(clueIndex)) {
        this.lastOrphan = clueIndex;
        break;
      }
    }
  }
  deleteClue(clueIndex) {
    let dir = clueIndex.substr(0, 1);
    if (dir != 'A' && dir != 'D' && dir != 'Z') {
      this.log('Cannot delete non-A/D/Z clue ' + clueIndex);
    }
    let theClue = this.clues[clueIndex];
    if (theClue.parentClueIndex) {
      this.log('Cannot delete clue ' + clueIndex + ' that has a parent');
    }
    if (theClue.childrenClueIndices && theClue.childrenClueIndices.length > 0) {
      this.log('Cannot delete clue ' + clueIndex + ' with children');
    }
    if (theClue.cells.length == 0) {
      this.log('Cannot delete clue ' + clueIndex + ' with no cells');
    }
    for (let cell of theClue.cells) {
      let gridCell = this.grid[cell[0]][cell[1]];
      if (dir == 'A') {
        delete gridCell.acrossClueLabel;
      } else if (dir == 'D') {
        delete gridCell.downClueLabel;
      } else if (dir == 'Z') {
        delete gridCell.z3dClueLabel;
      }
    }
    delete this.clues[clueIndex];
  }
  isOrphan(clueIndex) {
    let theClue = this.clues[clueIndex];
    return theClue && theClue.cells.length == 0;
  }
  isOrphanWithReveals(clueIndex) {
    return this.isOrphan(clueIndex) && this.clues[clueIndex].cellsOfOrphan;
  }
  allCellsKnown(clueIndex) {
    clueIndex = this.clueOrParentIndex(clueIndex);
    let clue = this.clues[clueIndex];
    if (!clue) {
      return false;
    }
    if (!clue.enumLen) {
      return false;
    }
    const cells = this.getAllCells(clueIndex);
    return cells.length == clue.enumLen;
  }

  processClueChildren() {
    for (let clueIndex of this.allClueIndices) {
      let clue = this.clues[clueIndex];
      if (!clue.children) {
        continue;
      }

      let lastRowCol = null;
      let firstRowCol = null;
      if (clue.cells.length > 0) {
        firstRowCol = clue.cells[0];
        lastRowCol = clue.cells[clue.cells.length - 1];

        if (!clue.enumLen || clue.enumLen <= 0) {
          lastRowCol = null;
        }
      }
      const firstRowColDir = clue.dir;
      let lastRowColDir = clue.dir;
      let dupes = {};
      const allDirections = ['A', 'D', 'Z', 'X'];
      let linkSep = clue.linkSep != ',' ? ' ' + clue.linkSep + ' ' : ', ';
      for (let chi = 0; chi < clue.children.length; chi++) {
        const child = clue.children[chi];
        let childIndex = this.getDirClueIndex(clue.dir, child.label);
        if (!child.isOffNum) {
          if (!this.clues[childIndex]) {
            for (let otherDir of allDirections) {
              if (otherDir == clue.dir) {
                continue;
              }
              const testChildIndex = this.getDirClueIndex(otherDir, child.label);
              if (this.clues[testChildIndex]) {
                childIndex = testChildIndex;
                break;
              }
            }
          }
          if (child.dir) {
            childIndex = this.getDirClueIndex(child.dir, child.label);
          } else {
            child.dir = childIndex.charAt(0);
          }
        } else {
          if (!this.offNumClueIndices[child.label] ||
            this.offNumClueIndices[child.label].length < 1) {
            this.log('non-num child label ' + child.label + ' was not seen');
          }
          childIndex = this.offNumClueIndices[child.label][0];
        }
        let childClue = this.clues[childIndex];
        if (!childClue || childIndex == clueIndex) {
          this.log('Invalid child ' + childIndex + ' in ' + clueIndex);
        }
        if (dupes[childIndex]) {
          this.log(
            'Duplicate child ' + childIndex + ' in ' + clue.label + clue.dir
          );
        }
        dupes[childIndex] = true;
        if (childClue.label) {
          if (!childClue.fullDisplayLabel) {
            childClue.fullDisplayLabel = this.clueLabelDisp(childClue);
          }
          clue.displayLabel =
            clue.displayLabel +
            linkSep +
            (childClue.dir == clue.dir && !childClue.reversed
              ? childClue.label
              : childClue.fullDisplayLabel);
          clue.fullDisplayLabel =
            clue.fullDisplayLabel + linkSep + childClue.fullDisplayLabel;
        }
        linkSep = child.linkSep != ',' ? ' ' + child.linkSep + ' ' : ', ';
        clue.childrenClueIndices.push(childIndex);
        childClue.parentClueIndex = clueIndex;

        if (lastRowCol && childClue.cells.length > 0) {
          let cell = childClue.cells[0];
          let childDir = childClue.dir;
          if (lastRowCol[0] == cell[0] && lastRowCol[1] == cell[1]) {
            if (childDir == lastRowColDir || childClue.cells.length == 1) {
              this.log('loop in successor for ' + lastRowCol);
            }
            childClue.linkedOffset = 1;
            cell = childClue.cells[1]; // Advance to the next cell.
          }
          this.grid[lastRowCol[0]][lastRowCol[1]]['succ' + lastRowColDir] = {
            cell: cell,
            dir: childDir,
          };
          this.grid[cell[0]][cell[1]]['pred' + childDir] = {
            cell: lastRowCol,
            dir: lastRowColDir,
          };
        }

        lastRowCol = null;
        if (childClue.cells.length > 0) {
          lastRowCol = childClue.cells[childClue.cells.length - 1];
        }
        lastRowColDir = childClue.dir;
      }

      if (firstRowCol &&
        lastRowCol &&
        firstRowCol[0] == lastRowCol[0] &&
        firstRowCol[1] == lastRowCol[1]) {
        const succ = this.grid[firstRowCol[0]][firstRowCol[1]]['succ' + firstRowColDir];
        if (succ) {
          this.grid[lastRowCol[0]][lastRowCol[1]]['succ' + lastRowColDir] = {
            cell: succ.cell,
            dir: firstRowColDir,
          };
        }
      }
      if (this.hasDgmlessCells) {
        continue;
      }

      let prevLen = clue.cells.length;
      let wordEndIndex = 0;
      while (wordEndIndex < clue.wordEndAfter.length &&
        clue.wordEndAfter[wordEndIndex] < prevLen) {
        wordEndIndex++;
      }
      let hyphenIndex = 0;
      while (hyphenIndex < clue.hyphenAfter.length &&
        clue.hyphenAfter[hyphenIndex] < prevLen) {
        hyphenIndex++;
      }
      for (let childIndex of clue.childrenClueIndices) {
        const childClue = this.clues[childIndex];
        const childLen = childClue.cells.length - childClue.linkedOffset;
        while (wordEndIndex < clue.wordEndAfter.length &&
          clue.wordEndAfter[wordEndIndex] < prevLen + childLen) {
          const pos = clue.wordEndAfter[wordEndIndex] - prevLen + childClue.linkedOffset;
          childClue.wordEndAfter.push(pos);
          wordEndIndex++;
        }
        while (hyphenIndex < clue.hyphenAfter.length &&
          clue.hyphenAfter[hyphenIndex] < prevLen + childLen) {
          const pos = clue.hyphenAfter[hyphenIndex] - prevLen + childClue.linkedOffset;
          childClue.hyphenAfter.push(pos);
          hyphenIndex++;
        }
        prevLen = prevLen + childLen;
      }
    }
  }
  roughlyStartsWith(s, prefix) {
    const punct = /[\s'.,-]*/gi;
    let normS = s
      .trim()
      .replace(/<[^>]*>/gi, '')
      .replace(punct, '')
      .trim()
      .toUpperCase();
    let normP = prefix
      .trim()
      .replace(punct, '')
      .trim()
      .toUpperCase();
    return normS.startsWith(normP);
  }
  finalClueTweaks() {
    for (const clueIndex of this.allClueIndices) {
      const theClue = this.clues[clueIndex];
      this.setClueSolution(clueIndex);
      if (!theClue.enumLen && !this.hasDgmlessCells) {
        const cells = this.getAllCells(clueIndex);
        theClue.enumLen = cells.length;
      }
      theClue.dispSol = '';
      if (this.addSolutionToAnno &&
        theClue.solution &&
        !this.isOrphan(clueIndex) &&
        !theClue.showBlanks &&
        (theClue.explicitSol ||
          !this.roughlyStartsWith(theClue.anno, theClue.solution))) {
        theClue.dispSol =
          '<span class="til-solution">' + theClue.solution + '. </span>';
      }
      if (theClue.anno ||
        theClue.dispSol ||
        (theClue.solution && theClue.showBlanks)) {
        this.hasReveals = true;
      }
      if (!theClue.fullDisplayLabel) {
        continue;
      }
      let label = theClue.fullDisplayLabel;
      let l = label.length;
      if (l < 1) {
        continue;
      }
      let last = label.charAt(l - 1).toLowerCase();
      if ((last >= 'a' && last <= 'z') || (last >= '0' && last <= '9')) {
        label = label + '. ';
      } else {
        label = label + ' ';
      }
      if (!this.allCellsKnown(clueIndex)) {
        theClue.fullDisplayLabel = `<span class="til-clickable"><span
        id="${this.prefix}-curr-clue-label" class="til-curr-clue-label"
        title="Click to forcibly mark/unmark as solved.">${label}</span></span>`;
      } else {
        theClue.fullDisplayLabel = `<span id="${this.prefix}-curr-clue-label"
        class="til-curr-clue-label">${label}</span>`;
      }
    }
  }

  setWordEndsAndHyphens() {
    for (c of this.forcedSeps['force-hyphen-right']) {
      if (c[0] >= 0 &&
        c[0] < this.gridHeight &&
        c[1] >= 0 &&
        c[1] < this.gridWidth) {
        this.grid[c[0]][c[1]].hyphenToRight = true;
      }
    }
    for (c of this.forcedSeps['force-hyphen-below']) {
      if (c[0] >= 0 &&
        c[0] < this.gridHeight &&
        c[1] >= 0 &&
        c[1] < this.gridWidth) {
        this.grid[c[0]][c[1]].hyphenBelow = true;
      }
    }
    for (c of this.forcedSeps['force-bar-right']) {
      if (c[0] >= 0 &&
        c[0] < this.gridHeight &&
        c[1] >= 0 &&
        c[1] < this.gridWidth) {
        this.grid[c[0]][c[1]].wordEndToRight = true;
      }
    }
    for (c of this.forcedSeps['force-bar-below']) {
      if (c[0] >= 0 &&
        c[0] < this.gridHeight &&
        c[1] >= 0 &&
        c[1] < this.gridWidth) {
        this.grid[c[0]][c[1]].wordEndBelow = true;
      }
    }
    if (this.hasDgmlessCells) {
      return;       // Give up on setting from clues.
    }
    for (let ci in this.clues) {
      const clue = this.clues[ci];
      let rev = clue.reversed;
      if (this.layers3d > 1 && clue.dir == 'D') rev = !rev;
      for (let w of clue.wordEndAfter) {
        const w2 = rev ? w + 1 : w;
        if (w2 < 0 || w2 >= clue.cells.length) continue;
        const cell = clue.cells[w2];
        const gridCell = this.grid[cell[0]][cell[1]];
        if (clue.dir == 'A') {
          gridCell.wordEndToRight = true;
        } else if (clue.dir == 'D') {
          gridCell.wordEndBelow = true;
        }
      }
      for (let w of clue.hyphenAfter) {
        const w2 = rev ? w + 1 : w;
        if (w2 < 0 || w2 >= clue.cells.length) continue;
        const cell = clue.cells[w2];
        const gridCell = this.grid[cell[0]][cell[1]];
        if (clue.dir == 'A') {
          gridCell.hyphenToRight = true;
        } else if (clue.dir == 'D') {
          gridCell.hyphenBelow = true;
        }
      }
    }
  }
  cmpGnavSpans(s1, s2) {
    const d1 = s1.dir.charAt(0);
    const d2 = s2.dir.charAt(0);
    if (d1 < d2) {
      return -1;
    } else if (d1 > d2) {
      return 1;
    }
    const c1 = s1.cells.length > 0
      ? s1.cells[s1.reversed ? s1.cells.length - 1 : 0]
      : [s1, s1];
    const c2 = s2.cells.length > 0
      ? s2.cells[s2.reversed ? s2.cells.length - 1 : 0]
      : [s2, s2];
    let i1 = c1[0];
    let i2 = c2[0];
    if (this.layers3d > 1) {
      const l1 = Math.floor(i1 / this.h3dLayer);
      const l2 = Math.floor(i2 / this.h3dLayer);
      if (l1 < l2) return -1;
      else if (l1 > l2) return 1;// Within a 3-d layer: near before far.
      i1 = 0 - i1;
      i2 = 0 - i2;
    }
    if (i1 < i2) {
      return -1;
    } else if (i1 > i2) {
      return 1;
    }
    if (c1[1] < c2[1]) {
      return -1;
    } else if (c1[1] > c2[1]) {
      return 1;
    } else {
      return 0;
    }
  }
  getDirClueIndex(dir, label) {
    if (!label) return '';
    if (this.offNumClueIndices[label]) {
      for (let index of this.offNumClueIndices[label]) {
        if (index.charAt(0) == dir) return index;
      }
    }
    return dir + label;
  }
  setUpGnav() {
    let gnavSpans = [];
    let cluesAlreadySpanned = {};
    for (let i = 0; i < this.gridHeight; i++) {
      let j = 0;
      while (j < this.gridWidth) {
        if (!this.grid[i][j].isDgmless) {
          j++;
          continue;
        }
        let span = { cells: [], dir: 'A' };
        let revPref = [];
        for (let pj = j - 1; pj >= 0; pj--) {
          let pcell = this.grid[i][pj];
          if (!pcell.isLight || pcell.hasBarAfter) {
            break;
          }
          const prefClue = this.getDirClueIndex('A', pcell.acrossClueLabel);
          if (prefClue && this.clues[prefClue]) {
            span.cells = span.cells.concat(this.clues[prefClue].cells);
            cluesAlreadySpanned[prefClue] = true;
            break;
          } else {
            revPref.push([i, pj]);
          }
        }
        span.cells = span.cells.concat(revPref.reverse());
        while (j < this.gridWidth) {
          let cell = this.grid[i][j];
          if (!cell.isDgmless && (!cell.isLight || cell.startsAcrossClue)) {
            break;
          }
          if (cell.isDgmless && cell.startsAcrossClue) {
            cluesAlreadySpanned[this.getDirClueIndex('A', cell.acrossClueLabel)] = true;
          }
          span.cells.push([i, j]);
          j++;
          if (cell.hasBarAfter) {
            break;
          }
        }
        console.assert(span.cells.length > 0, i, j);
        gnavSpans.push(span);
      }
    }
    for (let j = 0; j < this.gridWidth; j++) {
      let i = 0;
      while (i < this.gridHeight) {
        if (!this.grid[i][j].isDgmless) {
          i++;
          continue;
        }
        let span = { cells: [], dir: 'D' };
        let revPref = [];
        for (let pi = i - 1; pi >= 0; pi--) {
          let pcell = this.grid[pi][j];
          if (!pcell.isLight || pcell.hasBarUnder) {
            break;
          }
          const prefClue = this.getDirClueIndex('D', pcell.downClueLabel);
          if (prefClue && this.clues[prefClue]) {
            span.cells = span.cells.concat(this.clues[prefClue].cells);
            cluesAlreadySpanned[prefClue] = true;
            break;
          } else {
            revPref.push([pi, j]);
          }
        }
        span.cells = span.cells.concat(revPref.reverse());
        while (i < this.gridHeight) {
          let cell = this.grid[i][j];
          if (!cell.isDgmless && (!cell.isLight || cell.startsDownClue)) {
            break;
          }
          if (cell.isDgmless && cell.startsDownClue) {
            cluesAlreadySpanned[this.getDirClueIndex('D', cell.downClueLabel)] = true;
          }
          span.cells.push([i, j]);
          i++;
          if (cell.hasBarUnder) {
            break;
          }
        }
        console.assert(span.cells.length > 0, i, j);
        gnavSpans.push(span);
      }
    }
    for (let span of gnavSpans) {
      let dir = span.dir;
      let prev = null;
      for (let cell of span.cells) {
        let gridCell = this.grid[cell[0]][cell[1]];
        gridCell['dgmlessSpan' + dir] = span;
        if (prev) {
          this.grid[prev[0]][prev[1]]['succ' + dir] = { cell: cell, dir: dir };
          gridCell['pred' + dir] = { cell: prev, dir: dir };
        }
        prev = cell;
      }
    }

    for (let ci in this.clues) {
      const clue = this.clues[ci];
      if (clue.cells.length == 0) {
        continue;
      }
      if (cluesAlreadySpanned[ci]) {
        continue;
      }
      let dir = ci.charAt(0) == 'X' ? ci : ci.charAt(0);
      const span = {
        cells: clue.cells,
        dir: dir,
      };
      if (clue.reversed) {
        span.reversed = true;
      }
      gnavSpans.push(span);
    }

    gnavSpans.sort(this.cmpGnavSpans.bind(this));

    for (let idx = 0; idx < gnavSpans.length; idx++) {
      let prev = idx - 1;
      if (prev < 0) {
        prev = gnavSpans.length - 1;
      }
      let next = idx + 1;
      if (next >= gnavSpans.length) {
        next = 0;
      }
      for (let cell of gnavSpans[idx].cells) {
        this.grid[cell[0]][cell[1]]['next' + gnavSpans[idx].dir] = {
          cell: gnavSpans[next].cells[0],
          dir: gnavSpans[next].dir,
        };
        this.grid[cell[0]][cell[1]]['prev' + gnavSpans[idx].dir] = {
          cell: gnavSpans[prev].cells[0],
          dir: gnavSpans[prev].dir,
        };
      }
    }
  }
  brightness(rgb) {
    const cols = rgb.match(/[0-9\.]+/g);
    if (!cols || cols.length < 3) {
      return 0;
    }
    return (parseInt(cols[0]) + parseInt(cols[1]) + parseInt(cols[2])) / 3;
  }
  getSurroundingBG() {
    const transparent = 'rgba(0, 0, 0, 0)';
    const transparentIE11 = 'transparent';
    let elem = this.frame.parentElement;
    let bg = null;
    let thisBg;
    while (elem) {
      thisBg = getComputedStyle(elem).backgroundColor;
      if (thisBg === transparent || thisBg === transparentIE11) {
        elem = elem.parentElement;
      } else {
        bg = thisBg;
        break;
      }
    }
    if (!bg) {
      return 'rgb(255,255,255)';
    }
    return bg;
  }
  pickColorScheme() {
    const fgBrightness = typeof (this.frame) !== 'undefined' ? this.brightness(getComputedStyle(this.frame).color) : '';
    if (fgBrightness < 155) {
      this.colorScheme = this.lightColorScheme;
    } else {
      this.colorScheme = this.darkColorScheme;
    }
    if (this.smartColoring) {
      const bg = this.getSurroundingBG();
      const bgBrightness = this.brightness(bg);
      if ((fgBrightness < 155 && bgBrightness >= 200) ||
        (fgBrightness >= 155 && bgBrightness < 75)) {
        this.colorScheme['currclue'] = bg;
      }
    }
  }
  stripLineBreaks(s) {
    s = s.replace(/<br\s*\/?>/gi, ' / ');
    return s.replace(/<\/br\s*>/gi, '');
  }
  renderClueSpan(clue, elt, inCurrClue = false) {
    let clueText = inCurrClue ? this.stripLineBreaks(clue.clue) : clue.clue;
    let html = '';
    let idx = clueText.indexOf('~{');
    let endIdx = 0;
    while (idx >= 0) {
      html += clueText.substring(endIdx, idx);
      endIdx = clueText.indexOf('}~', idx + 2);
      if (endIdx < 0) {
        endIdx = idx;
        break;
      }
      let skip = 2;
      if (clueText.charAt(idx + skip) == '{') {
        const close = clueText.indexOf('}', idx + skip + 1);
        if (close >= idx + skip + 1) {
          skip = close + 1 - idx;
        }
      }
      html +=
        '<span class="til-in-clue-anno">' +
        clueText.substring(idx + skip, endIdx) +
        '</span>';
      endIdx += 2;
      idx = clueText.indexOf('~{', endIdx);
    }
    html += clueText.substr(endIdx);
    elt ? elt.innerHTML = html : '';
    if (inCurrClue) {
      return;
    }
    clue.inClueAnnoReveals = {};
    if (clue.inClueAnnos.length == 0) {
      return;
    }
    const inClueAnnoSpans = elt.getElementsByClassName('til-in-clue-anno');
    console.assert(
      inClueAnnoSpans.length == clue.inClueAnnos.length,
      inClueAnnoSpans,
      clue
    );
    for (let s = 0; s < inClueAnnoSpans.length; s++) {
      const c = clue.inClueAnnos[s];
      if (!clue.inClueAnnoReveals[c]) {
        clue.inClueAnnoReveals[c] = [];
      }
      clue.inClueAnnoReveals[c].push(inClueAnnoSpans[s]);
      if (!this.inClueAnnoReveals[c]) {
        this.inClueAnnoReveals[c] = [];
      }
      this.inClueAnnoReveals[c].push(inClueAnnoSpans[s]);
    }
  }
  
  displayClues() {
    let table = null;
    let dir = '';
    let extraPanels = [];
    let revSuff = '';
    for (let clueIndex of this.allClueIndices) {
      let theClue = this.clues[clueIndex];
      if (!theClue.clue && !theClue.parentClueIndex) {
        this.log('Found no clue text nor a parent clue for ' + clueIndex);
      }
      let clueDir = theClue.clueTableDir || theClue.dir;
      if (dir != clueDir) {
        if (clueDir == 'A') {
          table = this.acrossClues;
          this.hasAcrossClues = true;
          revSuff =
            this.layers3d > 1
              ? 'ba'
              : 'b';
        } else if (clueDir == 'D') {
          table = this.downClues;
          this.hasDownClues = true;
          revSuff =
            this.layers3d > 1
              ? 'to'
              : 'u';
        } else if (clueDir == 'Z') {
          table = this.z3dClues;
          this.hasZ3dClues = true;
          revSuff = 'up';
        } else if (clueDir == 'X') {
          table = this.nodirClues;
          this.hasNodirClues = true;
          revSuff = '';
        } else {
          this.log('Unexpected clue direction ' + clueDir + ' in ' + clueIndex);
        }
        dir = clueDir;
      }
      if (theClue.startNewTable) {
        const newPanel = document.createElement('div');
        newPanel.setAttributeNS( null, 'class', 'til-clues-box til-clues-extra-panel');
        const newTable = document.createElement('table');
        newTable.className = 'til-clues-table';
        newPanel.appendChild(newTable);
        extraPanels.push(newPanel);

        const newPanelInDiv = document.createElement('div');
        newPanelInDiv.setAttributeNS(null, 'class', 'til-clues-panel');
        newPanelInDiv.insertAdjacentHTML('afterbegin',
          `<div class="til-clues-box til-clues-label">
          <hr>
          ${theClue.newTableHeading}
        </div>`
        );
        newPanelInDiv.appendChild(newPanel);

        let tableGrandParent = table.parentElement.parentElement;
        tableGrandParent.parentElement.insertBefore(
          newPanelInDiv,
          tableGrandParent.nextSibling
        );
        table = newTable;
      }
      if (theClue.filler) {
        const tr = document.createElement('tr');
        const col = document.createElement('td');
        const colspan = 2 + (this.extractionSlots ? 1 : 0);
        col.setAttributeNS(null, 'colspan', '' + colspan);
        col.setAttributeNS(null, 'class', 'til-filler');
        col.innerHTML = theClue.filler;
        tr.appendChild(col);
        table.appendChild(tr);
      }
      const tr = document.createElement('tr');

      if (this.extractionSlots > 0) {
        const extrCol = document.createElement('td');
        extrCol.classList.add('til-clue-extraction');
        const extr = document.createElement('input');
        extr.classList.add('til-clue-extraction-slot');
        const slotsStr = '' + this.extractionSlots;
        extr.setAttributeNS(null, 'size', slotsStr);
        extr.setAttributeNS(null, 'type', 'text');
        extr.style.color = this.colorScheme['imp-text'];
        extr.style.maxWidth = '' + (this.extractionSlots + 1) + 'ch';
        extr.setAttributeNS(null, 'maxlength', slotsStr);
        extr.setAttributeNS(null, 'autocomplete', 'off');
        extr.setAttributeNS(null, 'spellcheck', 'false');
        extr.addEventListener('click', this.boundListeners['clue-input-click']);
        extr.addEventListener('input', this.boundListeners['update']);
        extrCol.appendChild(extr);
        this.answersList.push({ input: extr, isq: false,});
        tr.appendChild(extrCol);
      }
      const labelCol = document.createElement('td');
      labelCol.innerHTML = theClue.displayLabel;
      labelCol.classList.add('til-clue-label');

      let labelColChars = theClue.displayLabel.replace(/&[^;]*;/g, '#');
      let labelColNumChars = [...labelColChars].length;
      let indenterHTML = '';
      const linkSep = labelColChars.substr(1, 2);
      if (linkSep == ', ' ||
        linkSep == ' &' ||
        (revSuff && labelColChars.substr(1, revSuff.length) == revSuff)) {
        labelCol.style.textIndent = this.caseCheck(labelColChars.substr(0, 1)) ? '0.55ch' : '1ch';
        indenterHTML = '0';
        labelColNumChars++;
      }
      if (!this.allCellsKnown(clueIndex)) {
        labelCol.classList.add('til-clickable');
        labelCol.setAttributeNS(null, 'title', 'Click to forcibly mark/unmark as solved.');
        labelCol.addEventListener( 'click', this.clueStateToggler.bind(this, clueIndex));
      }
      const clueCol = document.createElement('td');
      if (labelColNumChars > 2) {
        indenterHTML += theClue.displayLabel;
        const indenter = document.createElement('span');
        indenter.className = 'til-invisible';
        indenter.innerHTML = indenterHTML;
        clueCol.appendChild(indenter);
        clueCol.classList.add('til-clue-indent');
      }
      const clueSpan = document.createElement('span');
      this.renderClueSpan(theClue, clueSpan);
      clueCol.appendChild(clueSpan);
      theClue.clueSpan = clueSpan;

      if ((theClue.showBlanks || this.isOrphan(clueIndex)) &&
        !theClue.parentClueIndex) {
        let placeholder = '';
        let len = this.PLACEHOLDER_BLANK_LEN;
        if (theClue.placeholder) {
          placeholder = theClue.placeholder.replace(/\?/g, '·');
          len = placeholder.length;
        }
        if (theClue.showBlanks && theClue.showBlanks > 1) {
          len = theClue.showBlanks;
        }
        if (theClue.placeholderForBlank) {
          placeholder = theClue.placeholderForBlank;
        }
        theClue.placeholderBlank = this.addPlaceholderBlank(
          clueCol,
          false,
          len,
          placeholder,
          clueIndex
        );
        this.answersList.push({
          input: theClue.placeholderBlank,
          isq: false,
        });
      }
      const annoSpan = document.createElement('span');
      annoSpan.setAttributeNS(null, 'class', 'til-anno-text');
      annoSpan.style.color = this.colorScheme['anno'];
      annoSpan.style.display = 'none';
      if (theClue.anno || theClue.dispSol) {
        annoSpan.innerHTML =
          ' ' + theClue.dispSol + '<span>' + theClue.anno + '</span>';
        this.revelationList.push(annoSpan);
      }
      clueCol.appendChild(annoSpan);
      theClue.annoSpan = annoSpan;
      tr.appendChild(labelCol);
      tr.appendChild(clueCol);
      tr.addEventListener('click', this.clueActivator.bind(this, clueIndex));
      theClue.clueTR = tr;
      table.appendChild(tr);
    }
    if (this.cluesPanelLines > 0) {
      const ems = 1.4 * this.cluesPanelLines;
      const emsStyle = '' + ems + 'em';
      this.acrossPanel.style.maxHeight = emsStyle;
      this.downPanel.style.maxHeight = emsStyle;
      this.nodirPanel.style.maxHeight = emsStyle;
      for (let p of extraPanels) {
        p.style.maxHeight = emsStyle;
      }
    }
    if (this.hasAcrossClues) {
      this.acrossPanel.parentElement.style.display = '';
    }
    if (this.hasDownClues) {
      this.downPanel.parentElement.style.display = '';
    }
    if (this.hasZ3dClues) {
      this.z3dPanel.parentElement.style.display = '';
    }
    if (this.hasNodirClues) {
      this.nodirPanel.parentElement.style.display = '';
      if (!this.nodirHeading) {
        this.nodirHeading = 'Other';
      }
      document
        .getElementById(this.prefix + '-nodir-label')
        .insertAdjacentHTML('beforeend', this.nodirHeading);
    }
  }

  computeGridSize(maxDim) {
    let viewportDim = Math.min(this.getViewportWidth(), this.getViewportHeight());
    if (maxDim > 0 && maxDim < viewportDim) {
      viewportDim = maxDim;
    }

    this.squareDim = 31;
    if (this.gridWidth <= 30 && // For jumbo grids, give up.
      (this.squareDim + this.GRIDLINE) * this.gridWidth + this.GRIDLINE >
      viewportDim - 8) {
      this.squareDim = Math.max(
        12,
        Math.floor((viewportDim - 8 - this.GRIDLINE) / this.gridWidth) -
        this.GRIDLINE
      );
    }
    if (this.cellW <= 0 || this.cellH <= 0) {
      this.cellW = this.squareDim;
      this.cellH =
        this.layers3d > 1
          ? Math.ceil(this.squareDim * this.ratio3d)
          : this.squareDim;
    }
    this.squareDim = Math.min(this.cellW, this.cellH);
    this.cellWBy2 = Math.floor((this.cellW + 1) / 2);
    this.cellHBy2 = Math.floor((this.cellH + 1) / 2);
    this.squareDimBy2 = Math.min(this.cellWBy2, this.cellHBy2);

    this.numberStartY = Math.min(10, Math.floor(this.cellH / 3));
    this.numberStartY = !this.isMobile ? this.numberStartY+5 : this.numberStartY+2;
    this.lightStartX = 1.0 + this.cellW / 2.0;
    this.lightStartY = 1.925 + Math.floor(2 * this.cellH / 3);

    this.hyphenW = Math.max(7, Math.floor(this.squareDim / 3) - 1);
    this.hyphenWBy2 = Math.floor((this.hyphenW + 1) / 2);

    this.circleR = 0.0 + this.squareDim / 2.0;
    this.boxWidth =
      this.cellW * this.gridWidth + (this.gridWidth + 1) * this.GRIDLINE;
    if (this.layers3d > 1) {
      this.h3dLayer = this.gridHeight / this.layers3d;
      this.offset3d =
        (this.cellH + this.GRIDLINE) / Math.tan(this.angle3d * Math.PI / 180);
      this.boxWidth += this.offset3d * this.h3dLayer + this.GRIDLINE;
    }
    this.boxHeight =
      this.cellH * this.gridHeight + (this.gridHeight + 1) * this.GRIDLINE;
    this.letterSize = Math.max(8, this.squareDimBy2);
    this.numberSize = 1 + Math.max(5, Math.floor(this.squareDim / 3) - 1);
    this.arrowSize = Math.max(6, Math.floor(13 * this.squareDim / 31));
    this.maxCurrClueWidth = Math.max(
      this.boxWidth + 2 * this.offsetLeft,
      Math.min(viewportDim - 30, 450)
    );
  }
  makeRect(x, y, w, h, colour) {
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttributeNS(null, 'x', x);
    rect.setAttributeNS(null, 'y', y);
    rect.setAttributeNS(null, 'width', w);
    rect.setAttributeNS(null, 'height', h);
    rect.style.fill = colour;
    return rect;
  }
  displayGridBackground() {
    const svgWidth = this.boxWidth + 2 * this.offsetLeft;
    const svgHeight = this.boxHeight + 2 * this.offsetTop;
    this.svg.setAttributeNS(null, 'viewBox', '0 0 ' + svgWidth + ' ' + svgHeight);
    this.svg.setAttributeNS(null, 'width', svgWidth);
    this.svg.setAttributeNS(null, 'height', svgHeight);

    if (this.layers3d > 1) {
      this.background = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'g'
      );
    } else {
      this.background = this.makeRect(
        this.offsetLeft,
        this.offsetTop,
        this.boxWidth,
        this.boxHeight,
        this.colorScheme['background']
      );
    }
    this.svg.appendChild(this.background);
  }
  fireCompletionEvent() {
    if (this.numCellsToFill != this.numCellsFilled || !this.frame) {
      return;
    }
    const event = new CustomEvent('tilXword', {
      bubbles: true,
      detail: {
        id: this.id,
        toFill: this.numCellsToFill,
        filled: this.numCellsFilled,
        knownCorrect: this.knownCorrect,
        knownIncorrect: this.knownIncorrect,
      },
    });
    this.frame.dispatchEvent(event);
  }

  getGridStateAndNumFilled(notifyIfComplete = true) {
    let state = '';
    let numFilled = 0;
    let numCorrect = 0;
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        let gridCell = this.grid[i][j];
        if (gridCell.isLight || gridCell.isDgmless) {
          let stateLetter = gridCell.currLetter;
          if (stateLetter == '?') {
            stateLetter = '0';
          }
          if (!this.multiLetter) {
            state = state + stateLetter;
          } else {
            state = state + stateLetter + '$';
          }
          if (stateLetter != '0') {
            numFilled++;
            if (stateLetter == gridCell.solution) numCorrect++;
          }
        } else {
          state = state + '.';
        }
      }
    }
    const knownCorrect = !this.hasUnsolvedCells && this.numCellsToFill == numCorrect;
    const knownIncorrect = !this.hasUnsolvedCells && this.numCellsToFill > numCorrect;
    const justFinished = numFilled == this.numCellsToFill &&
      (this.numCellsFilled < numFilled ||
        this.knownCorrect != knownCorrect ||
        this.knownIncorrect != knownIncorrect);
    this.numCellsFilled = numFilled;
    this.knownCorrect = knownCorrect;
    this.knownIncorrect = knownIncorrect;
    if (justFinished && notifyIfComplete) {
      setTimeout(this.fireCompletionEvent.bind(this), 0);
    }
    return state;
  }

  updateDisplayAndGetState(notifyIfComplete = true) {
    let state = this.getGridStateAndNumFilled(notifyIfComplete);
    let ci = this.clueOrParentIndex(this.currClueIndex);
    let revOrphan = this.isOrphanWithReveals(ci);
    let theClue = this.clues[ci];
    let haveReveals = (this.activeCells.length > 0 && !this.hasUnsolvedCells) ||
      (theClue &&
        (theClue.anno ||
          theClue.solution ||
          revOrphan ||
          theClue.inClueAnnos.length > 0));
    if (!haveReveals && this.szCellsToOrphan > 0 && this.activeCells.length > 0) {
      let orphanClue = this.cellsToOrphan[JSON.stringify(this.activeCells)];
      if (orphanClue) {
        let oc = this.clues[orphanClue];
        haveReveals =
          oc && (oc.anno || oc.solution || this.isOrphanWithReveals(orphanClue));
      }
    }
    return state;
  }

  updateAndSaveState(notifyIfComplete = true) {
    let state = this.updateDisplayAndGetState(notifyIfComplete);
    for (let a of this.answersList) {
      state = state + this.STATE_SEP + a.input.value;
    }

    if (this.notTemp) {
      try {
        const lsVal = JSON.stringify({
          //timestamp: Date.now(),
          state: state,
          penaltyPairs: this.revelCellsList,
          completionTimeInMillis: (this.timeTaken) * 1000,
          penaltyTimeInMillis: (this.timePenalty) * 1000,
          lastFocussedCell: this.lastFocussedCell,
          autoSuggestEnabled: this.autoSuggestEnabled,
        });
        window.localStorage.setItem(this.stateKey(), lsVal);
      } catch (err) {
        if (!this.warnedAboutLocalStorage) {
          this.warnedAboutLocalStorage = true;
        }
      }
    }
  }
  resetState() {
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        let gridCell = this.grid[i][j];
        if (gridCell.isLight || gridCell.isDgmless) {
          if (gridCell.prefill) {
            gridCell.currLetter = gridCell.solution;
          } else {
            gridCell.currLetter = '0';
          }
          gridCell.textNode.nodeValue = this.stateToDisplayChar(
            gridCell.currLetter
          );
        }
      }
    }
    this.adjustRebusFonts();
  }

  parseState(state) {
    let parsedState = [];
    state = state.trim();
    if (!state) {
      return false;
    }
    let index = 0;
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        if (index >= state.length) {
          this.log('Not enough characters in saved state');
          return false;
        }
        let letter = '';
        letter = state.charAt(index++);
        if (this.multiLetter && letter != '.') {
          let dollar = state.indexOf('$', index);
          if (dollar < 0) {
            this.log('Missing compound-char separator in saved state');
            return false;
          }
          letter = letter + state.substring(index, dollar);
          index = dollar + 1;
        }
        let gridCell = this.grid[i][j];
        if (gridCell.isLight || gridCell.isDgmless) {
          if (gridCell.prefill) {
            parsedState.push(gridCell.solution);
            continue;
          }
          if (letter == '1') {
            if (!gridCell.isDgmless) {
              this.log('Unexpected ⬛ in non-diagramless location');
              return false;
            }
            parsedState.push('1');
          } else {
            if (!this.isValidStateChar(letter)) {
              this.log( 'Unexpected letter/digit ' + letter + ' in state: ' + state);
              return false;
            }
            parsedState.push(letter);
          }
        } else {
          if (letter != '.') {
            this.log( 'Unexpected letter ' + letter + ' in state, expected .: ' + state);
            return false;
          }
        }
      }
    }
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        let gridCell = this.grid[i][j];
        if (gridCell.isLight || gridCell.isDgmless) {
          console.assert(parsedState.length > 0, parsedState);
          gridCell.currLetter = parsedState.shift();
          gridCell.textNode.nodeValue = this.stateToDisplayChar(
            gridCell.currLetter
          );
        }
      }
    }
    this.adjustRebusFonts();
    console.assert(parsedState.length == 0, parsedState);

    if (state.substr(index, this.STATE_SEP.length) == this.STATE_SEP) {
      let parts = state
        .substr(index + this.STATE_SEP.length)
        .split(this.STATE_SEP);
      if (parts.length == this.answersList.length) {
        for (let i = 0; i < parts.length; i++) {
          this.answersList[i].input.value = parts[i];
        }
      }
    }
    return true;
  }
  stateKey() {
    return 'tilstate:' + this.id;
  }
  restoreStateConfirmation() { 
    this.resetState();
    let foundState = false;
    let lsVal = window.localStorage.getItem(this.stateKey());
    if (lsVal) {
      try {
        let decoded = JSON.parse(lsVal);
        foundState = this.parseState(decoded.state);
        if (foundState) {
          if((localStorage && localStorage.getItem('toigames'))){
            //if(this.todaysGame){
              this.restoreState();
              this.pause = false;
            // }
            // else{
            //   if (typeof localStorage !== 'undefined') {
            //     localStorage.removeItem(this.stateKey());
            //   }
            //   // this.overlayCall('pausegamepopup');
            //   this.restoreState();
            //   this.pause = false;
            // }
          }
          else{
            this.restoreState();
            this.pause = true;
          }
        }
      }
      catch (err) {
        foundState = false;
      }
    } else {
      this.restoreState();
    }
  }

  restoreState() {
    this.resetState();
    let foundState = false;
    let lsVal = window.localStorage.getItem(this.stateKey());
    if (lsVal) {
      try {
        let decoded = JSON.parse(lsVal);
        foundState = this.parseState(decoded.state);
        if (decoded.penaltyPairs) {
          this.revelCellsList = decoded.penaltyPairs;
        }
        if (decoded.completionTimeInMillis) {
          this.timeTaken = (decoded.completionTimeInMillis) / 1000;
        }
        if (decoded.penaltyTimeInMillis) {
          this.timePenalty = (decoded.penaltyTimeInMillis) / 1000;
        }
        if (decoded.lastFocussedCell) {
          this.lastFocussedCell = decoded.lastFocussedCell;
          let row = this.lastFocussedCell.row;
          let column = this.lastFocussedCell.column;
          let dir = this.lastFocussedCell.dir;
          this.gnavToInner([row, column], dir);
        }
        if (decoded.autoSuggestEnabled) {
          this.autoSuggestEnabled = decoded.autoSuggestEnabled;
          if (this.autoSuggestEnabled) {
            const autoCheckInput = document.getElementById(this.prefix + '-autocheckbtn');
            if (autoCheckInput) {
              autoCheckInput.checked = this.autoSuggestEnabled
            }
            this.validateGrid();
          }
        }
      } catch (err) {
        foundState = false;
      }
    }else{
      const firstCell = document.querySelector('rect[y="1"]');
      if (firstCell) {
        firstCell.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        this.gridInput.focus();
      }
    }
   
    for (let ci of this.allClueIndices) {
      this.updateClueState(ci, true, null, false /* dont note a fresh solve */);
    }
    if(this.tempSetup){
      let state = this.updateDisplayAndGetState();
      this.gameAPICall('fetchStateCall', '', '', state);
    }
    else{ 
      this.createTimer();
    }
    if(!(localStorage && localStorage.getItem('toigames'))){
      this.pause = true;
    }
    this.updateAndSaveState(false); 
  }
  deactivateCurrCell() {
    this.gridInputWrapper.style.display = 'none';
    for (const x of this.activeCells) {
      const gridCell = this.grid[x[0]][x[1]];
      const cellRect = gridCell.cellRect;
      cellRect.style.fill = this.colorScheme['cell'];
      if (!gridCell.prefill) {
        gridCell.cellText.style.fill = this.colorScheme['light-text'];
      }
      if (gridCell.cellNum) {
        gridCell.cellNum.style.fill = this.colorScheme['light-label'];
      }
      if (gridCell.cellCircle) {
        gridCell.cellCircle.style.stroke = this.colorScheme['circle'];
      }
    }
    if (this.activeCells && this.activeCells.length !== 0 && this.autoSuggestEnabled) {
      this.validateGrid();
    }
    this.activeCells = [];
  }

  currCellIsValid() {
    if (this.currRow < 0 ||
      this.currRow >= this.gridHeight ||
      this.currCol < 0 ||
      this.currCol >= this.gridWidth) {
      return false;
    }
    return true;
  }
  currCell() {
    if (!this.currCellIsValid()) {
      return null;
    }
    return this.grid[this.currRow][this.currCol];
  }
  atCurr(row, col) {
    return row == this.currRow && col == this.currCol;
  }
  symCell(row, col) {
    return this.grid[this.gridHeight - 1 - row][this.gridWidth - 1 - col];
  }
  cellLeftPos(col, offset) {
    return this.offsetLeft + offset + col * (this.cellW + this.GRIDLINE);
  }
  cellTopPos(row, offset) {
    return this.offsetTop + offset + row * (this.cellH + this.GRIDLINE);
  }
  clueOrParentIndex(ci) {
    if (ci && this.clues[ci] && this.clues[ci].parentClueIndex) {
      return this.clues[ci].parentClueIndex;
    }
    return ci;
  }

  deactivateCurrClue() {
    for (let x of this.activeClues) {
      x.style.background = 'inherit';
    }
    this.activeClues = [];
    this.currClueIndex = null;
    if(this.currClue && !this.viewSolution){  
      this.currClue.style.display = 'none';
      document.getElementById('til_crossword_keyboard').style.display = 'none';
    }
  }
  
  gnavToInner(cell, dir) {
    this.currRow = cell[0];
    this.currCol = cell[1];
    this.currDir = dir;
    this.lastFocussedCell = {row: this.currRow, column: this.currCol, dir: this.currDir}

    let gridCell = this.currCell();
    if (!gridCell || (!gridCell.isLight && !gridCell.isDgmless)) {
      return null;
    }

    this.gridInputWrapper.style.left = '' + gridCell.cellLeft + 'px';
    this.gridInputWrapper.style.top = '' + gridCell.cellTop + 'px';
    this.gridInput.value = gridCell.prefill
      ? ''
      : this.stateToDisplayChar(gridCell.currLetter);
    this.gridInputRarr.style.display = 'none';
    this.gridInputDarr.style.display = 'none';
    this.gridInputLarr.style.display = 'none';
    this.gridInputUarr.style.display = 'none';

    this.gridInputWrapper.style.display = '';
    this.gridInput.focus();
    if (this.gridInput.setSelectionRange) {
      let len = this.gridInput.value.length;
      this.gridInput.setSelectionRange(len, len);
    }

    let activeClueIndex = '';
    let activeClueLabel = '';
    if (this.currDir == 'A' &&
      !gridCell.isDgmless &&
      !gridCell.acrossClueLabel &&
      !gridCell.dgmlessSpanA) {
      this.toggleCurrDir();
    } else if (this.currDir == 'D' &&
      !gridCell.isDgmless &&
      !gridCell.downClueLabel &&
      !gridCell.dgmlessSpanD) {
      this.toggleCurrDir();
    } else if (this.currDir == 'Z' && !gridCell.z3dClueLabel) {
      this.toggleCurrDir();
    } else if (this.currDir.charAt(0) == 'X' &&
      (!gridCell.nodirClues || !gridCell.nodirClues.includes(this.currDir))) {
      this.toggleCurrDir();
    }
    if (this.currDir == 'A') {
      if (gridCell.acrossClueLabel) {
        activeClueLabel = gridCell.acrossClueLabel;
        activeClueIndex = this.getDirClueIndex('A', activeClueLabel);
      }
    } else if (this.currDir == 'D') {
      if (gridCell.downClueLabel) {
        activeClueLabel = gridCell.downClueLabel;
        activeClueIndex = this.getDirClueIndex('D', activeClueLabel);
      }
    } else if (this.currDir == 'Z') {
      if (gridCell.z3dClueLabel) {
        activeClueLabel = gridCell.z3dClueLabel;
        activeClueIndex = this.getDirClueIndex('Z', activeClueLabel);
      }
    } else {
      activeClueIndex = this.currDir;
      activeClueLabel = this.currDir.substr(1);
    }
    if (activeClueIndex != '') {
      if (!this.clues[activeClueIndex]) {
        activeClueIndex = '';
        if (this.offNumClueIndices[activeClueLabel]) {
          for (let ci of this.offNumClueIndices[activeClueLabel]) {
            if (ci.charAt(0) == 'X' ||
              ci.charAt(0) == activeClueIndex.charAt(0)) {
              activeClueIndex = ci;
              break;
            }
          }
        }
        if (!this.clues[activeClueIndex]) {
          activeClueIndex = '';
        }
      }
    }

    let dgmlessSpan = gridCell['dgmlessSpan' + this.currDir];
    if (dgmlessSpan) {
      for (let rowcol of dgmlessSpan.cells) {
        this.grid[rowcol[0]][rowcol[1]].cellRect.style.fill = this.colorScheme['active'];
        this.activeCells.push(rowcol);
      }
      if (!activeClueIndex) {
        activeClueIndex = this.lastOrphan;
      }
    } else if (activeClueIndex && this.clues[activeClueIndex]) {
      let clueIndices = this.getLinkedClues(activeClueIndex);
      let parentIndex = clueIndices[0];
      let last = null;
      for (let clueIndex of clueIndices) {
        for (let rowcol of this.clues[clueIndex].cells) {
          this.grid[rowcol[0]][rowcol[1]].cellRect.style.fill = this.colorScheme['active'];
          if (!last || last[0] != rowcol[0] || last[1] != rowcol[1]) {
            this.activeCells.push(rowcol);
            last = rowcol;
          }
        }
      }
      if (last &&
        last[0] == this.activeCells[0][0] &&
        last[1] == this.activeCells[0][1]) {
        this.activeCells.pop();
      }
    } else {
      this.activeCells.push([this.currRow, this.currCol]);
      activeClueIndex = this.lastOrphan;
    }
    gridCell.cellRect.style.fill = this.colorScheme['input'];
    if (!gridCell.prefill) {
      gridCell.cellText.style.fill = this.colorScheme['light-text-input'];
    }
    if (gridCell.cellNum) {
      gridCell.cellNum.style.fill = this.colorScheme['light-label-input'];
    }
    if (gridCell.cellCircle) {
      gridCell.cellCircle.style.stroke = this.colorScheme['circle-input'];
    }

    if (activeClueIndex) {
      const clue = this.clues[activeClueIndex];
      if (clue.dir == 'A') {
        if (clue.reversed) this.gridInputLarr.style.display = '';
        else this.gridInputRarr.style.display = '';
      } else if (clue.dir == 'D') {
        const pointDown = (this.layers3d == 1 && !clue.reversed) ||
          (this.layers3d > 1 && clue.reversed);
        if (pointDown) this.gridInputDarr.style.display = '';
        else this.gridInputUarr.style.display = '';
      } else if (clue.dir == 'Z') {
        if (clue.reversed) {
          this.gridInputLarr.style.display = '';
          this.gridInputUarr.style.display = '';
        } else {
          this.gridInputRarr.style.display = '';
          this.gridInputDarr.style.display = '';
        }
      }
    }

    if (this.layers3d > 1) {
      this.gridInputWrapper.style.transformOrigin = 'top left';
      this.gridInputWrapper.style.transform =
        this.skew3d + ` translate(${gridCell.offset3d}px)`;
    }

    return activeClueIndex;
  }
  activateCell(row, col) {
    this.deactivateCurrCell();
    let clue = this.gnavToInner([row, col], this.currDir);
    if (clue) {
      this.deactivateCurrClue();
      this.cnavToInner(clue);
    }
    this.updateDisplayAndGetState();
  }
  cellActivator(row, col) {
    this.usingGnav = true;
    this.activateCell(row, col);
    this.lastFocussedCell = {row: row, column: col, dir: this.currDir}
  }
  clueActivator(ci) {
    this.usingGnav = false;
    this.cnavTo(ci);
  }
  getViewportHeight() {
    const ch = window.location != window.parent.location
      ? 0
      : document.documentElement.clientHeight;
    return window.innerHeight && ch
      ? Math.min(window.innerHeight, ch)
      : window.innerHeight ||
      ch ||
      document.getElementsByTagName('body')[0].clientHeight;
  }
  getViewportWidth() {
    const cw = window.location != window.parent.location
      ? 0
      : document.documentElement.clientWidth;
    return window.innerWidth && cw
      ? Math.min(window.innerWidth, cw)
      : window.innerWidth ||
      cw ||
      document.getElementsByTagName('body')[0].clientWidth;
  }

  scrollIfNeeded(elt) {
    // const par = elt.parentElement.parentElement;
    // const parPos = par.getBoundingClientRect();
    // if (parPos.bottom < 0) {
    //   return;
    // }
    // let windowH = this.getViewportHeight();
    // if (!windowH || windowH <= 0) {
    //   return;
    // }
    // if (parPos.top >= windowH) {
    //   return;
    // }
    // const pos = elt.getBoundingClientRect();
    // if (pos.bottom < 0 ||
    //   pos.bottom < parPos.top ||
    //   pos.top >= windowH ||
    //   pos.top < parPos.top ||
    //   pos.top >= parPos.bottom) {
    //   par.scrollTop = pos.top - elt.parentElement.getBoundingClientRect().top;
    // }
    if (!elt) return;
    const par = elt.closest('.til-clues');
    if (!par) return;
    const eltRect = elt.getBoundingClientRect();
    const parRect = par.getBoundingClientRect();
    if (eltRect.top < parRect.top) {
      par.scrollTo({
        top: par.scrollTop - (parRect.top - eltRect.top + 30),
        behavior: 'smooth',
      });
    } else if (eltRect.bottom > parRect.bottom) {
      par.scrollTo({
        top: par.scrollTop + (eltRect.bottom - parRect.bottom),
        behavior: 'smooth',
      });
    }
  }

  getLinkedClues(clueIndex) {
    let clueIndices = [clueIndex];
    if (this.clues[clueIndex]) {
      if (this.clues[clueIndex].parentClueIndex) {
        let parent = this.clues[clueIndex].parentClueIndex;
        clueIndices = [parent].concat(this.clues[parent].childrenClueIndices);
      } else if (this.clues[clueIndex].childrenClueIndices) {
        clueIndices = clueIndices.concat(
          this.clues[clueIndex].childrenClueIndices
        );
      }
    }
    return clueIndices;
  }

  getCurrClueButtons() {
    return `<span>
      <button id="${this.prefix}-curr-clue-prev"
        class="til-prevArrow"
        title="Previous clue"
          >
          <i class="iconLeft"></i>
          </button>
      <button id="${this.prefix}-curr-clue-next"
        class="til-nextArrow"
        title="Next clue"
          >
          <i class="iconRight"></i>
          </button></span>`;
  }
  cnavNext() {
    if (!this.currClueIndex ||
      !this.clues[this.currClueIndex] ||
      !this.clues[this.currClueIndex].next) {
      return;
    }
    let next = this.clues[this.currClueIndex].next;
    if (this.gnavIsClueless()) {
      let jumps = 0;
      while (jumps < this.allClueIndices.length && !this.isOrphan(next)) {
        jumps++;
        next = this.clues[next].next;
      }
    }
    this.cnavTo(next, false);
    this.refocus();
  }
  cnavPrev() {
    if (!this.currClueIndex ||
      !this.clues[this.currClueIndex] ||
      !this.clues[this.currClueIndex].prev) {
      return;
    }
    let prev = this.clues[this.currClueIndex].prev;
    if (this.gnavIsClueless()) {
      let jumps = 0;
      while (jumps < this.allClueIndices.length && !this.isOrphan(prev)) {
        jumps++;
        prev = this.clues[prev].prev;
      }
    }
    this.cnavTo(prev, false);
    this.refocus();
  }
  cnavToInner(activeClueIndex, grabFocus = false) {
    let clueIndices = this.getLinkedClues(activeClueIndex);
    let parentIndex = clueIndices[0];
    let gnav = null;
    let clueAtActive = this.clues[activeClueIndex];
    if (clueAtActive && clueAtActive.cells.length > 0) {
      let dir = activeClueIndex.charAt(0) == 'X'
        ? activeClueIndex
        : activeClueIndex.charAt(0);
      gnav = [clueAtActive.cells[0][0], clueAtActive.cells[0][1], dir];
    }
    let curr = this.clues[parentIndex];
    if (!curr || !curr.clue) {
      activeClueIndex = this.lastOrphan;
      parentIndex = this.lastOrphan;
      curr = this.clues[parentIndex];
      if (!curr || !curr.clue) {
        return null;
      }
      clueIndices = this.getLinkedClues(parentIndex);
    }
    let orphan = this.isOrphan(parentIndex);
    if (orphan) {
      this.lastOrphan = parentIndex;
    }
    let colour = orphan
      ? this.colorScheme['orphan']
      : this.colorScheme['active-clue'];
    for (let clueIndex of clueIndices) {
      let theClue = this.clues[clueIndex];
      if (!theClue.clueTR) {
        continue;
      }
      theClue.clueTR.style.background = colour;
      // if (this.cluesPanelLines > 0) {
        this.scrollIfNeeded(theClue.clueTR);
      // }
      this.activeClues.push(theClue.clueTR);
    }
    this.currClueIndex = activeClueIndex;
    this.revealcellButton.classList.remove('disabled');
    if (this.currClueInner) {
      this.currClueInner.innerHTML =
        this.getCurrClueButtons() +
        curr.fullDisplayLabel +
        `<span id="${this.prefix}-curr-clue-text"></span>`;
    }
    let clueSpan = document.getElementById(`${this.prefix}-curr-clue-text`);

    this.renderClueSpan(curr, clueSpan, true);

    const currCluePrev = document.getElementById(this.prefix + '-curr-clue-prev');
    const currClueNext = document.getElementById(this.prefix + '-curr-clue-next');


    currCluePrev ? currCluePrev.addEventListener('click', this.cnavPrev.bind(this)) : '';
    currClueNext ? currClueNext.addEventListener('click', this.cnavNext.bind(this)) : '';

    let currLab = document.getElementById(this.prefix + '-curr-clue-label');
    if (currLab && currLab.parentElement.classList.contains('til-clickable')) {
      currLab.addEventListener(
        'click',
        this.toggleClueSolvedState.bind(this, this.currClueIndex)
      );
    }
    if (this.clues[parentIndex].placeholderBlank) {
      let placeholder = '';
      let len = this.clues[parentIndex].placeholderBlank.size ||
        this.PLACEHOLDER_BLANK_LEN;
      if (this.clues[parentIndex].placeholder) {
        placeholder = this.clues[parentIndex].placeholder.replace(/\?/g, '·');
      }
      this.addPlaceholderBlank(
        this.currClueInner,
        true,
        len,
        placeholder,
        parentIndex
      );
      this.copyPlaceholderBlankToCurr(parentIndex);
      if (grabFocus && !this.usingGnav && parentIndex == activeClueIndex) {
        this.clues[parentIndex].placeholderBlank.focus();
      }
    }
    this.currClueInner ? this.currClueInner.style.background = this.colorScheme['currclue'] : '';
    this.updateClueState(parentIndex, false, null);
    if(this.currClue && (this.isMobile || this.viewSolution)) 
      {
        this.currClue.style.display = '' ;
        // Only show keyboard for mobile mode, not viewSolution
        if (this.isMobile && !this.viewSolution) {
          document.getElementById('til_crossword_keyboard').style.display = '';
        }
      }
    return gnav;
  }

  gnavIsClueless() {
    let gridCell = this.currCell();
    if (!gridCell) {
      return false;
    }
    let aIndex = '';
    let dIndex = '';
    return (
      gridCell.isDgmless ||
      (this.currDir == 'A' &&
        (!gridCell.acrossClueLabel ||
          !(aIndex = this.getDirClueIndex('A', gridCell.acrossClueLabel)) ||
          !this.clues[aIndex] ||
          !this.clues[aIndex].clue)) ||
      (this.currDir == 'D' &&
        (!gridCell.downClueLabel ||
          !(dIndex = this.getDirClueIndex('D', gridCell.downClueLabel)) ||
          !this.clues[dIndex] ||
          !this.clues[dIndex].clue)) ||
      (this.currDir == 'Z' &&
        (!gridCell.z3dClueLabel ||
          !(zIndex = this.getDirClueIndex('Z', gridCell.z3dClueLabel)) ||
          !this.clues[zIndex] ||
          !this.clues[zIndex].clue)) ||
      (this.currDir.charAt(0) == 'X' &&
        (!gridCell.nodirClues || !gridCell.nodirClues.includes(this.currDir)))
    );
  }
  cnavTo(activeClueIndex, grabFocus = true) {
    if (activeClueIndex == this.currClueIndex) {
      this.refocus();
      return;
    }
    this.deactivateCurrClue();
    let cellDir = this.cnavToInner(activeClueIndex, grabFocus);
    if (cellDir) {
      this.deactivateCurrCell();
      this.gnavToInner([cellDir[0], cellDir[1]], cellDir[2]);
    } else {
      if (!this.gnavIsClueless()) {
        this.deactivateCurrCell();
      }
    }
    this.updateDisplayAndGetState();
  }
  copyPlaceholderBlank(clueIndex) {
    if (this.hideCopyPlaceholders ||
      this.activeCells.length < 1 ||
      !clueIndex ||
      !this.clues[clueIndex] ||
      !this.clues[clueIndex].clueTR) {
      return;
    }
    const inp = this.clues[clueIndex].placeholderBlank;
    if (!inp) {
      return;
    }
    const entry = inp.value;
    let splitter = '';
    if (this.langMaxCharCodes > 1 && entry.indexOf(' ') >= 0) {
      splitter = ' ';
    }
    const letters = [];
    const candLetters = entry.split(splitter);
    for (const letter of candLetters) {
      if (!this.caseCheck(letter)) {
        if (!this.allowChars || !this.allowChars[letter]) {
          continue;
        }
      }
      letters.push(letter);
    }
    if (letters.length < 1) {
      return;
    }
    let index = 0;
    let row = -1;
    let col = -1;
    for (let i = 0; i < letters.length; i++) {
      if (index >= this.activeCells.length) {
        break;
      }
      const x = this.activeCells[index++];
      row = x[0];
      col = x[1];
      const gridCell = this.grid[row][col];
      if (gridCell.prefill) {
        continue;
      }
      const letter = letters[i];
      const oldLetter = gridCell.currLetter;
      if (oldLetter != letter) {
        gridCell.currLetter = letter;
        const revealedChar = this.stateToDisplayChar(letter);
        gridCell.textNode.nodeValue = revealedChar;
        if (this.atCurr(row, col)) {
          this.gridInput.value = revealedChar;
        }
      }
    }
    this.adjustRebusFonts();
    if (index < this.activeCells.length) {
      const x = this.activeCells[index];
      row = x[0];
      col = x[1];
    }
    if (row >= 0 && col >= 0) {
      this.activateCell(row, col);
    }
    this.updateActiveCluesState();
    this.updateAndSaveState();
  }

  updateOrphanEntry(clueIndex, inCurr, evt) {
    if (!clueIndex ||
      !this.clues[clueIndex] ||
      !this.clues[clueIndex].clueTR ||
      this.clues[clueIndex].parentClueIndex ||
      !this.clues[clueIndex].placeholderBlank) {
      return;
    }
    evt.stopPropagation();
    const theInput = this.clues[clueIndex].placeholderBlank;
    if (!inCurr) {
      let cursor = theInput.selectionStart;
      theInput.value = theInput.value.toUpperCase().trimLeft();
      theInput.selectionEnd = cursor;
      this.updateAndSaveState();
    }
    let curr = document.getElementById(this.CURR_PLACEHOLDER_BLANK_ID);
    if (!curr) {
      return;
    }
    let currInputs = curr.getElementsByTagName('input');
    if (currInputs.length != 1) {
      return;
    }
    let theCurrInput = currInputs[0];
    if (inCurr) {
      let cursor = theCurrInput.selectionStart;
      theCurrInput.value = theCurrInput.value.toUpperCase().trimLeft();
      theCurrInput.selectionEnd = cursor;
      theInput.value = theCurrInput.value;
      this.updateAndSaveState();
    } else {
      theCurrInput.value = theInput.value;
    }
  }

  copyPlaceholderBlankToCurr(clueIndex) {
    if (!clueIndex ||
      !this.clues[clueIndex] ||
      !this.clues[clueIndex].clueTR ||
      this.clues[clueIndex].parentClueIndex ||
      !this.clues[clueIndex].placeholderBlank) {
      return;
    }
    const clueInput = this.clues[clueIndex].placeholderBlank;
    const curr = document.getElementById(this.CURR_PLACEHOLDER_BLANK_ID);
    if (!curr) {
      return;
    }
    const currInputs = curr.getElementsByTagName('input');
    if (currInputs.length != 1) {
      return;
    }
    currInputs[0].value = clueInput.value;
  }
  phBlankCopier(clueIndex, e) {
    this.copyPlaceholderBlank(clueIndex);
    e.stopPropagation();
  }
  clueInputClick(e) {
    e.stopPropagation();
  }
  addPlaceholderBlank(elt,
    inCurr,
    len,
    placeholder,
    clueIndex) {
    let html = '<span';
    if (inCurr) {
      html = html + ' id="' + this.CURR_PLACEHOLDER_BLANK_ID + '"';
    }
    if (len < placeholder.length) {
      len = placeholder.length;
    }
    html = html + ' class="til-nobr"><input size="' + len + '" + style="max-width:' + len +
      'ch"' + '" class="til-incluefill" placeholder="' + placeholder + '" type="text title="" autocomplete="off" spellcheck="off"></input>';
    if (!this.hideCopyPlaceholders) { html = html + '<button class="til-small-button">&#8690;</button>';}
    html = html + '</span>';
    elt.insertAdjacentHTML('beforeend', html);
    const incluefill = elt.lastElementChild.firstElementChild;
    incluefill.style.color = this.colorScheme['solution'];
    incluefill.addEventListener(
      'input',
      this.updateOrphanEntry.bind(this, clueIndex, inCurr)
    );
    incluefill.addEventListener('click', this.boundListeners['clue-input-click']);
    if (!this.hideCopyPlaceholders) {
      elt.lastElementChild.lastElementChild.addEventListener(
        'click',
        this.phBlankCopier.bind(this, clueIndex)
      );
    }
    return incluefill;
  }
  
  dirCmp(d1, d2) {
    return this.dirOrder[d1.substr(0, 1)] - this.dirOrder[d2.substr(0, 1)];
  }
  toggleCurrDir() {
    let gridCell = this.currCell();
    if (!gridCell) {
      return;
    }
    let choices = [];
    if (gridCell.acrossClueLabel || gridCell.succA || gridCell.predA) {
      choices.push('A');
    }
    if (gridCell.downClueLabel || gridCell.succD || gridCell.predD) {
      choices.push('D');
    }
    if (gridCell.z3dClueLabel || gridCell.succZ || gridCell.predZ) {
      choices.push('Z');
    }
    if (gridCell.nodirClues) {
      choices = choices.concat(gridCell.nodirClues);
    }
    if (choices.length < 1) {
      return;
    }
    choices.sort(this.dirCmp.bind(this));
    let i = 0;
    while (i < choices.length && this.currDir != choices[i]) {
      i++;
    }
    if (i >= choices.length) {
      i = -1;
    }
    let newDir = choices[(i + 1) % choices.length];
    if (this.currDir == newDir) {
      return;
    }
    this.currDir = newDir;
  }
  toggleCurrDirAndActivate(e) {
    this.usingGnav = true;
    if (e && !e.shiftKey) {
      this.toggleCurrDir();
    }
    this.activateCell(this.currRow, this.currCol);
  }

  handleKeyUpInner(key, shift = false) {
    if (key == 9 && !shift) {
      if (this.usingGnav) {
        let gridCell = this.currCell();
        if (!gridCell || !this.currDir) {
          return false;
        }
        let gnav = gridCell['next' + this.currDir];
        if (!gnav) {
          return false;
        }
        this.currDir = gnav.dir;
        this.activateCell(gnav.cell[0], gnav.cell[1]);
      } else {
        if (!this.currClueIndex ||
          !this.clues[this.currClueIndex] ||
          !this.clues[this.currClueIndex].next) {
          return false;
        }
        this.cnavTo(this.clues[this.currClueIndex].next);
      }
      return true;
    } else if (key == 9 && shift) {
      if (this.usingGnav) {
        let gridCell = this.currCell();
        if (!gridCell || !this.currDir) {
          return false;
        }
        let gnav = gridCell['prev' + this.currDir];
        if (!gnav) {
          return false;
        }
        this.currDir = gnav.dir;
        this.activateCell(gnav.cell[0], gnav.cell[1]);
      } else {
        if (!this.currClueIndex ||
          !this.clues[this.currClueIndex] ||
          !this.clues[this.currClueIndex].prev) {
          return false;
        }
        this.cnavTo(this.clues[this.currClueIndex].prev);
      }
      return true;
    }
    if (!this.currCellIsValid()) {
      return false;
    }

    this.usingGnav = true;
    if (key == 8) {
      let gridCell = this.currCell();
      if (gridCell.currLetter != '0' &&
        gridCell.currLetter != '?' &&
        !gridCell.prefill) {
        return true;
      }

      this.retreatCursorInLight();
      return true;
    }
    if (key == 46) {
      const gridCell = this.currCell();
      if (gridCell && gridCell.isLight && !gridCell.prefill) {
        this.clearCell(this.currRow, this.currCol);
        this.updateActiveCluesState();
        this.updateAndSaveState();
      }
      return true;
    }
    if (key == 13) {
      this.toggleCurrDirAndActivate();
    } else if (key == 39) {
      let col = this.currCol + 1;
      while (col < this.gridWidth &&
        !this.grid[this.currRow][col].isLight &&
        !this.grid[this.currRow][col].isDgmless) {
        col++;
      }
      if (col < this.gridWidth) {
        this.activateCell(this.currRow, col);
      }
    } else if (key == 37) {
      let col = this.currCol - 1;
      while (col >= 0 &&
        !this.grid[this.currRow][col].isLight &&
        !this.grid[this.currRow][col].isDgmless) {
        col--;
      }
      if (col >= 0) {
        this.activateCell(this.currRow, col);
      }
    } else if (key == 40) {
      let row = this.currRow + 1;
      while (row < this.gridHeight &&
        !this.grid[row][this.currCol].isLight &&
        !this.grid[row][this.currCol].isDgmless) {
        row++;
      }
      if (row < this.gridHeight) {
        this.activateCell(row, this.currCol);
      }
    } else if (key == 38) {
      let row = this.currRow - 1;
      while (row >= 0 &&
        !this.grid[row][this.currCol].isLight &&
        !this.grid[row][this.currCol].isDgmless) {
        row--;
      }
      if (row >= 0) {
        this.activateCell(row, this.currCol);
      }
    }
    return true;
  }
  handleKeyUp(e) {
    let key = e.which || e.keyCode;
    if (key == 9) {
      return; // Already handled with key-down.
    }
    this.handleKeyUpInner(key);
  }
  muzzleEvent(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  handleKeyDown(e) {
    let key = e.which || e.keyCode;
    this.lastKeyHadShift = e.shiftKey;
    if (key == 9) {
      if (this.handleKeyUpInner(key, e.shiftKey)) {
        e.preventDefault();
      }
    } else if (e.ctrlKey && (e.key == 'q' || e.key == 'Q')) {
      this.muzzleEvent(e);
      if (e.key == 'Q') {
        this.clearAll();
      } else {
        this.clearCurr();
      }
    } else if (e.ctrlKey && e.key == 'B') {
      this.muzzleEvent(e);
    } 
  }
  advanceCursor() {
    const gridCell = this.currCell();
    if (!gridCell) {
      return;
    }
    const successor = gridCell['succ' + this.currDir];
    if (!successor) {
      return;
    }
    this.currDir = successor.dir;
    this.activateCell(successor.cell[0], successor.cell[1]);
  }
  retreatCursorInLight() {
    const gridCell = this.currCell();
    if (!gridCell) {
      return;
    }
    const pred = gridCell['pred' + this.currDir];
    if (!pred) {
      return;
    }
    this.currDir = pred.dir;
    this.activateCell(pred.cell[0], pred.cell[1]);
  }
  toggleClueSolvedState(clueIndex) {
    if (this.allCellsKnown(clueIndex)) {
      this.log( 'toggleClueSolvedState() called on ' + clueIndex +' with all cells known' );
      return;
    }
    let clue = this.clues[clueIndex];
    if (!clue || !clue.clueTR) {
      return;
    }
    let cls = clue.clueTR.className;
    let currLab = null;
    if (clueIndex == this.currClueIndex) {
      currLab = document.getElementById(this.prefix + '-curr-clue-label');
    }
    if (cls == 'til-solved') {
      clue.clueTR.className = '';
      if (currLab) {
        currLab.className = 'til-curr-clue-label';
      }
    } else {
      clue.clueTR.className = 'til-solved';
      if (currLab) {
        currLab.className = 'til-curr-clue-label til-solved';
      }
    }
  }
  clueStateToggler(ci, e) {
    this.toggleClueSolvedState(ci);
    e.stopPropagation();
  }

  updateClueState(clueIndex,
    annoPrefilled,
    forceSolved,
    logSolved) {
    let cis = this.getLinkedClues(clueIndex);
    if (!cis || cis.length == 0) {
      return;
    }
    clueIndex = cis[0]; // Use parent for a linked child
    if (!clueIndex) {
      return;
    }
    const clue = this.clues[clueIndex];
    if (!clue) {
      return;
    }
    let solved = false;
    if (clue && clue.clueTR && clue.clueTR.className == 'til-solved') {
      solved = true;
    }
    let numFilled = 0;
    let numPrefilled = 0;
    for (let ci of cis) {
      let theClue = this.clues[ci];
      if (!theClue.clueTR) {
        numFilled = 0;
        break;
      }
      let isFullRet = this.isFull(ci);
      if (!isFullRet[0]) {
        numFilled = 0;
        break;
      }
      numFilled += isFullRet[1];
      if (isFullRet[0] == 2) {
        numPrefilled += isFullRet[1];
      }
    }
    if (forceSolved) {
      if (forceSolved == 'solved') {
        solved = true;
      } else {
        solved = false;
        if (this.allCellsKnown(clueIndex) && numPrefilled == clue.enumLen) {
          solved = true;
        }
      }
    } else if ((clue.anno || clue.dispSol) && clue?.annoSpan?.style?.display == '') {
      solved = true;
    } else if (this.allCellsKnown(clueIndex)) {
      solved = numFilled == clue.enumLen;
    }
    if (solved &&
      numFilled == numPrefilled &&
      annoPrefilled &&
      (clue.anno || clue.dispSol)) {
      this.revealClueAnno(clueIndex);
    }
    let cls = solved ? 'til-solved' : '';
    for (let ci of cis) {
      if (this.clues[ci].clueTR) {
        this.clues[ci].clueTR.setAttributeNS(null, 'class', cls);
      }
      if (ci == this.currClueIndex) {
        let currLab = document.getElementById(this.prefix + '-curr-clue-label');
        if (currLab) {
          currLab.setAttributeNS(
            null,
            'class',
            'til-curr-clue-label' + (cls ? ' ' + cls : '')
          );
        }
      }
    }
    const lastEntry = clue.entry || '';
    clue.entry = this.getClueEntry(clueIndex);
  }

  updateActiveCluesState() {
    let clueIndices = {};
    if (this.currClueIndex) {
      let lci = this.getLinkedClues(this.currClueIndex);
      for (let ci of lci) {
        clueIndices[ci] = true;
      }
    }
    for (let x of this.activeCells) {
      let gridCell = this.grid[x[0]][x[1]];
      if (gridCell.acrossClueLabel) {
        let ci = this.getDirClueIndex('A', gridCell.acrossClueLabel);
        clueIndices[ci] = true;
      }
      if (gridCell.downClueLabel) {
        let ci = this.getDirClueIndex('D', gridCell.downClueLabel);
        clueIndices[ci] = true;
      }
      if (gridCell.z3dClueLabel) {
        let ci = this.getDirClueIndex('Z', gridCell.z3dClueLabel);
        clueIndices[ci] = true;
      }
      if (gridCell.nodirClues) {
        for (let ci of gridCell.nodirClues) {
          clueIndices[ci] = true;
        }
      }
    }
    for (let ci in clueIndices) {
      this.updateClueState(ci, false, null, true);
    }
  }

  expireOverwrite(gridCell) {
    if (!gridCell) {
      return;
    }
    if (gridCell.cellText) {
      gridCell.cellText.classList.remove('til-overwritten');
    }
    if (gridCell.overwritten) {
      gridCell.overwritten = null;
    }
    if (gridCell.overwrittenT) {
      clearTimeout(gridCell.overwrittenT);
      gridCell.overwrittenT = null;
    }
  }

  enableMultiLetterEntry() {
    if (!this.multiLetter) {
      return;
    }
    const gridCell = this.currCell();
    if (!gridCell || !gridCell.isLight) {
      return;
    }
    this.multiLetterCellRow = this.currRow;
    this.multiLetterCellCol = this.currCol;
  }

  checkMultiLetterMode(entry) {
    if (!this.multiLetter) {
      return false;
    }
    const mRow = this.multiLetterCellRow;
    const mCol = this.multiLetterCellCol;

    this.multiLetterCellRow = -1;
    this.multiLetterCellCol = -1;
    if (this.lastKeyHadShift || entry.length > 1) {
      return true;
    }
    if (this.currRow == mRow && this.currCol == mCol) {
      this.multiLetterCellRow = mRow;
      this.multiLetterCellCol = mCol;
      return true;
    }
    return false;
  }
  handleGridInput(event = false) {
    if(this.isMobile && event){
      const buttonText = event.target.textContent;
      this.gridInput.value = buttonText;
    }
    this.usingGnav = true;
    const gridCell = this.currCell();
    if (!gridCell) {
      return;
    }
    if (!gridCell.isLight && !gridCell.isDgmless) {
      return;
    }
    let newInput = this.gridInput.value;
    let currDisplayChar = this.stateToDisplayChar(gridCell.currLetter);
    const multiLetterMode = this.checkMultiLetterMode(currDisplayChar);
    if (gridCell.currLetter != '0' &&
      gridCell.currLetter != '?' &&
      newInput != currDisplayChar &&
      !multiLetterMode) {

      const index = newInput.indexOf(currDisplayChar);
      if (index == 0) {
        newInput = newInput.substr(1);
      }
    }
    let displayChar = newInput.replace(/\s+/g, ' ');
    if (!this.hasRebusCells || !multiLetterMode) {
      displayChar = newInput.substr(0, this.langMaxCharCodes);
    }
    let wasSpace = displayChar == ' ';
    if (wasSpace) {
      if (gridCell.isDgmless) {

        displayChar = this.BLOCK_CHAR;
      } else {
        displayChar = '';
      }
    } else {
      displayChar = displayChar.toUpperCase();
      if (displayChar && !this.isValidDisplayChar(displayChar)) {
        this.gridInput.value = gridCell.prefill
          ? ''
          : this.stateToDisplayChar(gridCell.currLetter);
        return;
      }
      if (this.gridInput.value.toUpperCase() !== gridCell.solution) {
        gridCell.cellRect.style.fill = '#FCAB64';

      }
    }
    if (gridCell.prefill) {
      this.gridInput.value = '';
      this.advanceCursor();
      return;
    }
    const stateChar = this.displayToStateChar(displayChar);
    const oldLetter = gridCell.currLetter;
    gridCell.currLetter = stateChar;
    gridCell.textNode.nodeValue = displayChar;
    this.gridInput.value = displayChar;
    if (this.hasRebusCells) {
      const fontSize = this.cellLetterSize(displayChar);
      gridCell.cellText.style.fontSize = fontSize;
      this.gridInput.style.fontSize = fontSize;
    }
    if (oldLetter == '1' || stateChar == '1') {
      let gridCellSym = this.symCell(this.currRow, this.currCol);
      if (gridCellSym.isDgmless) {
        let symLetter = stateChar == '1' ? '1' : '0';
        let symChar = stateChar == '1' ? this.BLOCK_CHAR : '';
        gridCellSym.currLetter = symLetter;
        gridCellSym.textNode.nodeValue = symChar;
      }
    }
    if (displayChar != '' &&
      stateChar != '0' &&
      stateChar != oldLetter &&
      oldLetter != '0' &&
      oldLetter != '?' &&
      this.hltOverwrittenMillis > 0) {
      if (!gridCell.overwritten) {

        gridCell.overwritten = oldLetter;
        gridCell.cellText.classList.add('til-overwritten');
        gridCell.overwrittenT = setTimeout(
          this.expireOverwrite.bind(this, gridCell),
          this.hltOverwrittenMillis
        );
      } else if (gridCell.overwritten == stateChar) {
        this.expireOverwrite(gridCell);
      }
    }

    let cluesAffected = [];
    let index = this.getDirClueIndex('A', gridCell.acrossClueLabel);
    if (index && this.clues[index]) {
      cluesAffected.push(index);
    }
    index = this.getDirClueIndex('D', gridCell.downClueLabel);
    if (index && this.clues[index]) {
      cluesAffected.push(index);
    }
    index = this.getDirClueIndex('Z', gridCell.z3dClueLabel);
    if (index && this.clues[index]) {
      cluesAffected.push(index);
    }
    let otherClues = gridCell.nodirClues;
    if (otherClues) {
      cluesAffected = cluesAffected.concat(otherClues);
    }
    let ci;
    for (ci of cluesAffected) {
      this.updateClueState(ci, false, null, true);
    }

    this.updateAndSaveState();
    
    if (this.autoSuggestEnabled) {
      this.validateGrid();
    }

    if (!multiLetterMode && (wasSpace || this.isValidDisplayChar(displayChar))) {
      // this.advanceCursor();
      const extractedClues = Object.fromEntries(
        Object.entries(this.clues).map(([key, value]) => [
          key,
          {
            index: value.index,
            next: value.next,
            prev: value.prev,
            cells: value.cells,
            dir: value.dir,
            label: value.label,
            enumLen: value.enumLen,
            solution: value.solution,
            entry: value.entry,
            displayLabel: value.displayLabel
          }
        ])
      );
    
      const activeClue = Object.values(extractedClues).find(clue =>
        clue.dir === this.lastFocussedCell.dir &&
        clue.cells.some(cell =>
          cell[0] === this.lastFocussedCell.row &&
          cell[1] === this.lastFocussedCell.column
        )
      );
      if (activeClue) {
        const isWordCompleted = activeClue.entry &&
          activeClue.entry.length === activeClue.enumLen &&
          !activeClue.entry.includes('?');
        if (isWordCompleted) {
          this.lastDirection = activeClue.dir;
          // Finding first unfilled cell in a clue
          const getFirstEmptyCell = (clue) => 
            clue.cells.find((_, idx) => clue.entry[idx] === '?');
          // Checking if a clue has any unfilled cells
          const hasUnfilledCells = (clue) => clue.entry.includes('?');
          // Finding the next word in the same direction which has unfilled cells
          const nextSameDirWord = Object.values(extractedClues).find(clue =>
            clue.dir === this.lastDirection && hasUnfilledCells(clue)
          );
          if (nextSameDirWord) {
            const emptyCell = getFirstEmptyCell(nextSameDirWord);
            if (emptyCell) {
              this.activateCell(emptyCell[0], emptyCell[1]);
              return;
            }
          }
          // If no words available in the same direction, switch to the other direction
          const nextOtherDirWord = Object.values(extractedClues).find(clue =>
            clue.dir !== this.lastDirection && hasUnfilledCells(clue)
          );
          if (nextOtherDirWord) {
            const emptyCell = getFirstEmptyCell(nextOtherDirWord);
            if (emptyCell) {
              this.activateCell(emptyCell[0], emptyCell[1]);
              return;
            }
          }
          // Fallback If all words are completed
          this.advanceCursor();
          return;
        }
        // For incomplete word, perform normal cursor movement
        this.advanceCursor();
      } else {
        // No Clue Case
        this.advanceCursor();
      }
    }
  }
  deactivator() {
    this.deactivateCurrCell();
    this.deactivateCurrClue();
    this.usingGnav = false;
    this.revealcellButton ? this.revealcellButton.classList.add('disabled') : '';
  }
  createListeners() {
    this.boundListeners = {};

    this.boundListeners['clue-input-click'] = this.clueInputClick.bind(this);
    this.boundListeners['key-up'] = this.handleKeyUp.bind(this);
    this.boundListeners['update'] = this.updateAndSaveState.bind(this, true);

    this.boundListeners['key-down'] = this.handleKeyDown.bind(this);

    this.boundListeners['grid-input'] = this.handleGridInput.bind(this);
    this.boundListeners['grid-cell-dblclick'] = this.enableMultiLetterEntry.bind(
      this
    );
    this.boundListeners['grid-cell-click'] = this.toggleCurrDirAndActivate.bind(
      this
    );
    this.boundListeners['deactivator'] = this.deactivator.bind(this);
    this.windowListeners = {};
  }
  bindListeners() {
    this.gridInput.addEventListener('keyup', this.boundListeners['key-up']);
    this.frame.addEventListener('keydown', this.boundListeners['key-down']);
    this.gridInput.addEventListener('input', this.boundListeners['grid-input']);
    this.gridInputWrapper.addEventListener(
      'click',
      this.boundListeners['grid-cell-click']
    );
    this.gridInputWrapper.addEventListener(
      'dblclick',
      this.boundListeners['grid-cell-dblclick']
    );

    const boundDeactivator = this.boundListeners['deactivator'];
    this.background.addEventListener('click', boundDeactivator);
    if (this.notTemp) {
      for (let e in this.windowListeners) {
        window.addEventListener(e, this.windowListeners[e]);
      }
    }
  }
  recolourCells(scale = 1) {
    this.colourGroup.innerHTML = '';
    const dupes = {};
    for (let colourSpec of this.colourfuls) {
      for (let cccc of colourSpec.list) {
        for (let cell of cccc.cells) {
          const row = cell[0];
          const col = cell[1];
          if (dupes[[row, col, colourSpec.colour]]) continue;
          this.colourGroup.appendChild(
            this.makeCellDiv(row, col, colourSpec.colour, scale)
          );
          dupes[[row, col, colourSpec.colour]] = true;
        }
      }
    }
    this.colourGroup.style.display = this.colourfuls.length > 0 ? '' : 'none';
  }
  cellLetterSize(entry) {
    if (!this.hasRebusCells || entry.length <= 1) {
      return this.letterSize + 'px';
    }
    const AVAILABLE_WIDTH = this.cellW - 2.5 * this.BAR_WIDTH;
    const width = this.measureTextWidth(entry);

    if (width <= AVAILABLE_WIDTH) {
      return this.letterSize + 'px';
    }
    const scaledSize = Math.max(6, this.letterSize * AVAILABLE_WIDTH / width);
    return scaledSize + 'px';
  }

  measureTextWidth(entry) {

    const canvas = this.canvas ?? (this.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    context.font = getComputedStyle(this.gridParent).getPropertyValue('font');
    const metrics = context.measureText(entry);
    return metrics.width;
  }
  adjustRebusFonts() {
    if (!this.hasRebusCells) {
      return;
    }
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        const gridCell = this.grid[i][j];
        if (!gridCell.isLight) {
          continue;
        }
        const displayChar = this.stateToDisplayChar(gridCell.currLetter);
        const fontSize = this.cellLetterSize(displayChar);
        gridCell.cellText.style.fontSize = fontSize;
        if (this.atCurr(i, j)) {
          this.gridInput.style.fontSize = fontSize;
        }
      }
    }
  }
  displayGrid() {
    let fontSize = this.cellLetterSize('');
    this.gridInput.style.fontSize = fontSize;
    this.gridInputWrapper.style.fontSize = fontSize;
    this.numCellsToFill = 0;
    this.numCellsPrefilled = 0;
    for (let i = 0; i < this.gridHeight; i++) {
      const cellTop = this.cellTopPos(i, this.GRIDLINE);
      for (let j = 0; j < this.gridWidth; j++) {
        const cellLeft = this.cellLeftPos(j, this.GRIDLINE);
        let gridCell = this.grid[i][j];
        gridCell.cellLeft = cellLeft;
        gridCell.cellTop = cellTop;
        if (!gridCell.isLight && !gridCell.isDgmless) {
          continue;
        }
        const cellGroup = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'g'
        );
        let activator = this.cellActivator.bind(this, i, j);

        this.numCellsToFill++;
        if (gridCell.prefill) {
          this.numCellsPrefilled++;
        }
        const cellRect = this.makeRect(
          cellLeft,
          cellTop,
          this.cellW,
          this.cellH,
          this.colorScheme['cell']
        );
        cellGroup.appendChild(cellRect);

        const cellText = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );
        cellText.setAttributeNS(null, 'x', this.cellLeftPos(j, this.lightStartX));
        cellText.setAttributeNS(null, 'y', this.cellTopPos(i, this.lightStartY));
        cellText.setAttributeNS(null, 'text-anchor', 'middle');
        cellText.setAttributeNS(null, 'editable', 'simple');
        let letter = '0';
        let cellClass = 'til-cell-text';
        if (gridCell.prefill) {
          letter = gridCell.solution;
          cellText.style.fill = this.colorScheme['prefill'];
          cellClass = 'til-cell-text til-prefill';
        } else {
          cellText.style.fill = this.colorScheme['light-text'];
        }
        if(!this.isMobile){
          cellClass = cellClass + ' til-text-font';
          this.type !== 'crossword' ? fontSize = '38px': fontSize = '24px';
        }
        
        cellText.style.fontSize = fontSize;
        cellText.setAttributeNS(null, 'class', cellClass);

        const text = document.createTextNode(letter);
        cellText.appendChild(text);
        cellGroup.appendChild(cellText);

        gridCell.currLetter = letter;
        gridCell.textNode = text;
        gridCell.cellText = cellText;
        gridCell.cellRect = cellRect;
        gridCell.cellGroup = cellGroup;

        cellText.addEventListener('click', activator);
        cellRect.addEventListener('click', activator);

        if (gridCell.hasCircle) {
          const cellCircle = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'circle'
          );
          cellCircle.setAttributeNS(
            null,
            'cx',
            this.cellLeftPos(
              j,
              this.circleR + this.GRIDLINE + (this.cellW / 2 - this.circleR)
            )
          );
          cellCircle.setAttributeNS(
            null,
            'cy',
            this.cellTopPos(
              i,
              this.circleR + this.GRIDLINE + (this.cellH / 2 - this.circleR)
            )
          );
          cellCircle.setAttributeNS(null, 'class', 'til-cell-circle');
          cellCircle.style.stroke = this.colorScheme['circle'];
          cellCircle.setAttributeNS(null, 'r', this.circleR);
          cellGroup.appendChild(cellCircle);
          cellCircle.addEventListener('click', activator);
          gridCell.cellCircle = cellCircle;
        }
        if ((gridCell.startsClueLabel &&
          !gridCell.isDgmless &&
          !gridCell.skipNum &&
          !this.hideInferredNumbers) ||
          gridCell.forcedClueLabel) {
          const cellNum = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'text'
          );
          cellNum.setAttributeNS(
            null,
            'x',
            this.cellLeftPos(j, this.NUMBER_START_X)
          );
          const yTop = this.type !== 'crossword' ? this.cellTopPos(i, this.numberStartY)+12 : this.cellTopPos(i, this.numberStartY);
          cellNum.setAttributeNS(
            null,
            'y',
            yTop
          );
          cellNum.setAttributeNS(null, 'class', 'til-cell-num');
          cellNum.style.fill = this.colorScheme['light-label'];
          cellNum.style.fontSize = this.numberSize + 'px';
          const numText = gridCell.forcedClueLabel
            ? gridCell.forcedClueLabel
            : gridCell.startsClueLabel;
          cellNum.innerHTML = numText;
          cellNum.addEventListener('click', activator);
          cellGroup.appendChild(cellNum);
          gridCell.cellNum = cellNum;
        }
        this.svg.appendChild(cellGroup);
      }
    }
    this.adjustRebusFonts();

    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        let gridCell = this.grid[i][j];
        const cellGroup = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'g'
        );
        let emptyGroup = true;
        if (gridCell.wordEndToRight &&
          j + 1 < this.gridWidth &&
          this.grid[i][j + 1].isLight) {
          const wordEndRect = this.makeRect(
            this.cellLeftPos(j + 1, this.GRIDLINE - this.SEP_WIDTH_BY2),
            this.cellTopPos(i, this.GRIDLINE),
            this.SEP_WIDTH,
            this.cellH,
            this.colorScheme['separator']
          );
          cellGroup.appendChild(wordEndRect);
          emptyGroup = false;
        }
        if (gridCell.wordEndBelow &&
          i + 1 < this.gridHeight &&
          this.grid[i + 1][j].isLight) {
          const wordEndRect = this.makeRect(
            this.cellLeftPos(j, this.GRIDLINE),
            this.cellTopPos(i + 1, this.GRIDLINE - this.SEP_WIDTH_BY2),
            this.cellW,
            this.SEP_WIDTH,
            this.colorScheme['separator']
          );
          cellGroup.appendChild(wordEndRect);
          emptyGroup = false;
        }
        if (gridCell.hyphenToRight) {
          const hw = j + 1 < this.gridWidth ? this.hyphenW : this.hyphenWBy2;
          const hyphenRect = this.makeRect(
            this.cellLeftPos(j + 1, this.GRIDLINE - this.hyphenWBy2),
            this.cellTopPos(
              i,
              this.GRIDLINE + this.cellHBy2 - this.SEP_WIDTH_BY2
            ),
            hw,
            this.SEP_WIDTH,
            this.colorScheme['separator']
          );
          cellGroup.appendChild(hyphenRect);
          emptyGroup = false;
        }
        if (gridCell.hyphenBelow) {
          const hh = i + 1 < this.gridHeight ? this.hyphenW : this.hyphenWBy2;
          const hyphenRect = this.makeRect(
            this.cellLeftPos(
              j,
              this.GRIDLINE + this.cellWBy2 - this.SEP_WIDTH_BY2
            ),
            this.cellTopPos(i + 1, this.GRIDLINE - this.hyphenWBy2),
            this.SEP_WIDTH,
            hh,
            this.colorScheme['separator']
          );
          cellGroup.appendChild(hyphenRect);
          emptyGroup = false;
        }
        if (gridCell.hasBarAfter) {
          const barRect = this.makeRect(
            this.cellLeftPos(j + 1, this.GRIDLINE - this.BAR_WIDTH_BY2),
            this.cellTopPos(i, this.GRIDLINE),
            this.BAR_WIDTH,
            this.cellH,
            this.colorScheme['background']
          );
          cellGroup.appendChild(barRect);
          emptyGroup = false;
        }
        if (gridCell.hasBarUnder) {
          const barRect = this.makeRect(
            this.cellLeftPos(j, this.GRIDLINE),
            this.cellTopPos(i + 1, this.GRIDLINE - this.BAR_WIDTH_BY2),
            this.cellW,
            this.BAR_WIDTH,
            this.colorScheme['background']
          );
          cellGroup.appendChild(barRect);
          emptyGroup = false;
        }
        if (!emptyGroup) {
          gridCell.miscGroup = cellGroup;
          this.svg.appendChild(cellGroup);
        }
      }
    }

  }

  makeCellDiv(row, col, colour, scale = 1) {
    const gridCell = this.grid[row][col];
    const cellLeft = gridCell.cellLeft * scale;
    const cellTop = gridCell.cellTop * scale;

    const rect = document.createElement('div');
    rect.style.backgroundColor = colour;
    rect.setAttributeNS(null, 'class', 'til-coloured-cell');

    rect.style.left = '' + cellLeft + 'px';
    rect.style.top = '' + cellTop + 'px';
    rect.style.width = '' + this.cellW * scale + 'px';
    rect.style.height = '' + this.cellH * scale + 'px';
    if (this.layers3d > 1) {
      rect.style.transformOrigin = 'top left';
      rect.style.transform = `${this.skew3d} translate(${gridCell.offset3d *
        scale}px)`;
    }
    rect.addEventListener('click', this.cellActivator.bind(this, row, col));
    return rect;
  }
  clearCell(row, col) {
    let gridCell = this.grid[row][col];
    let oldLetter = gridCell.currLetter;
    if (oldLetter != '0') {
      gridCell.currLetter = '0';
      gridCell.textNode.nodeValue = '';
      if (this.atCurr(row, col)) {
        this.gridInput.value = '';
      }
    }
    this.adjustRebusFonts();
    if (oldLetter == '1') {
      let gridSymCell = this.symCell(row, col);
      if (gridSymCell.isDgmless) {
        gridSymCell.currLetter = '0';
        gridSymCell.textNode.nodeValue = '';
      }
    }
  }

  isFull(clueIndex) {
    let theClue = this.clues[clueIndex];
    if (!theClue) {
      return [0, 0];
    }
    let cells = theClue.cells;
    if (cells.length < 1) {
      cells = theClue.cellsOfOrphan;
      if (!cells || cells.length < 1) {
        return [0, 0];
      }
    }
    let numPrefills = 0;
    for (let x of cells) {
      let gridCell = this.grid[x[0]][x[1]];
      if (gridCell.prefill) {
        numPrefills++;
        continue;
      }
      if (gridCell.currLetter == '0' || gridCell.currLetter == '?') {
        return [0, 0];
      }
    }
    return numPrefills == cells.length ? [2, cells.length] : [1, cells.length];
  }
  clearCurr() {
    let clueIndices = [];
    if (this.activeCells.length > 0) {
      let clueCells = null;
      if (this.currClueIndex) {
        clueCells = this.getAllCells(this.clueOrParentIndex(this.currClueIndex));
      }
      if (this.sameCells(this.activeCells, clueCells)) {
        clueIndices = this.getLinkedClues(this.currClueIndex);
      } else {
        for (let cell of this.activeCells) {
          const gridCell = this.grid[cell[0]][cell[1]];
          if (this.currDir == 'A' && gridCell.acrossClueLabel) {
            clueIndices.push(this.getDirClueIndex('A', gridCell.acrossClueLabel));
          }
          if (this.currDir == 'D' && gridCell.downClueLabel) {
            clueIndices.push(this.getDirClueIndex('D', gridCell.downClueLabel));
          }
          if (this.currDir == 'Z' && gridCell.z3dClueLabel) {
            clueIndices.push(this.getDirClueIndex('Z', gridCell.z3dClueLabel));
          }
        }
      }
    } else if (this.currClueIndex) {
      clueIndices = this.getLinkedClues(this.currClueIndex);
    }
    const currClues = {};
    for (let ci of clueIndices) {
      currClues[ci] = true;
    }
    for (let clueIndex in currClues) {
      const theClue = this.clues[clueIndex];
      if (theClue.annoSpan) {
        theClue.annoSpan.style.display = 'none';
      }
      if (theClue.inClueAnnoReveals) {
        for (let c in theClue.inClueAnnoReveals) {
          for (let s of theClue.inClueAnnoReveals[c]) {
            s.className = '';
          }
        }
      }
    }
    const fullCrossers = [];
    const others = [];
    for (let x of this.activeCells) {
      const row = x[0];
      const col = x[1];
      const gridCell = this.grid[row][col];
      if (gridCell.prefill) {
        continue;
      }
      if (gridCell.currLetter == '0' || gridCell.currLetter == '?') {
        continue;
      }
      const crossers = [];
      const across = this.getDirClueIndex('A', gridCell.acrossClueLabel || '');
      if (this.clues[across] && !currClues[across]) crossers.push(across);
      const down = this.getDirClueIndex('D', gridCell.downClueLabel || '');
      if (this.clues[down] && !currClues[down]) crossers.push(down);
      const z3d = this.getDirClueIndex('Z', gridCell.z3dClueLabel || '');
      if (this.clues[z3d] && !currClues[z3d]) crossers.push(z3d);
      let hasFull = false;
      for (let crosser of crossers) {
        if (this.isFull(crosser)[0]) {
          hasFull = true;
          break;
        }
      }
      if (hasFull) {
        fullCrossers.push([row, col]);
      } else {
        others.push([row, col]);
      }
    }
    for (let rc of others) {
      this.clearCell(rc[0], rc[1]);
    }
    if (others.length == 0) {
      for (let rc of fullCrossers) {
        this.clearCell(rc[0], rc[1]);
      }
    }
    this.updateActiveCluesState();
    if (this.currClueIndex) {
      this.updateClueState(this.currClueIndex, false, 'unsolved', true);
    }
    this.updateAndSaveState();
    this.refocus();
  }

  clearAll() {
    for (let row = 0; row < this.gridHeight; row++) {
      for (let col = 0; col < this.gridWidth; col++) {
        let gridCell = this.grid[row][col];
        if (!gridCell.isLight && !gridCell.isDgmless) {
          continue;
        }
        if (gridCell.prefill) {
          continue;
        }
        gridCell.currLetter = '0';
        gridCell.textNode.nodeValue = '';
        if (this.atCurr(row, col)) {
          this.gridInput.value = '';
        }
      }
    }
    this.adjustRebusFonts();
    for (let a of this.answersList) {
      if (a.isq) {
        a.input.value = '';
      } else {
        break;
      }
    }
    for (let a of this.revelationList) {
      a.style.display = 'none';
    }
    for (let c in this.inClueAnnoReveals) {
      for (let s of this.inClueAnnoReveals[c]) {
        s.className = '';
      }
    }

    for (let ci of this.allClueIndices) {
      this.updateClueState(ci, false, 'unsolved', true);
      if (clearingPls && this.clues[ci].placeholderBlank) {
        this.clues[ci].placeholderBlank.value = '';
      }
    }
    if (clearingPls && this.currClue) {
      let clueInputs = this.currClue.getElementsByTagName('input');
      if (clueInputs.length == 1) {
        clueInputs[0].value = '';
      }
    }
    this.revelCellsList = [];
    this.updateAndSaveState();
    this.refocus();
    return true;
  }

  revealClueAnno(ci) {
    let clueIndices = this.getLinkedClues(ci);
    for (let clueIndex of clueIndices) {
      let theClue = this.clues[clueIndex];
      if (theClue.annoSpan) {
        theClue.annoSpan.style.display = '';
      }
      if (theClue.placeholderBlank) {
        if (theClue.solution) {
          theClue.placeholderBlank.value = theClue.solution;
          if (clueIndex == this.currClueIndex) {
            this.copyPlaceholderBlankToCurr(clueIndex);
          }
        }
      }
      if (theClue.inClueAnnoReveals) {
        for (let c in theClue.inClueAnnoReveals) {
          for (let s of theClue.inClueAnnoReveals[c]) {
            s.className = 'greenNeeded';
          }
        }
      }
    }
  }
  revealCellConfirmation() {
    try {
      if (typeof localStorage !== 'undefined') {
        const storedValue = localStorage.getItem('toigames');
        const parsedValue = storedValue ? JSON.parse(storedValue) : '';
        const revealCellPopUp = parsedValue ? parsedValue.revealCellPopUp : '';
        if (revealCellPopUp) {
          this.revealCell();
          this.fireGa('character_reveal', 'nonpopup');
          return false;
        } 
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
    if (this.revealcellButton && !this.revealcellButton.classList.contains('disabled')) {
      //let penalty = (1 + (this.revelCellsList.length) * 5);
      this.overlayCall('typeTwo');
      this.fireGa('character_reveal', 'popup');
    }
  }
  revealCell() {
    this.cellNotLight = true;
    this.revealCurr();
  }
  howtoPlay() {
    this.overlayCall('typeOne');
    this.fireGa('how_to_play');
    this.fireGa('auto_check','',true, 'start_game, help_bar');
    this.menuListHandler.bind(this);
  }
  hardPauseCall() {
    this.pause = true;
    this.gameAPICall('saveStateCall', '', '');
    document.removeEventListener("visibilitychange", this.boundManageTimer);
    this.hardPause();
    if(!this.showCongrate){
      this.fireGa('pause');
    }
  }
  revealCurr() {
    if (this.cellLightToggleTimer) {
      clearTimeout(this.cellLightToggleTimer);
      this.cellLightToggleTimer = null;
    }

    let clueIndexForAnnoReveal = null;
    let addCellsFromOrphanClue = null;
    if (this.usingGnav && this.activeCells.length > 0 && !this.cellNotLight) {
      if (this.currClueIndex && !this.isOrphan(this.currClueIndex)) {
        clueIndexForAnnoReveal = this.currClueIndex;
      }
      if (this.currClueIndex &&
        this.activeCells.length > 1 &&
        (this.isOrphan(this.currClueIndex) ||
          !this.allCellsKnown(this.currClueIndex)) &&
        this.szCellsToOrphan > 0) {
        let orphanClueForCells = this.cellsToOrphan[JSON.stringify(this.activeCells)];
        if (orphanClueForCells) {
          this.deactivateCurrClue();
          this.cnavToInner(orphanClueForCells);
          clueIndexForAnnoReveal = orphanClueForCells;
          addCellsFromOrphanClue = this.clues[orphanClueForCells];
        }
      }
    } else if (this.currClueIndex && !this.cellNotLight) {
      clueIndexForAnnoReveal = this.currClueIndex;
      let parentClueIndex = this.clues[this.currClueIndex].parentClueIndex || this.currClueIndex;
      if (this.isOrphanWithReveals(parentClueIndex)) {
        this.deactivateCurrCell();
        addCellsFromOrphanClue = this.clues[parentClueIndex];
      }
    }
    if (clueIndexForAnnoReveal) {
      this.revealClueAnno(clueIndexForAnnoReveal);
    }
    if (addCellsFromOrphanClue) {
      let activeCellsSet = {};
      for (let rowcol of this.activeCells) {
        activeCellsSet[JSON.stringify(rowcol)] = true;
      }
      for (let rowcol of addCellsFromOrphanClue.cellsOfOrphan) {
        let gridCell = this.grid[rowcol[0]][rowcol[1]];
        if (!activeCellsSet[JSON.stringify(rowcol)]) {
          gridCell.cellRect.style.fill = this.colorScheme['active'];
          this.activeCells.push(rowcol);
        }
      }
    }
    for (let x of this.activeCells) {
      let row = x[0];
      let col = x[1];
      if (this.cellNotLight && !this.atCurr(row, col)) {
        continue;
      }
      let gridCell = this.grid[row][col];
      if (gridCell.prefill) {
        continue;
      }
      let oldLetter = gridCell.currLetter;
      let letter = gridCell.solution;
      if (letter && oldLetter != letter && letter != '0' && letter != '?') {
        gridCell.currLetter = letter;
        let revealedChar = this.stateToDisplayChar(letter);
        gridCell.textNode.nodeValue = revealedChar;
        this.revelCellsList.push({row: row, column: col});
        if (Array.isArray(this.revelCellsList) &&
          this.revelCellsList.length > 0) {
          //let penalty = (1 + (this.revelCellsList.length - 1) * 5);
          let penalty = this.configPenalty;
          this.timePenalty = this.timePenalty + penalty;
          this.timeTaken =
            this.timeTaken + penalty;
          this.titleElt = document.getElementById(this.prefix + '-plusPoint');
          this.titleElt.innerHTML = '+' + penalty + ' Sec';
          //this.titleElt.style.display = 'block';
          this.titleElt.style.opacity = '1';
          setTimeout(() => {
            //this.titleElt.style.display = 'none';
            this.titleElt.style.opacity = '.5';
            //let penaltyDisplay = (1 + (this.revelCellsList.length) * 5);
            let penaltyDisplay = this.configPenalty;
            this.titleElt.innerHTML = '+' + penaltyDisplay + ' Sec';
          }, 2000);
        }

        if (this.atCurr(row, col)) {
          this.gridInput.value = revealedChar;
        }
      }
      if (oldLetter == '1' || letter == '1') {
        let gridSymCell = this.symCell(row, col);
        if (gridSymCell.isDgmless) {
          let symLetter = letter == '1' ? '1' : '0';
          let symChar = letter == '1' ? this.BLOCK_CHAR : '';
          gridSymCell.currLetter = symLetter;
          gridSymCell.textNode.nodeValue = symChar;
        }
      }
    }
    this.adjustRebusFonts();
    this.updateActiveCluesState();
    if (this.currClueIndex && !this.cellNotLight) {
      this.updateClueState(this.currClueIndex, false, 'solved', true);
    }
    this.updateAndSaveState();
    this.refocus();
    this.cellNotLight = false;
  }

  calculateRevelAllPenalty(){
    let countRevelCellsList = this.revelCellsList.length || 0;
    let penalty = 0;
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        let gridCell = this.grid[i][j];
        if (!gridCell.isLight && !gridCell.isDgmless) {
          continue;
        }
        if (gridCell.prefill) {
          continue;
        }
        if (gridCell.currLetter != gridCell.solution) {
          countRevelCellsList++;
          //let penaltyTemp = (1 + (countRevelCellsList - 1) * 5);
          let penaltyTemp = this.configPenalty;
          penalty = penaltyTemp + penalty;
        }
      }
    }
    return penalty;
  }
  revealAllHandler(ev) {
    this.fireGa('game_reveal');
    this.revelAllPenalty = this.calculateRevelAllPenalty();
    this.overlayCall('typeFour');
    this.fireGa('game_reveal', 'game_reveal_popup', true);
    //this.revealAll();
  }
  menuListHandler(ev) {
    if (this.menuList.style.display === 'block') {
      this.menuList.style.display = 'none';
      this.menuCircle.classList.remove(`close`);
    }
    else {
      this.menuList.style.display = 'block';
      this.menuCircle.classList.add(`close`);
    }
  }

  keyBoardCall(event){
    if(event.target.value === 'submit'){
      // this.fireGa('submit');
      window.crossword.submitSolution();
    }else{
    window.crossword.handleGridInput(event);
    }
  }

  resetCall() {
    try {
      if (typeof localStorage !== 'undefined') {
        const storedValue = localStorage.getItem('toigames');
        const parsedValue = storedValue ? JSON.parse(storedValue) : '';
        const resetPopUp = parsedValue ? parsedValue.resetPopUp : '';
        if (resetPopUp) {
          this.resetState();
          this.fireGa('play_again');
          return false;
        } 
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
    this.overlayCall('typeThree');
    this.fireGa('play_again');
  }

  validateGrid() {
    // if (!this.autoSuggestEnabled) return;

    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        const gridCell = this.grid[i][j];
        if (!gridCell || !gridCell.isLight) continue;
  
        let userInput = gridCell.currLetter?.toUpperCase()?.trim();  // Trim any spaces
        const correctLetter = gridCell.solution?.toUpperCase();
        if (!userInput || userInput === '0' || userInput === '') {
          gridCell.cellText.style.fill = this.colorScheme['correctEntry']; // Optional reset to default
          continue;
        }
  
        if (userInput === correctLetter) {
          gridCell.cellText.style.fill = this.colorScheme['correctEntry'];
        } else {
          gridCell.cellText.style.fill = this.colorScheme['errorEntry'];
        }
      }
    }
  }

  resetCellColors() {
    for (let i = 0; i < this.gridHeight; i++) {
      for (let j = 0; j < this.gridWidth; j++) {
        const gridCell = this.grid[i][j];
        if (!gridCell || !gridCell.isLight) continue;
        gridCell.cellText.style.fill = this.colorScheme['light-text'];
      }
    }
  }

handleAutoSuggestClick(event) {
  if (event) {
    this.autoSuggestEnabled = event.target.checked;
  } else {
    this.autoSuggestEnabled = !this.autoSuggestEnabled;
  }

  if (this.autoSuggestEnabled) {
    this.validateGrid();
    this.fireGa('auto_check','','', 'on');
  } else {
    this.resetCellColors();
    this.fireGa('auto_check','','', 'off');
  }
}

  revealAll() {
    for (let row = 0; row < this.gridHeight; row++) {
      for (let col = 0; col < this.gridWidth; col++) {
        let gridCell = this.grid[row][col];
        if (!gridCell.isLight && !gridCell.isDgmless) {
          continue;
        }
        if (gridCell.prefill) {
          continue;
        }
        if (gridCell.currLetter != gridCell.solution) {
          gridCell.currLetter = gridCell.solution;
          let revealedChar = this.stateToDisplayChar(gridCell.solution);
          gridCell.textNode.nodeValue = revealedChar;
          this.revelCellsList.push({row: row, column: col});
          //let penalty = (1 + (this.revelCellsList.length - 1) * 5);
          let penalty = this.configPenalty;
          this.timePenalty = this.timePenalty + penalty;
          this.timeTaken = this.timeTaken + penalty;
          if (this.atCurr(row, col)) {
            this.gridInput.value = revealedChar;
          }
        }
      }
    }
    this.adjustRebusFonts();
    for (let a of this.answersList) {
      if (a.ans) {
        a.input.value = a.ans;
      }
    }
    for (let a of this.revelationList) {
      a.style.display = '';
    }
    for (let c in this.inClueAnnoReveals) {
      for (let s of this.inClueAnnoReveals[c]) {
        s.className = c;
      }
    }
    for (let ci of this.allClueIndices) {
      this.revealClueAnno(ci);
      this.updateClueState(ci, false, 'solved', true);
    }
    this.updateAndSaveState();
    this.refocus();
    return true;
  }
  refocus() {
    if (this.gridInputWrapper.style.display != 'none') {
      this.gridInput.focus();
    }
  }
 
  submitSolution() {
    this.fireGa('submit', 'popup', false);
    this.overlayCall('submitConfirmation');
    this.fireGa('submit', 'submit_popup', true);
  }
  submitSolutionFinal() {
    // Capture the user's state BEFORE revealing the solution
    const userStateBeforeReveal = this.updateDisplayAndGetState(false);
    const userStateWithAnswers = userStateBeforeReveal + this.answersList.map(a => a.input.value).join(this.STATE_SEP);
    
    this.revealAll();
    if (this.revelCellsList &&
      Array.isArray(this.revelCellsList) &&
      this.revelCellsList.length > 0) {
      const grid = this.grid;
      this.revelCellsList.forEach(item => {
        let gridCell = grid[item.row][item.column];
        gridCell.cellRect.style.fill = '#FFFFFF';

        const userInput = gridCell.currLetter?.toUpperCase()?.trim();
        if (userInput && userInput !== '0' && userInput !== '') {
          gridCell.cellText.style.fill = this.colorScheme['errorEntry'];
        } else {
          gridCell.cellText.style.fill = this.colorScheme['correctEntry'];
        }
      });
    }
    this.titleElt = document.getElementById(this.prefix + '-clock-num-filled');
    this.titleElt.innerHTML = this.formatTime(this.timeTaken);
    clearInterval(this.stopTimeCounter);
    const timeblock = document.getElementById(this.prefix + '-timeBlock');
    if(timeblock){
      timeblock.classList.add('disabled');
      timeblock.style.display = 'none';
    }
    this.overlayCall = () => {};
    this.hardPause = () => {};
    this.submitButtonWrapper ? this.submitButtonWrapper.style.display = 'none' : '';
    this.svg? this.svg.style.pointerEvents = 'none': '';
    this.currClue ? this.currClue.style.display = 'none' : '';
    document.querySelectorAll('.til-grid-input.til-cell-text').forEach(input => input.readOnly = true); // This will disable the edit after game is submitted
    
    // Pass the user's state (before reveal) to the API call
    this.gameAPICall('submit', this.timeTaken, this.timePenalty, userStateWithAnswers);
    // Only remove gameEmbedder and call gameAPICall if not in solution view mode
    if (!this.viewSolution) {
      const gameEmbedder = document.getElementById('til-embedder');
      if (gameEmbedder && gameEmbedder.parentNode) {
        gameEmbedder.parentNode.removeChild(gameEmbedder);
      }
    }
    this.showCongrate = true;
  }
  formatTime(seconds) {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    let remainingSeconds = seconds % 60;
    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');
    remainingSeconds = String(remainingSeconds).padStart(2, '0');
    return `${hours}:${minutes}:${remainingSeconds}`;
  }
  
  createPuzzle() {
    this.init();
    this.createListeners();

    this.parseAndDisplayPrelude();
    this.parseGrid();
    this.markClueStartsUsingGrid();
    this.parseClueLists();

    this.processClueChildren();
    this.finalClueTweaks();
    this.setWordEndsAndHyphens();
    this.setUpGnav();
    if (!this.isMobile && !this.viewSolution) {
      this.displayClues();
    }
    this.displayGridBackground();
    this.displayGrid();
    this.recolourCells();
    this.restoreStateConfirmation();
    this.checkConsistency();

    this.bindListeners();
    if (this.customizer) {
      this.customizer(this);
    }
  }
  convertSeconds(seconds) {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    let remainingSeconds = seconds % 60;
    let hoursFormatted = ('0' + hours).slice(-2);
    let minutesFormatted = ('0' + minutes).slice(-2);
    let secondsFormatted = ('0' + remainingSeconds).slice(-2);
    let formattedTime = hoursFormatted + ':' + minutesFormatted + ':' + secondsFormatted;
    return formattedTime;
  }

  createTimer() {
    let prefix = this.prefix;
    let hiCounter = 0;
    function updateTimer(prefix, thisScope) {
      const timerElement = document.getElementById(prefix + '-clock-num-filled');
      timerElement
        ? (timerElement.textContent = thisScope.formatTime(thisScope.timeTaken))
        : ''; 
    }


    function startTimer(prefix, thisScope) {
      updateTimer(prefix, thisScope);
      if (thisScope.stopTimeCounter) {
        clearInterval(thisScope.stopTimeCounter);
      }
      thisScope.stopTimeCounter = setInterval(() => {
        if(!thisScope.pause){
          thisScope.timeTaken++;
          hiCounter++; 
          thisScope.updateAndSaveState();
          updateTimer(prefix, thisScope);
          if (hiCounter === thisScope.configSaveStateCounter) {
            thisScope.gameAPICall('saveStateCall', '', '');
            hiCounter = 0; 
          }
        }
      }, 1000);
    }
    startTimer(prefix, this);
  }
}

function tilXwordFromPuzNextNull(buffer, offset) {
  if (offset <= 0) {
    return buffer.length;
  }
  while (offset < buffer.length && buffer[offset] != 0) {
    offset++;
  }
  return offset;
}

function tilXwordFromPuz(buffer, fname = '', type, gameAPICall, viewSolution) {
  const dotPuzShort = function(buffer, offset) {
    return (buffer[offset + 1] << 8) + buffer[offset];
  };
  buffer = new Uint8Array(buffer);
  let offset = 0;

  const encoder = new TextEncoder('utf-8');
  const decoder = new TextDecoder('iso-8859-1');

  offset = 0x02;
  let fileMagic = encoder.encode('ACROSS&DOWN');
  for (let x of fileMagic) {
    if (buffer[offset++] != x) {
      return '';
    }
  }

  offset = 0x2c;
  const width = buffer[offset++];
  const height = buffer[offset++];

  const numCells = width * height;

  let tilXwordGrid = '';
  offset = 0x34;
  for (let i = 0; i < height; i++) {
    tilXwordGrid += '    ';
    for (let j = 0; j < width; j++) {
      let solution = decoder.decode(buffer.slice(offset, offset + 1));
      offset++;
      tilXwordGrid += solution;
    }
    tilXwordGrid += '\n';
  }
  const dummyContainer = document.createElement('div');
  dummyContainer.style.display = 'none';
  let dummyId = `puztil-${Math.random()
    .toString(36)
    .substring(2, 8)}`;
  dummyContainer.id = dummyId;
  document.body.appendChild(dummyContainer);
  const tempPuz = new TilXword(`
    tilXword-begin
    tilXword-width: ${width}
    tilXword-height: ${height}
    tilXword-id: ${dummyId}
    tilXword-grid:
  ${tilXwordGrid}
    tilXword-end
    `,
    dummyId,
    null,
    0,
    0,
    false,
    '',
    '',
    '',
    '',
    gameAPICall,
    '',
    '',
    '',
    type,
    '',
    true,
    '',
    viewSolution
  );
  dummyContainer.remove();
  offset += numCells;
  let nextNull = tilXwordFromPuzNextNull(buffer, offset);
  const title = decoder.decode(buffer.slice(offset, nextNull)).trim();
  offset = nextNull + 1;
  nextNull = tilXwordFromPuzNextNull(buffer, offset);
  offset = nextNull + 1;
  nextNull = tilXwordFromPuzNextNull(buffer, offset);
  offset = nextNull + 1;

  let orderedClueIndices = [];
  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      let gridCell = tempPuz.grid[i][j];
      if (!gridCell.isLight) {
        continue;
      }
      if (gridCell.startsAcrossClue) {
        orderedClueIndices.push('A' + gridCell.startsClueLabel);
      }
      if (gridCell.startsDownClue) {
        orderedClueIndices.push('D' + gridCell.startsClueLabel);
      }
    }
  }

  let acrossClues = '';
  let downClues = '';
  for (let ci of orderedClueIndices) {
    let theClue = tempPuz.clues[ci];
    nextNull = tilXwordFromPuzNextNull(buffer, offset);
    if (theClue.dir == 'A') {
      acrossClues +=
        '    ' +
        theClue.label +
        ' ' +
        decoder.decode(buffer.slice(offset, nextNull)) +
        '\n';
    } else {
      downClues +=
        '    ' +
        theClue.label +
        ' ' +
        decoder.decode(buffer.slice(offset, nextNull)) +
        '\n';
    }
    offset = nextNull + 1;
  }

  nextNull = tilXwordFromPuzNextNull(buffer, offset);
  let notes = decoder.decode(buffer.slice(offset, nextNull)).trim();
  offset = nextNull + 1;

  const gext = 'GEXT';
  while (offset + 8 + numCells <= buffer.length) {
    if (
      buffer[offset] == gext.charCodeAt(0) &&
      buffer[offset + 1] == gext.charCodeAt(1) &&
      buffer[offset + 2] == gext.charCodeAt(2) &&
      buffer[offset + 3] == gext.charCodeAt(3)
    ) {
      offset += 8;
      tilXwordGrid = '';
      for (let i = 0; i < height; i++) {
        tilXwordGrid += '    ';
        for (let j = 0; j < width; j++) {
          tilXwordGrid += tempPuz.grid[i][j].solution;
          if (buffer[offset++] & 0x80) {
            tilXwordGrid += '@';
          } else {
            tilXwordGrid += ' ';
          }
        }
        tilXwordGrid += '\n';
      }
      break;
    } else {
      offset++;
    }
  }
  tempPuz.destroy();

  if (!fname) {
    fname = 'unknown';
  }
  return `  tilXword-begin
    tilXword-width: ${width}
    tilXword-height: ${height}
    Crossword Option: ignore-enum-mismatch
    tilXword-maker:
      Converted by tilXword-from-puz.js from ${fname}
    tilXword-grid:
  ${tilXwordGrid}
    tilXword-across:
  ${acrossClues}
    tilXword-down:
  ${downClues}
    tilXword-end
    `;
}
class TilXwordEmbedder {
  constructor(params) {
    this.isMobile = params.isMobile; 
    this.isPrime = params.isPrime;
    this.isFrmapp = params.isFrmapp;
    this.overlayCall = params.overlayCall;
    this.puzzleAPI = params.puzzleAPI;
    this.gameAPICall = params.gameAPICall;
    this.showCongrate = params.showCongrate;
    this.todaysGame = params.todaysGame;
    this.hardPause = params.hardPause;
    this.type = params.type;
    this.apiConfigData = params.apiConfigData;
    this.fireGa = params.fireGa;
    this.viewSolution = params.viewSolution;
    this.embedder = document.getElementById('til-embedder');
    this.crossword = '';
    this.tilXwordOverrides = '';
    const finisher = this.showData.bind(this);
    const gamePuzFileUrl= this.puzzleAPI && this.puzzleAPI.url ? this.puzzleAPI.url : '';
    if(gamePuzFileUrl){
        fetch(gamePuzFileUrl,{mode: 'cors',},)
        .then(response => {
          if (!response.ok) {
            throw new Error( 'Error fetching [' + this.crossword + `], status = ${response.status}`, );
          }
          return response.arrayBuffer();
        })
        .then(result => {
          finisher(result);
        })
        .catch(error => {
          console.log('error>>', error);
          this.showMessage(error.name + ': ' + error.message);
        });
      }
      else{
        document.getElementById('til-embedder').innerHTML = '';
        this.overlayCall('errorPopUp');
      } 
  }

  showTilXword(specs) {
    let start = specs.indexOf('tilXword-begin');
    let end = specs.indexOf('tilXword-end');
    if (start < 0 || end < 0 || start >= end) {
      return false;
    }
    while (start > 0 && specs.charAt(start - 1) == ' ') {
      start--;
    }
    const tilXwordSpecs =
      specs.substring(start, end) + this.tilXwordOverrides + 'tilXword-end';
    try {
      const til = new TilXword(
        tilXwordSpecs, 
        'til-embedder', 
        null, 
        '',
        '',
        true,
        this.isMobile, 
        this.isPrime, 
        this.isFrmapp, 
        this.overlayCall,
        this.gameAPICall,
        this.puzzleAPI,
        this.todaysGame,
        this.hardPause,
        this.type,
        this.apiConfigData,
        false,
        this.fireGa,
        this.viewSolution
      );
      window.crossword = til;
    } catch (err) {
      console.log('err>>',err);
      this.showMessage(err);
      return false;
    }
    return true;
  }

  showPuz(buffer) {
    const tilXword = tilXwordFromPuz(buffer, this.crossword, this.type, this.gameAPICall, this.viewSolution);
    if (!tilXword) { return false; }
    return this.showTilXword(tilXword);
  }

  showData(data) {
    if (this.showPuz(data)) {
      return;
    }
    this.showMessage( 'Could not interpret the data in [' + this.crossword + '] as a crossword.',);
  }
  showMessage(msg) {
    console.log('error>>', msg);
    //document.getElementById('til-embedder').innerHTML = '';
    this.overlayCall('errorPopUp');
  }
}

export default function initGame(params) {
  try {
    const tilXwordEmbedder = new TilXwordEmbedder(params);
  } catch (err) {
    document.getElementById('til-embedder').innerHTML = err;
  }
}
